/* eslint-disable */
const insDataStub = [
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "HKMG",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Antwerp Enterprises,LLC",
    "cica_primarycontactfirstname": "Ardith",
    "id": "6341ee0a-9b0d-11e8-97af-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163730637",
    "cica_calltype": "Business",
    "cica_businessaddress": "154 Bay 35th St",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ardith",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Warnock",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/16/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Warnock"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "HKMG",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Mackoi Entertainment",
    "cica_primarycontactfirstname": "Pearle",
    "id": "6341f973-9b0d-11e8-bc03-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163730637",
    "cica_calltype": "Business",
    "cica_businessaddress": "105 Swan St",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Pearle",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "DRIVER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Maxim",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/19/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Maxim"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "HKMG",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Antwerp Enterprises,LLC",
    "cica_primarycontactfirstname": "Ardith",
    "id": "6342030f-9b0d-11e8-adf7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163730637",
    "cica_calltype": "Business",
    "cica_businessaddress": "154 Bay 35th St",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ardith",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Warnock",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/19/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Warnock"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "D.",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "HKMG",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Mackoi Entertainment",
    "cica_primarycontactfirstname": "Pearle",
    "id": "63420fe1-9b0d-11e8-9e2a-34363bd2a970",
    "cica_primarycontactmiddlename": "D.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163730637",
    "cica_calltype": "Business",
    "cica_businessaddress": "105 Swan St",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Pearle",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "DRIVER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "3243454843",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Maxim",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/4/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Maxim"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "HKMG",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Val Motor",
    "cica_primarycontactfirstname": "Christopher",
    "id": "63421b8f-9b0d-11e8-a3bf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163730637",
    "cica_calltype": "Business",
    "cica_businessaddress": "35 Seacoast Ter Apt 3W",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Christopher",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "CONSTR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "3243454844",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60088",
    "cica_primarycontactlastname": "Aumick",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/8/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Aumick"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "HKMG",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Aaron's",
    "cica_primarycontactfirstname": "Reginia",
    "id": "6342251e-9b0d-11e8-ae3c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163786693",
    "cica_calltype": "Business",
    "cica_businessaddress": "14 Metropolitan Oval Apt Tc",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Reginia",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "PRODUCTION",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "3243454845",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60089",
    "cica_primarycontactlastname": "Mendell",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/17/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mendell"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "HKMG",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Smith Tires",
    "cica_primarycontactfirstname": "Jaimee",
    "id": "63422e61-9b0d-11e8-a309-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163786693",
    "cica_calltype": "Business",
    "cica_businessaddress": "2531 38th St Apt 9",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jaimee",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "COACH",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "3243454846",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60090",
    "cica_primarycontactlastname": "Naugle",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/11/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Naugle"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "H.",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Rico Motorsports",
    "cica_primarycontactfirstname": "Na",
    "id": "634237c2-9b0d-11e8-98f0-34363bd2a970",
    "cica_primarycontactmiddlename": "H.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859687063",
    "cica_calltype": "Business",
    "cica_businessaddress": "9138 75th St",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Na",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "MACH OPER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent13",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "3243454847",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60091",
    "cica_primarycontactlastname": "Conaway",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/23/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Conaway"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SUNOCO STA",
    "cica_primarycontactfirstname": "Despina",
    "id": "6342412b-9b0d-11e8-adc5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859687063",
    "cica_calltype": "Business",
    "cica_businessaddress": "17014 130th Ave Apt 7G",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Despina",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "DOM ENGNR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent14",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "3243454848",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60092",
    "cica_primarycontactlastname": "Mowrer",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/21/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mowrer"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "OLEAN WHOLESALE",
    "cica_primarycontactfirstname": "Todd",
    "id": "63424a78-9b0d-11e8-9fc5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859687063",
    "cica_calltype": "Business",
    "cica_businessaddress": "189 Quincy St Unit 1",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Todd",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "3243454849",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60093",
    "cica_primarycontactlastname": "Timm",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/27/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Timm"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ALLEGANY CO SPCA",
    "cica_primarycontactfirstname": "Adrienne",
    "id": "634253b0-9b0d-11e8-918e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859732921",
    "cica_calltype": "Business",
    "cica_businessaddress": "15706 86th St",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Adrienne",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "STUDENT",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60094",
    "cica_primarycontactlastname": "Magner",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/3/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Magner"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "T.",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "TOM DUNN ATTORNEY",
    "cica_primarycontactfirstname": "Magdalena",
    "id": "63425d11-9b0d-11e8-9260-34363bd2a970",
    "cica_primarycontactmiddlename": "T.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859732921",
    "cica_calltype": "Business",
    "cica_businessaddress": "114 Holbrook Rd",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Magdalena",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OWNER",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60095",
    "cica_primarycontactlastname": "Troxler",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/4/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Troxler"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "INGALLS CONSULTANT",
    "cica_primarycontactfirstname": "Trisha",
    "id": "63426773-9b0d-11e8-a5d9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859732921",
    "cica_calltype": "Business",
    "cica_businessaddress": "36 Johnsontown Rd",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Trisha",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "BUS DRVR",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60096",
    "cica_primarycontactlastname": "Blinn",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/26/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Blinn"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "OLEAN OPEN MRI",
    "cica_primarycontactfirstname": "Fletcher",
    "id": "63427082-9b0d-11e8-a4ef-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "5859732921",
    "cica_calltype": "Business",
    "cica_businessaddress": "3801 Hudson Manor Ter Apt 2L",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Fletcher",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NURSE",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "8403938234",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60097",
    "cica_primarycontactlastname": "Backlund",
    "cica_residentialphone": "8474849504",
    "cica_fdif": "4/6/2016",
    "cica_residentialaddress": "154 Bay 35th St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Backlund"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "M",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "STROEHMANN",
    "cica_primarycontactfirstname": "Cristy",
    "id": "63427980-9b0d-11e8-8077-34363bd2a970",
    "cica_primarycontactmiddlename": "M",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "5859683923",
    "cica_calltype": "Business",
    "cica_businessaddress": "39 Amethyst St",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Credit",
    "cica_customerfirstname": "Cristy",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OFFC MGR",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "8403938234",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60098",
    "cica_primarycontactlastname": "Ohman",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/13/2017",
    "cica_residentialaddress": "105 Swan St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ohman"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "AOIB",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "CARRIER",
    "cica_primarycontactfirstname": "Jazmin",
    "id": "6342825e-9b0d-11e8-bb47-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "5859683923",
    "cica_calltype": "Business",
    "cica_businessaddress": "15 Fort Pl",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Credit",
    "cica_customerfirstname": "Jazmin",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "STUDENT",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "8403938234",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60099",
    "cica_primarycontactlastname": "Shamblin",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/10/2016",
    "cica_residentialaddress": "154 Bay 35th St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shamblin"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "DRESSER RAND",
    "cica_primarycontactfirstname": "Lillie",
    "id": "63428b3a-9b0d-11e8-b373-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "5855678090",
    "cica_calltype": "Business",
    "cica_businessaddress": "1554 Spirt Rd",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Credit",
    "cica_customerfirstname": "Lillie",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NURSE",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "8403938234",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60100",
    "cica_primarycontactlastname": "Quach",
    "cica_residentialphone": "7383939482",
    "cica_fdif": "2/27/2017",
    "cica_residentialaddress": "105 Swan St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Quach"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "Adams Reading",
    "cica_primarycontactfirstname": "Ema",
    "id": "6342944a-9b0d-11e8-9309-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "5855678090",
    "cica_calltype": "Business",
    "cica_businessaddress": "69 Birch Rd",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Credit",
    "cica_customerfirstname": "Ema",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "8403938234",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60101",
    "cica_primarycontactlastname": "Steyer",
    "cica_residentialphone": "7383939482",
    "cica_fdif": "4/1/2018",
    "cica_residentialaddress": "35 Seacoast Ter Apt 3W",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Steyer"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "Saw House",
    "cica_primarycontactfirstname": "Windy",
    "id": "63429d5c-9b0d-11e8-8ec7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "5852980871",
    "cica_calltype": "Business",
    "cica_businessaddress": "85 Marine Way",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Credit",
    "cica_customerfirstname": "Windy",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CHILD",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "8403938234",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60102",
    "cica_primarycontactlastname": "Huffstetler",
    "cica_residentialphone": "7383939482",
    "cica_fdif": "2/18/2018",
    "cica_residentialaddress": "14 Metropolitan Oval Apt Tc",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Huffstetler"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ADAMS WELL DRILLING",
    "cica_primarycontactfirstname": "Roland",
    "id": "6342a661-9b0d-11e8-ab08-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855934483",
    "cica_calltype": "Business",
    "cica_businessaddress": "105 Lamport Blvd",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Credit",
    "cica_customerfirstname": "Roland",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "WAITRESS",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60103",
    "cica_primarycontactlastname": "Thibeaux",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/10/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Thibeaux"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "CUBA RUSHFORD",
    "cica_primarycontactfirstname": "Ismael",
    "id": "6342af54-9b0d-11e8-a795-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855934483",
    "cica_calltype": "Business",
    "cica_businessaddress": "37 Barclay Cir",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Credit",
    "cica_customerfirstname": "Ismael",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "MACHINIST",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60104",
    "cica_primarycontactlastname": "Pigeon",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/5/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pigeon"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ELM ST ACADEMY",
    "cica_primarycontactfirstname": "Berniece",
    "id": "6342b81c-9b0d-11e8-91d9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855936000",
    "cica_calltype": "Business",
    "cica_businessaddress": "118 Bay Ter",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Berniece",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "RET USAF",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60105",
    "cica_primarycontactlastname": "Vandusen",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/1/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vandusen"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ALLEGANCY CENTER",
    "cica_primarycontactfirstname": "Shea",
    "id": "6342c1f5-9b0d-11e8-aaf6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855934791",
    "cica_calltype": "Business",
    "cica_businessaddress": "42 E Augusta Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shea",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "SECTY",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60106",
    "cica_primarycontactlastname": "Withers",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/5/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Withers"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYS DOT",
    "cica_primarycontactfirstname": "Sherise",
    "id": "6342caf0-9b0d-11e8-ac3c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855936000",
    "cica_calltype": "Business",
    "cica_businessaddress": "42 E Augusta Ave",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sherise",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "MECH",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60107",
    "cica_primarycontactlastname": "Zamorano",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/7/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Zamorano"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "HEALTH DEPARTMENT",
    "cica_primarycontactfirstname": "Delfina",
    "id": "6342d3c5-9b0d-11e8-8018-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855936000",
    "cica_calltype": "Business",
    "cica_businessaddress": "331 Powell St",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delfina",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "OWNER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60108",
    "cica_primarycontactlastname": "Leedy",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/27/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Leedy"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "DILL PICKLE",
    "cica_primarycontactfirstname": "Vernell",
    "id": "6342dca3-9b0d-11e8-9095-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855936519",
    "cica_calltype": "Business",
    "cica_businessaddress": "74 W Castor Pl",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vernell",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "TRUCK LOAD",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60109",
    "cica_primarycontactlastname": "Toussaint",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/11/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Toussaint"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "HYDRAMEC INC",
    "cica_primarycontactfirstname": "Tara",
    "id": "6342e58a-9b0d-11e8-b7c2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855936519",
    "cica_calltype": "Business",
    "cica_businessaddress": "74 Beechwood Pl",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tara",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "DELIVERY",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60110",
    "cica_primarycontactlastname": "Person",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/18/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Person"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PRESTO LITE",
    "cica_primarycontactfirstname": "Naoma",
    "id": "6342ee54-9b0d-11e8-9511-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6073563225",
    "cica_calltype": "Business",
    "cica_businessaddress": "PO Box 146",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Naoma",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "SUPERVISOR",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "60111",
    "cica_primarycontactlastname": "Trottier",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/9/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Trottier"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "WOODLAND PROPERTIES",
    "cica_primarycontactfirstname": "Jacinda",
    "id": "6342f7a1-9b0d-11e8-86d7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5853652071",
    "cica_calltype": "Business",
    "cica_businessaddress": "39 N 9th Ave",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jacinda",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "SELF EMPLO",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60112",
    "cica_primarycontactlastname": "Broady",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/19/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Broady"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BITV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "I-86 REPAIR AND TOWING",
    "cica_primarycontactfirstname": "Lavern",
    "id": "6343020f-9b0d-11e8-9883-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5853652071",
    "cica_calltype": "Business",
    "cica_businessaddress": "39 N 9th Ave",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lavern",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "DM5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "GRILL MGR",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60113",
    "cica_primarycontactlastname": "Gantt",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/18/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gantt"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "H.",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AYVA",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "RED BARN COUNTRY MALL",
    "cica_primarycontactfirstname": "Marcelene",
    "id": "63430b1e-9b0d-11e8-aa50-34363bd2a970",
    "cica_primarycontactmiddlename": "H.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5854372526",
    "cica_calltype": "Business",
    "cica_businessaddress": "100 Erskine Pl Apt 13A",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marcelene",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CNA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60114",
    "cica_primarycontactlastname": "Kowalski",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/17/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kowalski",
    "cica_issubmitted": true,
    "cica_isexpired": true
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "AYVA",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FRIENDSHIP DAIRIES",
    "cica_primarycontactfirstname": "Valrie",
    "id": "634313f3-9b0d-11e8-b7b5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859682884",
    "cica_calltype": "Business",
    "cica_businessaddress": "1783 Undercliff Ave",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Valrie",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CASHIER",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60115",
    "cica_primarycontactlastname": "Shick",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/12/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shick",
    "cica_issubmitted": true,
    "cica_isexpired": false
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "Y.",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "AYVA",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ARHAUS FURNITURE",
    "cica_primarycontactfirstname": "Miss",
    "id": "63431cb5-9b0d-11e8-b949-34363bd2a970",
    "cica_primarycontactmiddlename": "Y.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163534708",
    "cica_calltype": "Business",
    "cica_businessaddress": "586 Beck St Fl 2",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Miss",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "HWY REPR C",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60116",
    "cica_primarycontactlastname": "Aderholt",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/4/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Aderholt",
    "cica_issubmitted": false,
    "cica_isexpired": false
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "AYVA",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "POLYMER CONVERSION",
    "cica_primarycontactfirstname": "Simona",
    "id": "6343257d-9b0d-11e8-a5eb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5855934194",
    "cica_calltype": "Business",
    "cica_businessaddress": "222 Bedford Park Blvd Apt 6F",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Simona",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60117",
    "cica_primarycontactlastname": "Sia",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/6/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sia"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AYVA",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "WOODYS AFFORDABLE HOME IMP",
    "cica_primarycontactfirstname": "Mitchel",
    "id": "63432e3d-9b0d-11e8-a19b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7164922970",
    "cica_calltype": "Business",
    "cica_businessaddress": "1224 Prospect Ave Apt 6H",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mitchel",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CHILD",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60118",
    "cica_primarycontactlastname": "Hooton",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/28/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hooton"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "AYVA",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "TEXAS HOT",
    "cica_primarycontactfirstname": "Ryann",
    "id": "63433707-9b0d-11e8-b43b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7189916545",
    "cica_calltype": "Business",
    "cica_businessaddress": "1172 E Tremont Ave Apt 4D",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ryann",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "STUDENT",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60119",
    "cica_primarycontactlastname": "Staple",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/8/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Staple"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "E.",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "AYVA",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ST JAMES MERCY HEALTH",
    "cica_primarycontactfirstname": "Thersa",
    "id": "63433fdc-9b0d-11e8-a7a4-34363bd2a970",
    "cica_primarycontactmiddlename": "E.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163727695",
    "cica_calltype": "Business",
    "cica_businessaddress": "145 Lexington Ave",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Thersa",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "STUDENT",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60120",
    "cica_primarycontactlastname": "Heffley",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/16/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Heffley"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BIUV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "LOWES",
    "cica_primarycontactfirstname": "Annett",
    "id": "634348a6-9b0d-11e8-b94c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163737099",
    "cica_calltype": "Business",
    "cica_businessaddress": "145 Lexington Ave",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Annett",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent14",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60121",
    "cica_primarycontactlastname": "Lettieri",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/5/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lettieri"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BIUV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "DO BWAY DEPOT",
    "cica_primarycontactfirstname": "Kristeen",
    "id": "63435166-9b0d-11e8-b821-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163727695",
    "cica_calltype": "Business",
    "cica_businessaddress": "1945 Vyse Ave Apt 6E",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kristeen",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CHILD",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60122",
    "cica_primarycontactlastname": "Woolwine",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/26/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Woolwine"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BIUV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Finger Lakes S PC A of Central",
    "cica_primarycontactfirstname": "Gay",
    "id": "63435a1c-9b0d-11e8-897c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163727695",
    "cica_calltype": "Business",
    "cica_businessaddress": "854 Fairmount Pl",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gay",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60123",
    "cica_primarycontactlastname": "Kushner",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/5/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kushner"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BIUV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Twisted Apple Stained Glass",
    "cica_primarycontactfirstname": "Marcus",
    "id": "634362f0-9b0d-11e8-8d9c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7165322408",
    "cica_calltype": "Business",
    "cica_businessaddress": "2340 Broadway Apt 2B",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marcus",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "MUSIC TCHR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Marco",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/15/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Marco"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BIUV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Neudeck Electric",
    "cica_primarycontactfirstname": "Madge",
    "id": "63436bb0-9b0d-11e8-8a92-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7165329459",
    "cica_calltype": "Business",
    "cica_businessaddress": "1936 E Tremont Ave Apt 1B",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Madge",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "MECHANIC",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Maxfield",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/12/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Maxfield"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BIUV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Women's Health Of Western NY",
    "cica_primarycontactfirstname": "Lora",
    "id": "63437478-9b0d-11e8-a662-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3153648144",
    "cica_calltype": "Business",
    "cica_businessaddress": "78 Springville Rd",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lora",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "MECH",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Picha",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/22/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Picha"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIUV",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Moss Apartments",
    "cica_primarycontactfirstname": "Donnell",
    "id": "63437e02-9b0d-11e8-b608-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6075639105",
    "cica_calltype": "Business",
    "cica_businessaddress": "78 Springville Rd",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Donnell",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "HMMAKER",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent20",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Wenthold",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/15/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wenthold"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Verns Place",
    "cica_primarycontactfirstname": "Claudio",
    "id": "634386e1-9b0d-11e8-82d6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6075639105",
    "cica_calltype": "Business",
    "cica_businessaddress": "299 Monroe Dr",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Claudio",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "HOUSEWIFE",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60088",
    "cica_primarycontactlastname": "Mattoon",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/24/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mattoon"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "E John Gavras Center",
    "cica_primarycontactfirstname": "Gregg",
    "id": "634390f3-9b0d-11e8-b6ec-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6077648600",
    "cica_calltype": "Business",
    "cica_businessaddress": "299 Monroe Dr",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gregg",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CARPENTER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60089",
    "cica_primarycontactlastname": "Coldwell",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/23/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Coldwell"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Vaidina Dr",
    "cica_primarycontactfirstname": "Theresia",
    "id": "63439a68-9b0d-11e8-9022-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6076749234",
    "cica_calltype": "Business",
    "cica_businessaddress": "54 Newtown Rd",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Theresia",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWNR",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60090",
    "cica_primarycontactlastname": "Kirksey",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/18/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kirksey"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Finger Lakes Tire",
    "cica_primarycontactfirstname": "Maragaret",
    "id": "6343a363-9b0d-11e8-b129-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7168600153",
    "cica_calltype": "Business",
    "cica_businessaddress": "355 Randall Rd",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maragaret",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OWNR",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60091",
    "cica_primarycontactlastname": "Brockett",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/15/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Brockett"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Finger Lakes Drive In",
    "cica_primarycontactfirstname": "Marlena",
    "id": "6343ae73-9b0d-11e8-8f89-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7164256198",
    "cica_calltype": "Business",
    "cica_businessaddress": "131 W End Ave",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marlena",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "SECTRY",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60092",
    "cica_primarycontactlastname": "Mclendon",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/2/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mclendon"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "State University of New York",
    "cica_primarycontactfirstname": "Betty",
    "id": "6343ba7a-9b0d-11e8-94fa-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7165322443",
    "cica_calltype": "Business",
    "cica_businessaddress": "28 Middle Line Hwy",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Betty",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "HW",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60093",
    "cica_primarycontactlastname": "Meadows",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Meadows"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Teasers Hair & Nail Studio",
    "cica_primarycontactfirstname": "Eloy",
    "id": "6343c7fd-9b0d-11e8-9314-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7169883318",
    "cica_calltype": "Business",
    "cica_businessaddress": "534 N Magee St",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Eloy",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "DESIGN ENG",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60094",
    "cica_primarycontactlastname": "Murr",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/20/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Murr"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Stonehouse Automotives",
    "cica_primarycontactfirstname": "Ami",
    "id": "6343d9cc-9b0d-11e8-b199-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7169883318",
    "cica_calltype": "Business",
    "cica_businessaddress": "534 N Magee St",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ami",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "HW",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60095",
    "cica_primarycontactlastname": "Birchfield",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/5/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Birchfield"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Alan L Spears",
    "cica_primarycontactfirstname": "Freda",
    "id": "6343e4f0-9b0d-11e8-8c57-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152532226",
    "cica_calltype": "Business",
    "cica_businessaddress": "24 Fairway Ave",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Freda",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "RET",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60096",
    "cica_primarycontactlastname": "Ganey",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/3/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ganey"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Dublin Quality Structures",
    "cica_primarycontactfirstname": "Reuben",
    "id": "6343ef40-9b0d-11e8-87b9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152532226",
    "cica_calltype": "Business",
    "cica_businessaddress": "PO Box 1941",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Reuben",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CO OWNER",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60097",
    "cica_primarycontactlastname": "Carlson",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/17/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Carlson"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BGOW",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "JMJ Auto Sales",
    "cica_primarycontactfirstname": "Angella",
    "id": "6343f985-9b0d-11e8-9b27-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6079675123",
    "cica_calltype": "Business",
    "cica_businessaddress": "PO Box 1941",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Angella",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "SC5",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "43-3011 04",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent21",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60098",
    "cica_primarycontactlastname": "Reichert",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/8/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Reichert"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Rhonda Delaney",
    "cica_primarycontactfirstname": "Jesenia",
    "id": "634403f3-9b0d-11e8-b011-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6079675123",
    "cica_calltype": "Business",
    "cica_businessaddress": "32 Coxs Curve Rd",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jesenia",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "MILLWRIGHT",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60099",
    "cica_primarycontactlastname": "Levens",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/12/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Levens"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Gregory & Picciano Electric Co",
    "cica_primarycontactfirstname": "Hyman",
    "id": "63440d5e-9b0d-11e8-bab5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6072054779",
    "cica_calltype": "Business",
    "cica_businessaddress": "10802 220th St",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hyman",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "STUDENT",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60100",
    "cica_primarycontactlastname": "Schuelke",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/5/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schuelke"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Taylor Law Firm",
    "cica_primarycontactfirstname": "Melodee",
    "id": "6344164f-9b0d-11e8-b10d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6076569634",
    "cica_calltype": "Business",
    "cica_businessaddress": "33 Narragansett Ave",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Melodee",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60101",
    "cica_primarycontactlastname": "Mcclinton",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/8/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcclinton"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Va Bainbridge Clinic",
    "cica_primarycontactfirstname": "Louanne",
    "id": "63441f38-9b0d-11e8-b8dc-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3155939804",
    "cica_calltype": "Business",
    "cica_businessaddress": "123 State St Fl 2",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Louanne",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "DEALER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60102",
    "cica_primarycontactlastname": "Whitford",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/17/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Whitford"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "X.",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Jeanne Shear",
    "cica_primarycontactfirstname": "Cammy",
    "id": "63442817-9b0d-11e8-9af0-34363bd2a970",
    "cica_primarycontactmiddlename": "X.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3155939806",
    "cica_calltype": "Business",
    "cica_businessaddress": "3735 Old Crompond Rd",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cammy",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "41-2011 01",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60103",
    "cica_primarycontactlastname": "Grange",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/10/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Grange"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "Reblade Manufacturing Co",
    "cica_primarycontactfirstname": "Leonila",
    "id": "634430eb-9b0d-11e8-8047-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6073739752",
    "cica_calltype": "Business",
    "cica_businessaddress": "85 S Regent St",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Leonila",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "CONSTRUCTI",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60104",
    "cica_primarycontactlastname": "Demas",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/2/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Demas"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SWIFTYS",
    "cica_primarycontactfirstname": "Vernie",
    "id": "634439c7-9b0d-11e8-884f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6072263269",
    "cica_calltype": "Business",
    "cica_businessaddress": "85 S Regent St",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vernie",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "BUS DRIVER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60105",
    "cica_primarycontactlastname": "Dick",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/16/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dick"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "S F",
    "cica_primarycontactfirstname": "Cleotilde",
    "id": "63444287-9b0d-11e8-830d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6073363307",
    "cica_calltype": "Business",
    "cica_businessaddress": "342 Marietta Ave",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cleotilde",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "MANAGER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60106",
    "cica_primarycontactlastname": "Quesnel",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/22/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Quesnel"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BROOKFIELD",
    "cica_primarycontactfirstname": "Jen",
    "id": "63444b47-9b0d-11e8-8076-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6073363307",
    "cica_calltype": "Business",
    "cica_businessaddress": "342 Marietta Ave",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jen",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CARPENTER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60107",
    "cica_primarycontactlastname": "Olden",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/27/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Olden"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "EMERLING FORD",
    "cica_primarycontactfirstname": "Cris",
    "id": "63445407-9b0d-11e8-be51-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7169683231",
    "cica_calltype": "Business",
    "cica_businessaddress": "2183 Mohansic Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cris",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "RETAIL PHA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60108",
    "cica_primarycontactlastname": "Rehkop",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/18/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rehkop"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "LARS AUTO SHOP",
    "cica_primarycontactfirstname": "Delphia",
    "id": "63445cc7-9b0d-11e8-a44c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7162703770",
    "cica_calltype": "Business",
    "cica_businessaddress": "2183 Mohansic Ave",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delphia",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "ELEC CNTRC",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60109",
    "cica_primarycontactlastname": "Tomlin",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/4/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tomlin"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "DAVID BURKE CONST",
    "cica_primarycontactfirstname": "Gita",
    "id": "63446587-9b0d-11e8-9b8e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152465889",
    "cica_calltype": "Business",
    "cica_businessaddress": "30 Fieldstone Dr Apt 26A",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gita",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "39-1021 02",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60110",
    "cica_primarycontactlastname": "Nisbett",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nisbett"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BALCOM FLATS FARMS",
    "cica_primarycontactfirstname": "Nancie",
    "id": "63446e47-9b0d-11e8-8e2d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152539736",
    "cica_calltype": "Business",
    "cica_businessaddress": "30 Fieldstone Dr Apt 26A",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nancie",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OUT PATRIA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60111",
    "cica_primarycontactlastname": "Tetrault",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/27/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tetrault"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIWD",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BALCOM FLATS FARMS",
    "cica_primarycontactfirstname": "Dirk",
    "id": "63447711-9b0d-11e8-8620-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6073168210",
    "cica_calltype": "Business",
    "cica_businessaddress": "9 Winnetou Rd",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dirk",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "LABORER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "DM6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60112",
    "cica_primarycontactlastname": "Jeppesen",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/14/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jeppesen"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BCS",
    "cica_primarycontactfirstname": "Shizuko",
    "id": "63447fc7-9b0d-11e8-be93-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163731628",
    "cica_calltype": "Business",
    "cica_businessaddress": "19 Manitou Trl",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shizuko",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "BOOKEEPER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60113",
    "cica_primarycontactlastname": "Junkin",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/9/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Junkin"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "JERRIES INN",
    "cica_primarycontactfirstname": "Vernia",
    "id": "634488b8-9b0d-11e8-8fbd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6072344046",
    "cica_calltype": "Business",
    "cica_businessaddress": "19 Manitou Trl",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vernia",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "SUPERVISOR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60114",
    "cica_primarycontactlastname": "Mitchell",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/25/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mitchell"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "UNISON G E",
    "cica_primarycontactfirstname": "Ming",
    "id": "634491ab-9b0d-11e8-9889-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6076746899",
    "cica_calltype": "Business",
    "cica_businessaddress": "7 Gedney Ter",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ming",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "PROVIDER",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60115",
    "cica_primarycontactlastname": "Heron",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/8/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Heron"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "STEPHEN JOYCE",
    "cica_primarycontactfirstname": "Velvet",
    "id": "63449a6b-9b0d-11e8-83c8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7169456089",
    "cica_calltype": "Business",
    "cica_businessaddress": "7 Gedney Ter",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Velvet",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "MANAGER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60116",
    "cica_primarycontactlastname": "Babbitt",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/22/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Babbitt"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYS CORRECTION",
    "cica_primarycontactfirstname": "Adrianne",
    "id": "6344a335-9b0d-11e8-b178-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163721171",
    "cica_calltype": "Business",
    "cica_businessaddress": "21 Tomahawk Dr",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Adrianne",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OWNER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60117",
    "cica_primarycontactlastname": "Iskra",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/28/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Iskra"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "T.",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "CURVES",
    "cica_primarycontactfirstname": "Francie",
    "id": "6344ac14-9b0d-11e8-a19a-34363bd2a970",
    "cica_primarycontactmiddlename": "T.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163721171",
    "cica_calltype": "Business",
    "cica_businessaddress": "21 Tomahawk Dr",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Francie",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "PO",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60118",
    "cica_primarycontactlastname": "Cranford",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cranford"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "RECOVERY AT NRG ASSET",
    "cica_primarycontactfirstname": "Athena",
    "id": "6344b4e6-9b0d-11e8-b9fd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "5859330569",
    "cica_calltype": "Business",
    "cica_businessaddress": "31 Centre St",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Athena",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "FIREFIGHTE",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60119",
    "cica_primarycontactlastname": "Brazeau",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/1/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Brazeau"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NEW PROCESS GEAR",
    "cica_primarycontactfirstname": "Trudie",
    "id": "6344bdb3-9b0d-11e8-a3ec-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7163586213",
    "cica_calltype": "Business",
    "cica_businessaddress": "132 Page Ave",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Trudie",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "PARAMEDIC",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60120",
    "cica_primarycontactlastname": "Montoro",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/14/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Montoro"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "EMILY BENTIVEGNA",
    "cica_primarycontactfirstname": "Inga",
    "id": "6344c685-9b0d-11e8-ae64-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7164998020",
    "cica_calltype": "Business",
    "cica_businessaddress": "132 Page Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Inga",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OWNER",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60121",
    "cica_primarycontactlastname": "Jakes",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/4/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jakes"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "E.",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "UNIVERSITY OF BUFFALO",
    "cica_primarycontactfirstname": "Eldridge",
    "id": "6344cf63-9b0d-11e8-912e-34363bd2a970",
    "cica_primarycontactmiddlename": "E.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7169453756",
    "cica_calltype": "Business",
    "cica_businessaddress": "132 Page Ave",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Eldridge",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "SALES MANA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60122",
    "cica_primarycontactlastname": "Carner",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/23/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Carner"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SENECA ALLEGANY CASINO",
    "cica_primarycontactfirstname": "Rhona",
    "id": "6344d838-9b0d-11e8-943a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7169453756",
    "cica_calltype": "Business",
    "cica_businessaddress": "40 Huber Pl",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rhona",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "PO",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60123",
    "cica_primarycontactlastname": "Pogue",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/10/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pogue"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BONTON",
    "cica_primarycontactfirstname": "Lessie",
    "id": "6344e0f5-9b0d-11e8-867c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7169453756",
    "cica_calltype": "Business",
    "cica_businessaddress": "40 Huber Pl",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lessie",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "FIREMAN",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Vandorn",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/27/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vandorn"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BACH AND CO",
    "cica_primarycontactfirstname": "Marlin",
    "id": "6344e9c2-9b0d-11e8-9724-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152538163",
    "cica_calltype": "Business",
    "cica_businessaddress": "40 Huber Pl",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marlin",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "HOUSEWIFE",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Crafts",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/21/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Crafts"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "AUBURN SCHOOL",
    "cica_primarycontactfirstname": "Mark",
    "id": "6344f297-9b0d-11e8-a184-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152538163",
    "cica_calltype": "Business",
    "cica_businessaddress": "527 Riverdale Ave",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mark",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "BUS OPER",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Jeffcoat",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/5/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jeffcoat"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "GARROPYS REST",
    "cica_primarycontactfirstname": "Reba",
    "id": "6344fb57-9b0d-11e8-aaff-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152535017",
    "cica_calltype": "Business",
    "cica_businessaddress": "16 Terrace Pl",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Reba",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "HWY REPAIR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Franson",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/25/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Franson"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "W.",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BFLQ",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "RITE AID",
    "cica_primarycontactfirstname": "Soon",
    "id": "63450428-9b0d-11e8-8617-34363bd2a970",
    "cica_primarycontactmiddlename": "W.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152538692",
    "cica_calltype": "Business",
    "cica_businessaddress": "16 Terrace Pl",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Soon",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "POLC OFFCR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent15",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60088",
    "cica_primarycontactlastname": "Stoddart",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/17/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stoddart"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ON BANK",
    "cica_primarycontactfirstname": "Rozanne",
    "id": "63450cd7-9b0d-11e8-823e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152551819",
    "cica_calltype": "Business",
    "cica_businessaddress": "16 Terrace Pl",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rozanne",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "SUPVR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60089",
    "cica_primarycontactlastname": "Redman",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/16/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Redman"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "A-TEC ELECTRIC",
    "cica_primarycontactfirstname": "Jeri",
    "id": "6345159e-9b0d-11e8-bcc7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152551819",
    "cica_calltype": "Business",
    "cica_businessaddress": "30 Westwood Ave",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jeri",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "AGENT",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60090",
    "cica_primarycontactlastname": "Cost",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/20/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cost"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ALARM TECH",
    "cica_primarycontactfirstname": "Sharyl",
    "id": "63451e73-9b0d-11e8-ba2c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152551680",
    "cica_calltype": "Business",
    "cica_businessaddress": "30 Westwood Ave",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sharyl",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CHILD",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60091",
    "cica_primarycontactlastname": "Cotten",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/19/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cotten"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "AUBURN MEMORIAL",
    "cica_primarycontactfirstname": "Marcus",
    "id": "6345272b-9b0d-11e8-998b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152551680",
    "cica_calltype": "Business",
    "cica_businessaddress": "252 Pembrook Dr",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marcus",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "POLICE OFF",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60092",
    "cica_primarycontactlastname": "Dominick",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/19/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dominick"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "US POST OFFICE",
    "cica_primarycontactfirstname": "Pamela",
    "id": "63452ff3-9b0d-11e8-ab5c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3157293157",
    "cica_calltype": "Business",
    "cica_businessaddress": "40 Touissant Ave",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Pamela",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "PARTS COUN",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60093",
    "cica_primarycontactlastname": "Hout",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/16/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hout"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "UPSTATE HOSPITAL",
    "cica_primarycontactfirstname": "Rochelle",
    "id": "63453921-9b0d-11e8-81fe-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3156773269",
    "cica_calltype": "Business",
    "cica_businessaddress": "142 Lincoln Ave",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rochelle",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CHIDL",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60094",
    "cica_primarycontactlastname": "Dubrey",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/24/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dubrey"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "RICHARD MYER INC",
    "cica_primarycontactfirstname": "Riva",
    "id": "634541eb-9b0d-11e8-ae6a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3152775207",
    "cica_calltype": "Business",
    "cica_businessaddress": "126 N Route 303 Unit 2",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Riva",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NURSE ASST",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60095",
    "cica_primarycontactlastname": "Runkle",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/2/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Runkle"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FRENCHS GARAGE",
    "cica_primarycontactfirstname": "Catheryn",
    "id": "63454aa1-9b0d-11e8-8118-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6075638826",
    "cica_calltype": "Business",
    "cica_businessaddress": "11 Lenore Ave",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Catheryn",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "33-2011 05",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60096",
    "cica_primarycontactlastname": "Primm",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/18/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Primm"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BOCES",
    "cica_primarycontactfirstname": "Shena",
    "id": "6345534c-9b0d-11e8-a5fb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6075638826",
    "cica_calltype": "Business",
    "cica_businessaddress": "11 Lenore Ave",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shena",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CHILD",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60097",
    "cica_primarycontactlastname": "Spengler",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/24/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Spengler"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NAZZITTOS WINES & LIQUORS",
    "cica_primarycontactfirstname": "Sibyl",
    "id": "63455c5e-9b0d-11e8-8284-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6077648600",
    "cica_calltype": "Business",
    "cica_businessaddress": "11 Lenore Ave",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sibyl",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "HSE KPNG",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60098",
    "cica_primarycontactlastname": "Friedland",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/13/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Friedland"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "JIM BROWN TRUCKING",
    "cica_primarycontactfirstname": "Felipa",
    "id": "63456514-9b0d-11e8-95f9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6073361419",
    "cica_calltype": "Business",
    "cica_businessaddress": "11 Lenore Ave",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Felipa",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "P O",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60099",
    "cica_primarycontactlastname": "Koester",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/27/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Koester"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD PSA4",
    "cica_primarycontactfirstname": "Meridith",
    "id": "63456dd4-9b0d-11e8-b7f7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6073342717",
    "cica_calltype": "Business",
    "cica_businessaddress": "46 Susan Dr",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Meridith",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "ADMIN",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60100",
    "cica_primarycontactlastname": "Eiland",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/27/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Eiland"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PSA 4",
    "cica_primarycontactfirstname": "Antonietta",
    "id": "634576d9-9b0d-11e8-914b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7185514968",
    "cica_calltype": "Business",
    "cica_businessaddress": "46 Susan Dr",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Antonietta",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OFFC MGR",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60101",
    "cica_primarycontactlastname": "Bento",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/12/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bento"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ROOSEVELT HOSPITAL",
    "cica_primarycontactfirstname": "Roslyn",
    "id": "63458151-9b0d-11e8-98d4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7186261625",
    "cica_calltype": "Business",
    "cica_businessaddress": "46 Susan Dr",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Roslyn",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "MAINT",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60102",
    "cica_primarycontactlastname": "Sandor",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/23/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sandor"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD 17 PCT",
    "cica_primarycontactfirstname": "Mohammed",
    "id": "63458aee-9b0d-11e8-8c77-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7182174795",
    "cica_calltype": "Business",
    "cica_businessaddress": "277 W Crooked Hill Rd",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mohammed",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CNA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60103",
    "cica_primarycontactlastname": "Lamorte",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/25/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lamorte"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MT SIANI HOSPITAL",
    "cica_primarycontactfirstname": "Dorinda",
    "id": "63459354-9b0d-11e8-b362-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7184522720",
    "cica_calltype": "Business",
    "cica_businessaddress": "277 W Crooked Hill Rd",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dorinda",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "STUDENT",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60104",
    "cica_primarycontactlastname": "Romanik",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/14/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Romanik"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "ATTS",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MT SINAI HOSPITAL GUGGENHEIM",
    "cica_primarycontactfirstname": "Joelle",
    "id": "63459bcf-9b0d-11e8-941c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7186285510",
    "cica_calltype": "Business",
    "cica_businessaddress": "277 W Crooked Hill Rd",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joelle",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "TEACHER AS",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "SC6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163730637",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60105",
    "cica_primarycontactlastname": "Probert",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/7/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Probert"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MT SINAI HOSPITAL",
    "cica_primarycontactfirstname": "Angelika",
    "id": "6345a447-9b0d-11e8-b290-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6317484499",
    "cica_calltype": "Business",
    "cica_businessaddress": "12 Parkway Trailer Ct",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Angelika",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "RN",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163730637",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60106",
    "cica_primarycontactlastname": "Schleicher",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/26/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schleicher"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "METROPOLITAN HOSPITAL",
    "cica_primarycontactfirstname": "Loreen",
    "id": "6345acd4-9b0d-11e8-aa6e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "8457532166",
    "cica_calltype": "Business",
    "cica_businessaddress": "21 Harriman Ave",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Loreen",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "POLICE OFF",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163786693",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "60107",
    "cica_primarycontactlastname": "Albury",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/20/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Albury"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FDNY",
    "cica_primarycontactfirstname": "Katia",
    "id": "6345b559-9b0d-11e8-8aea-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3473265767",
    "cica_calltype": "Business",
    "cica_businessaddress": "73 Mallory Rd",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Katia",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OWNER",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163786693",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "60108",
    "cica_primarycontactlastname": "Goold",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/2/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Goold"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Carma",
    "id": "6345bdde-9b0d-11e8-9528-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7183900015",
    "cica_calltype": "Business",
    "cica_businessaddress": "73 Mallory Rd",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carma",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWNER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859687063",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60109",
    "cica_primarycontactlastname": "Jaques",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/27/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jaques"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "1199 SEIU",
    "cica_primarycontactfirstname": "Marg",
    "id": "6345c657-9b0d-11e8-a23e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7186004554",
    "cica_calltype": "Business",
    "cica_businessaddress": "12 W Sneden Pl",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marg",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OWNER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859687063",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60110",
    "cica_primarycontactlastname": "Beem",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/20/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Beem"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NY PRESBYTERIAN HOSP",
    "cica_primarycontactfirstname": "Leisa",
    "id": "6345cedc-9b0d-11e8-9c65-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7183517031",
    "cica_calltype": "Business",
    "cica_businessaddress": "12 W Sneden Pl",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Leisa",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "WORKER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859687063",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60111",
    "cica_primarycontactlastname": "Phegley",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/13/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Phegley"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "LENOX MEDICAL CENTER",
    "cica_primarycontactfirstname": "Trang",
    "id": "6345d757-9b0d-11e8-b5de-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7185248315",
    "cica_calltype": "Business",
    "cica_businessaddress": "12 Sneden Pl W",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Trang",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "HW",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60112",
    "cica_primarycontactlastname": "Ferree",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/19/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ferree"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD TRANSIT DST 2",
    "cica_primarycontactfirstname": "Alexandria",
    "id": "6345dfc5-9b0d-11e8-96f6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7183178096",
    "cica_calltype": "Business",
    "cica_businessaddress": "6 Sherman Dr",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Alexandria",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "MECH",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60113",
    "cica_primarycontactlastname": "Vandermeer",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/4/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vandermeer"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD TRANSIT DST 2",
    "cica_primarycontactfirstname": "Clotilde",
    "id": "6345e911-9b0d-11e8-b1fd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7189878199",
    "cica_calltype": "Business",
    "cica_businessaddress": "500 E Funston Ave Apt 17",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Clotilde",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "WORKER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60114",
    "cica_primarycontactlastname": "Lena",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/18/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lena"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "RICHMOND CENTER FOR REH",
    "cica_primarycontactfirstname": "Debora",
    "id": "6345f194-9b0d-11e8-bcde-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7189663835",
    "cica_calltype": "Business",
    "cica_businessaddress": "500 E Funston Ave Apt 17",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Debora",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "REAL ESTAT",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60115",
    "cica_primarycontactlastname": "Yarberry",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Yarberry"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ALL BROTHERS AUTO BODY",
    "cica_primarycontactfirstname": "Marchelle",
    "id": "6345fa19-9b0d-11e8-a28e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7189663835",
    "cica_calltype": "Business",
    "cica_businessaddress": "11 Rock Dr",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marchelle",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859683923",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60116",
    "cica_primarycontactlastname": "Kirkland",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/5/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kirkland"
  },
  {
    "cica_market": "3",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "JYHM",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NASCO STONE & TILE",
    "cica_primarycontactfirstname": "Lashawn",
    "id": "6346029e-9b0d-11e8-b260-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3478857573",
    "cica_calltype": "Business",
    "cica_businessaddress": "11 Rock Dr",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lashawn",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "SC6",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWNER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "48",
    "cica_writingagentfirstname": "Agent16",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859683923",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60117",
    "cica_primarycontactlastname": "Schoenfeld",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/20/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schoenfeld"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Natalia",
    "id": "63460dde-9b0d-11e8-8809-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7189483844",
    "cica_calltype": "Business",
    "cica_businessaddress": "109 Biltmore Ave",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Natalia",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5855678090",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60118",
    "cica_primarycontactlastname": "Stiverson",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/5/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stiverson"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYC FIRE DEPT ENG 163",
    "cica_primarycontactfirstname": "Brunilda",
    "id": "634619b3-9b0d-11e8-90a8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7189814719",
    "cica_calltype": "Business",
    "cica_businessaddress": "9911 204th St",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Brunilda",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NRS AIDE",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5855678090",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60119",
    "cica_primarycontactlastname": "Streetman",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/11/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Streetman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MTA",
    "cica_primarycontactfirstname": "Ardith",
    "id": "63462314-9b0d-11e8-b02a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7189925079",
    "cica_calltype": "Business",
    "cica_businessaddress": "PO Box 561",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ardith",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OWNER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5852980871",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60120",
    "cica_primarycontactlastname": "Stolz",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/16/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stolz"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYC PARKS DEPARTMENT",
    "cica_primarycontactfirstname": "Courtney",
    "id": "63462d1e-9b0d-11e8-9904-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9173462065",
    "cica_calltype": "Business",
    "cica_businessaddress": "525 Fowler Ave",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Courtney",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CASHIER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60121",
    "cica_primarycontactlastname": "Roberti",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/3/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Roberti"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "DOT",
    "cica_primarycontactfirstname": "Floyd",
    "id": "6346366b-9b0d-11e8-bc54-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9173462065",
    "cica_calltype": "Business",
    "cica_businessaddress": "960 Oaks Dr",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Floyd",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "ARCHITECT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60122",
    "cica_primarycontactlastname": "Glines",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/11/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Glines"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "CITY OF NEW YORK",
    "cica_primarycontactfirstname": "Lakita",
    "id": "6346405e-9b0d-11e8-91a0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3476025844",
    "cica_calltype": "Business",
    "cica_businessaddress": "130 Days Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lakita",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "HHA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60123",
    "cica_primarycontactlastname": "Persinger",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/24/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Persinger"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "LINCOLN HOSPITAL",
    "cica_primarycontactfirstname": "Daryl",
    "id": "634649ae-9b0d-11e8-9d0f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9178388641",
    "cica_calltype": "Business",
    "cica_businessaddress": "310 Fairhaven Blvd",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Daryl",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CNA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Fears",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/9/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fears"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "LINCOLN HOSPITAL",
    "cica_primarycontactfirstname": "Rhett",
    "id": "634653e8-9b0d-11e8-abc7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6467488428",
    "cica_calltype": "Business",
    "cica_businessaddress": "310 Fairhaven Blvd",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rhett",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "HHA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Shellhammer",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/12/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shellhammer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "H W WILSONS CO",
    "cica_primarycontactfirstname": "Grayce",
    "id": "63465e05-9b0d-11e8-ae47-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3479283740",
    "cica_calltype": "Business",
    "cica_businessaddress": "321 S 8th St Fl 2",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Grayce",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "ACCNT",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Whetstone",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/13/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Whetstone"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BRONX LEBANNON HOSPITAL",
    "cica_primarycontactfirstname": "Deedra",
    "id": "634667f0-9b0d-11e8-9eba-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6466373102",
    "cica_calltype": "Business",
    "cica_businessaddress": "2021 49th St # 1",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Deedra",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "OWNER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Fricke",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/19/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fricke"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Mario",
    "id": "634671ae-9b0d-11e8-a089-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9176013119",
    "cica_calltype": "Business",
    "cica_businessaddress": "469 50th St",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mario",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "SALES",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60088",
    "cica_primarycontactlastname": "Jarvie",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/7/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jarvie"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD TD 12",
    "cica_primarycontactfirstname": "Stacy",
    "id": "63467bca-9b0d-11e8-a0ba-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6316717796",
    "cica_calltype": "Business",
    "cica_businessaddress": "469 50th St",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Stacy",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "RETIRED",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60089",
    "cica_primarycontactlastname": "Bowland",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/21/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bowland"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD TD 12",
    "cica_primarycontactfirstname": "Lucie",
    "id": "634689b0-9b0d-11e8-b6cb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6316717796",
    "cica_calltype": "Business",
    "cica_businessaddress": "509 E 45th St",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lucie",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "STUDENT",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60090",
    "cica_primarycontactlastname": "Bixler",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/24/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bixler"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BEDFORD HILLS CONSTRUCTION",
    "cica_primarycontactfirstname": "Stephania",
    "id": "63469470-9b0d-11e8-a775-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6462940557",
    "cica_calltype": "Business",
    "cica_businessaddress": "9125 Kings Hwy",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Stephania",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "PRACTICE M",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60091",
    "cica_primarycontactlastname": "Holiman",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/9/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Holiman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Deneen",
    "id": "63469ea1-9b0d-11e8-b812-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7182396964",
    "cica_calltype": "Business",
    "cica_businessaddress": "9125 Kings Hwy",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Deneen",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "FIREMAN",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60092",
    "cica_primarycontactlastname": "Moon",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/12/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Moon"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FDNY E 64",
    "cica_primarycontactfirstname": "Georgiann",
    "id": "6346a905-9b0d-11e8-beb3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3473991376",
    "cica_calltype": "Business",
    "cica_businessaddress": "5705 Tilden Ave",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Georgiann",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60093",
    "cica_primarycontactlastname": "Bloodworth",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/23/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bloodworth"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "TCE3",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "STAR MITSUBISHI",
    "cica_primarycontactfirstname": "Wilhemina",
    "id": "6346b1ba-9b0d-11e8-89ff-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6467242224",
    "cica_calltype": "Business",
    "cica_businessaddress": "577 E 55th St",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Wilhemina",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CNA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60094",
    "cica_primarycontactlastname": "Deremer",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/14/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Deremer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD 50 PCT",
    "cica_primarycontactfirstname": "Suzette",
    "id": "6346bbb3-9b0d-11e8-a6f2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9172512430",
    "cica_calltype": "Business",
    "cica_businessaddress": "310 Lenox Rd Apt 3R",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Suzette",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "WORKER",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60095",
    "cica_primarycontactlastname": "Zak",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Zak"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ST BARNABAS HOSPITAL",
    "cica_primarycontactfirstname": "Graig",
    "id": "6346c6ab-9b0d-11e8-bd91-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7186547620",
    "cica_calltype": "Business",
    "cica_businessaddress": "934 Liberty St",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Graig",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NURSE",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60096",
    "cica_primarycontactlastname": "Biller",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/20/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Biller"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "QUALITY FORD",
    "cica_primarycontactfirstname": "Ciera",
    "id": "6346d08f-9b0d-11e8-8334-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7182106589",
    "cica_calltype": "Business",
    "cica_businessaddress": "416 Crescent St",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ciera",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "MECH",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60097",
    "cica_primarycontactlastname": "Kristensen",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/7/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kristensen"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MONTIFORE HOSPITAL",
    "cica_primarycontactfirstname": "Asia",
    "id": "6346d92e-9b0d-11e8-a1ab-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3472372208",
    "cica_calltype": "Business",
    "cica_businessaddress": "416 Crescent St",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Asia",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "DAUGHTER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60098",
    "cica_primarycontactlastname": "Bradeen",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/7/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bradeen"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD 52 PCT",
    "cica_primarycontactfirstname": "Rosalie",
    "id": "6346e1b3-9b0d-11e8-b5bd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6465386496",
    "cica_calltype": "Business",
    "cica_businessaddress": "416 Crescent St",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosalie",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "ELECTRCN",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60099",
    "cica_primarycontactlastname": "Petrin",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Petrin"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FDNY",
    "cica_primarycontactfirstname": "Tana",
    "id": "6346ead7-9b0d-11e8-84aa-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7185933388",
    "cica_calltype": "Business",
    "cica_businessaddress": "416 Crescent St",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tana",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60100",
    "cica_primarycontactlastname": "Alles",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Alles"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MONTEFIORE MEDICAL CENTER",
    "cica_primarycontactfirstname": "Holli",
    "id": "6346f3e6-9b0d-11e8-8b67-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6467250841",
    "cica_calltype": "Business",
    "cica_businessaddress": "416 Crescent St",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Holli",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWNER",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60101",
    "cica_primarycontactlastname": "Abbas",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/14/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Abbas"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SARAH NEUMAN NURSING HOME",
    "cica_primarycontactfirstname": "Jaye",
    "id": "6346fd51-9b0d-11e8-b5ee-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3478581728",
    "cica_calltype": "Business",
    "cica_businessaddress": "19 Jefferson Ave",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jaye",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "WAREHSE",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60102",
    "cica_primarycontactlastname": "Hartsell",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/5/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hartsell"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PRECEIT 44",
    "cica_primarycontactfirstname": "Pura",
    "id": "634706cf-9b0d-11e8-81c1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3478058261",
    "cica_calltype": "Business",
    "cica_businessaddress": "3F Signs Rd",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Pura",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "PAYROLL SU",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60103",
    "cica_primarycontactlastname": "Victorino",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/17/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Victorino"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Irma",
    "id": "63470fe1-9b0d-11e8-8cbe-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7185196188",
    "cica_calltype": "Business",
    "cica_businessaddress": "961 E 37th St",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Irma",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OWNER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60104",
    "cica_primarycontactlastname": "Vizcaino",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/18/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vizcaino"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BRONX VA HOSPITAL",
    "cica_primarycontactfirstname": "Tom",
    "id": "634718b3-9b0d-11e8-a8b5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7185196188",
    "cica_calltype": "Business",
    "cica_businessaddress": "157 Rodney St",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tom",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "TRUCK DRVR",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60105",
    "cica_primarycontactlastname": "Stevenson",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/25/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stevenson"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "TONYS HOT DOGS PLUS",
    "cica_primarycontactfirstname": "Lorena",
    "id": "6347216b-9b0d-11e8-98ab-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7183200512",
    "cica_calltype": "Business",
    "cica_businessaddress": "157 Rodney St",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lorena",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "MAINTANCE",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60106",
    "cica_primarycontactlastname": "Pelaez",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/23/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pelaez"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MT KISCO HONDA",
    "cica_primarycontactfirstname": "Alejandro",
    "id": "63472a28-9b0d-11e8-a114-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3478190868",
    "cica_calltype": "Business",
    "cica_businessaddress": "14534 110th Ave",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Alejandro",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "SALES",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60107",
    "cica_primarycontactlastname": "Steadman",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/20/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Steadman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "TOWN OF CORTLANDT WATER DEPT",
    "cica_primarycontactfirstname": "Laure",
    "id": "634732e1-9b0d-11e8-9bad-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7183198384",
    "cica_calltype": "Business",
    "cica_businessaddress": "1615 Dean St Apt 2D",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Laure",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "FF",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60108",
    "cica_primarycontactlastname": "Jerrell",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/7/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jerrell"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "C.",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SKYVIEW NURSING HOME",
    "cica_primarycontactfirstname": "Aletha",
    "id": "63473c17-9b0d-11e8-b6af-34363bd2a970",
    "cica_primarycontactmiddlename": "C.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9175573815",
    "cica_calltype": "Business",
    "cica_businessaddress": "8737 259th St",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Aletha",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "33-3012 01",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60109",
    "cica_primarycontactlastname": "Ritzman",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/15/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ritzman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SPRINGHURST ELEMTARY SCHOOL",
    "cica_primarycontactfirstname": "Sherrie",
    "id": "634744e1-9b0d-11e8-a5c9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9176370762",
    "cica_calltype": "Business",
    "cica_businessaddress": "1137 Bergen St Apt 6",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sherrie",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CHILD",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60110",
    "cica_primarycontactlastname": "Betts",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/16/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Betts"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "HOME INSTEAD CARE",
    "cica_primarycontactfirstname": "Hettie",
    "id": "63474e23-9b0d-11e8-9ae4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9179123503",
    "cica_calltype": "Business",
    "cica_businessaddress": "3765 18th Ave Apt A14",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hettie",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "SUPV",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60111",
    "cica_primarycontactlastname": "Nice",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/5/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nice"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "DOBBS FERRY HOSPITAL",
    "cica_primarycontactfirstname": "Nada",
    "id": "634756e3-9b0d-11e8-8940-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7186442909",
    "cica_calltype": "Business",
    "cica_businessaddress": "1837 58th St Fl 1",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nada",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60112",
    "cica_primarycontactlastname": "Groner",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/17/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Groner"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "HARRISON POLICE DEPARTMENT",
    "cica_primarycontactfirstname": "Kimber",
    "id": "63475fae-9b0d-11e8-83c7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145285489",
    "cica_calltype": "Business",
    "cica_businessaddress": "1837 58th St Fl 1",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kimber",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "WORKER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60113",
    "cica_primarycontactlastname": "Pinto",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/15/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pinto"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "LETS MAKE A DEAL",
    "cica_primarycontactfirstname": "Nichelle",
    "id": "63476863-9b0d-11e8-81ba-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143757547",
    "cica_calltype": "Business",
    "cica_businessaddress": "4107 12th Ave",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nichelle",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OFFICER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60114",
    "cica_primarycontactlastname": "Berggren",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/20/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Berggren"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "WIRELESS WORLD",
    "cica_primarycontactfirstname": "Maya",
    "id": "63477142-9b0d-11e8-8789-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147552142",
    "cica_calltype": "Business",
    "cica_businessaddress": "829 60th St Apt 2R",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maya",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "OFFICER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60115",
    "cica_primarycontactlastname": "Comeaux",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/3/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Comeaux"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "WIRELESS WORLD",
    "cica_primarycontactfirstname": "Terisa",
    "id": "63477a00-9b0d-11e8-8082-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7183247913",
    "cica_calltype": "Business",
    "cica_businessaddress": "216 N Michigan Ave",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Terisa",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OFFICER",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60116",
    "cica_primarycontactlastname": "Vandemark",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/22/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vandemark"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "KEEP IT COOL INC",
    "cica_primarycontactfirstname": "Sharika",
    "id": "634782c2-9b0d-11e8-82f4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142716765",
    "cica_calltype": "Business",
    "cica_businessaddress": "1874 Victory Blvd # 1",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sharika",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "TEACHER",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60117",
    "cica_primarycontactlastname": "Pope",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/2/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pope"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIHC",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MAMARONECK DPW",
    "cica_primarycontactfirstname": "Jenni",
    "id": "63478bf0-9b0d-11e8-9aca-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146936909",
    "cica_calltype": "Business",
    "cica_businessaddress": "611 Rogers Ave Apt 3R",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jenni",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CHILD",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60118",
    "cica_primarycontactlastname": "Stenberg",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/7/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stenberg"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "500 SAW MILL  RIVER RD",
    "cica_primarycontactfirstname": "Deanna",
    "id": "63479597-9b0d-11e8-aa1c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149096136",
    "cica_calltype": "Business",
    "cica_businessaddress": "31 Balfour Pl",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Deanna",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "FIREFIGHTE",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60119",
    "cica_primarycontactlastname": "Mangus",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/18/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mangus"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MARYKNOLL",
    "cica_primarycontactfirstname": "Herb",
    "id": "63479e6b-9b0d-11e8-87e6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149096136",
    "cica_calltype": "Business",
    "cica_businessaddress": "31 Balfour Pl",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Herb",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "TRCK DRVER",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent17",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60120",
    "cica_primarycontactlastname": "Alberico",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/25/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Alberico"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MARYKNOLL",
    "cica_primarycontactfirstname": "Kimbra",
    "id": "6347a733-9b0d-11e8-9f93-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148389689",
    "cica_calltype": "Business",
    "cica_businessaddress": "7761 79th St",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kimbra",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "ADMIN ASST",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60121",
    "cica_primarycontactlastname": "Finnegan",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/26/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Finnegan"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "VETERANS NURSING HOME",
    "cica_primarycontactfirstname": "Sandy",
    "id": "6347aff5-9b0d-11e8-bfbd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143937356",
    "cica_calltype": "Business",
    "cica_businessaddress": "419 Pleasantview Ct",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sandy",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OFFICER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60122",
    "cica_primarycontactlastname": "Schecter",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/12/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schecter"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ROYAL CLEANERS",
    "cica_primarycontactfirstname": "Barbra",
    "id": "6347b8b3-9b0d-11e8-bf34-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145930117",
    "cica_calltype": "Business",
    "cica_businessaddress": "119 Gauldy Ave",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Barbra",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "MONITOR",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60123",
    "cica_primarycontactlastname": "Carnahan",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/1/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Carnahan"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ROYAL CLEANERS",
    "cica_primarycontactfirstname": "Kesha",
    "id": "6347c15e-9b0d-11e8-a464-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146900303",
    "cica_calltype": "Business",
    "cica_businessaddress": "3 Nova Ct",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kesha",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CHILD",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Prahl",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/26/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Prahl"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ROYAL CLEANERS",
    "cica_primarycontactfirstname": "Sibyl",
    "id": "6347ca33-9b0d-11e8-a7cf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148350303",
    "cica_calltype": "Business",
    "cica_businessaddress": "188 Bay 17th St # 3E",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sibyl",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "SGT",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Kemplin",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/9/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kemplin"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ROYAL CLEANERS",
    "cica_primarycontactfirstname": "Jestine",
    "id": "6347d2eb-9b0d-11e8-ac1e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147693873",
    "cica_calltype": "Business",
    "cica_businessaddress": "202 Foster Ave Apt 8",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jestine",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "EMPL",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Kalina",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/15/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kalina"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "EDWARD WILLIAMS SCHOOL",
    "cica_primarycontactfirstname": "Olivia",
    "id": "6347dbb3-9b0d-11e8-ae77-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146980020",
    "cica_calltype": "Business",
    "cica_businessaddress": "109 Lehigh St",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Olivia",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "STU",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Raymer",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/26/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Raymer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "W.",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MOUNT SINAI",
    "cica_primarycontactfirstname": "Sheri",
    "id": "6347e487-9b0d-11e8-a8e3-34363bd2a970",
    "cica_primarycontactmiddlename": "W.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144200281",
    "cica_calltype": "Business",
    "cica_businessaddress": "1098 E 58th St",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sheri",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NURSE",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60088",
    "cica_primarycontactlastname": "Mori",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/1/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mori"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MONTEFIORE MT VERNON HOSPITAL",
    "cica_primarycontactfirstname": "Renaldo",
    "id": "6347ed51-9b0d-11e8-a8fa-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149069243",
    "cica_calltype": "Business",
    "cica_businessaddress": "1098 E 58th St",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Renaldo",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "SALES",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60089",
    "cica_primarycontactlastname": "Montemayor",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/3/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Montemayor"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "JOAN BEAUTY SALON",
    "cica_primarycontactfirstname": "Ahmad",
    "id": "6347f611-9b0d-11e8-b4d5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149412388",
    "cica_calltype": "Business",
    "cica_businessaddress": "10215 Avenue J",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ahmad",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "TEACHERS",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60090",
    "cica_primarycontactlastname": "Melone",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/28/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Melone"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "CVS",
    "cica_primarycontactfirstname": "Genny",
    "id": "6347fedc-9b0d-11e8-a0fa-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149412388",
    "cica_calltype": "Business",
    "cica_businessaddress": "1398 E 93rd St",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Genny",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "MECH",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60091",
    "cica_primarycontactlastname": "Eugene",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/4/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Eugene"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PETER GISOLFI",
    "cica_primarycontactfirstname": "Kieth",
    "id": "6348081c-9b0d-11e8-ad5c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149412388",
    "cica_calltype": "Business",
    "cica_businessaddress": "2038 Stuart St",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kieth",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CHIROPRACT",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60092",
    "cica_primarycontactlastname": "Nigro",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/15/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nigro"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "THE OSBORN",
    "cica_primarycontactfirstname": "Beatrice",
    "id": "634810fa-9b0d-11e8-8a70-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146671706",
    "cica_calltype": "Business",
    "cica_businessaddress": "1824 124th St",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Beatrice",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "POLICE OFF",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60093",
    "cica_primarycontactlastname": "Kneeland",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/24/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kneeland"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "KAREN CONNECTION",
    "cica_primarycontactfirstname": "Emily",
    "id": "634819b3-9b0d-11e8-b62e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142411495",
    "cica_calltype": "Business",
    "cica_businessaddress": "1824 124th St",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Emily",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NURSE",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60094",
    "cica_primarycontactlastname": "Mccalister",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/15/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mccalister"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PEPSI COLA",
    "cica_primarycontactfirstname": "Sanjuanita",
    "id": "6348227a-9b0d-11e8-be5d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142411495",
    "cica_calltype": "Business",
    "cica_businessaddress": "19608 44th Ave",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sanjuanita",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "ENVIRONMEN",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60095",
    "cica_primarycontactlastname": "Antes",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/27/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Antes"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "WESTCHESTER MEDICAL CENTER",
    "cica_primarycontactfirstname": "Janee",
    "id": "63482b4f-9b0d-11e8-ba8b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142411495",
    "cica_calltype": "Business",
    "cica_businessaddress": "4 Hampton Ct",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Janee",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NURSE",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60096",
    "cica_primarycontactlastname": "Izquierdo",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/3/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Izquierdo"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AXBN",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BRONX GARDENS",
    "cica_primarycontactfirstname": "Latonya",
    "id": "63483423-9b0d-11e8-8e4d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142411495",
    "cica_calltype": "Business",
    "cica_businessaddress": "21019 56th Ave",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Latonya",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "DM7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "RETIRED",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent22",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60097",
    "cica_primarycontactlastname": "Couvillion",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/19/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Couvillion"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FNDY EMS STATION",
    "cica_primarycontactfirstname": "Lannie",
    "id": "63483cf8-9b0d-11e8-b1ee-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145628610",
    "cica_calltype": "Business",
    "cica_businessaddress": "143 Floral Pkwy",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lannie",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "LIMO DRIVR",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60098",
    "cica_primarycontactlastname": "Seifried",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/23/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Seifried"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "HEBREW HOSPITAL HOME",
    "cica_primarycontactfirstname": "Dominic",
    "id": "634845cc-9b0d-11e8-a8d2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142169196",
    "cica_calltype": "Business",
    "cica_businessaddress": "6120 217th St",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dominic",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "OFF MGR",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60099",
    "cica_primarycontactlastname": "Hammon",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/12/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hammon"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PEOPLES CARE",
    "cica_primarycontactfirstname": "Tawny",
    "id": "63484e97-9b0d-11e8-856f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9176696809",
    "cica_calltype": "Business",
    "cica_businessaddress": "19214 110th Rd",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tawny",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "SELF EMPLO",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60100",
    "cica_primarycontactlastname": "Sturdevant",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/23/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sturdevant"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "GRAPHICS ART",
    "cica_primarycontactfirstname": "Retta",
    "id": "63485754-9b0d-11e8-bf3c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146648103",
    "cica_calltype": "Business",
    "cica_businessaddress": "19214 110th Rd",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Retta",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "SCHL SAFET",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60101",
    "cica_primarycontactlastname": "Hemmer",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/7/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hemmer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "G & CO MICH WORKS",
    "cica_primarycontactfirstname": "Delia",
    "id": "63486017-9b0d-11e8-9ef7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145629840",
    "cica_calltype": "Business",
    "cica_businessaddress": "19214 110th Rd",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delia",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "POLICE OFF",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60102",
    "cica_primarycontactlastname": "Remmers",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/28/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Remmers"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PREPAID LEGAL",
    "cica_primarycontactfirstname": "Ardath",
    "id": "634868d4-9b0d-11e8-9140-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146681433",
    "cica_calltype": "Business",
    "cica_businessaddress": "11446 203rd St",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ardath",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NURSE ASST",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60103",
    "cica_primarycontactlastname": "Mosca",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/14/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mosca"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "HUDSON EYE ASSOC",
    "cica_primarycontactfirstname": "Ali",
    "id": "63487182-9b0d-11e8-8cd5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143257640",
    "cica_calltype": "Business",
    "cica_businessaddress": "13053 232nd St",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ali",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "BABYSITTER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60104",
    "cica_primarycontactlastname": "Betances",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/8/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Betances"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MOUNT VERNON FIRE DEPT",
    "cica_primarycontactfirstname": "Darcy",
    "id": "63487a42-9b0d-11e8-8f16-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146639089",
    "cica_calltype": "Business",
    "cica_businessaddress": "13719 159th St",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Darcy",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "ADMIN PD A",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60105",
    "cica_primarycontactlastname": "Bartkowski",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/25/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bartkowski"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MONTROSE VA",
    "cica_primarycontactfirstname": "Martha",
    "id": "634882ee-9b0d-11e8-a988-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "6463383860",
    "cica_calltype": "Business",
    "cica_businessaddress": "46 Stewart Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Martha",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "ADMINST PD",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60106",
    "cica_primarycontactlastname": "Kerfoot",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/7/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kerfoot"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "WATER DEPT",
    "cica_primarycontactfirstname": "Reda",
    "id": "63488ca8-9b0d-11e8-9123-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "7863992321",
    "cica_calltype": "Business",
    "cica_businessaddress": "9711 109th Ave Fl 2",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Reda",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "CHILD",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60107",
    "cica_primarycontactlastname": "Rhode",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/1/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rhode"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "JOSEPH SUPPA & SONS",
    "cica_primarycontactfirstname": "Lelah",
    "id": "63489997-9b0d-11e8-9e08-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3479499311",
    "cica_calltype": "Business",
    "cica_businessaddress": "234 Grand Ave",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lelah",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "POLICE OFF",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60108",
    "cica_primarycontactlastname": "Jarmon",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/27/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jarmon"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FDNY ENG 6",
    "cica_primarycontactfirstname": "Sha",
    "id": "6348a44a-9b0d-11e8-92d5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148043759",
    "cica_calltype": "Business",
    "cica_businessaddress": "234 Grand Ave",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sha",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CLERK",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60109",
    "cica_primarycontactlastname": "Bohrer",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/16/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bohrer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "W.",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FDNY",
    "cica_primarycontactfirstname": "Jeffery",
    "id": "6348adf0-9b0d-11e8-a37a-34363bd2a970",
    "cica_primarycontactmiddlename": "W.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145625042",
    "cica_calltype": "Business",
    "cica_businessaddress": "14139 243rd St",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jeffery",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "SCH SAFETY",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60110",
    "cica_primarycontactlastname": "Hesser",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/24/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hesser"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NANUET CHRYSLER PLYMOUTH",
    "cica_primarycontactfirstname": "Genia",
    "id": "6348b6c5-9b0d-11e8-8a31-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146685449",
    "cica_calltype": "Business",
    "cica_businessaddress": "24032 146th Ave",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Genia",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "RET",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60111",
    "cica_primarycontactlastname": "Rotz",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/22/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rotz"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "TEND BUSINESS SERVICE",
    "cica_primarycontactfirstname": "Kendra",
    "id": "6348bfd4-9b0d-11e8-8878-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145733158",
    "cica_calltype": "Business",
    "cica_businessaddress": "58 Camdike St",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kendra",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "POLICE OFC",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60112",
    "cica_primarycontactlastname": "Mcloughlin",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/23/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcloughlin"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "TEND BUSINESS SERVICE",
    "cica_primarycontactfirstname": "Delcie",
    "id": "6348c887-9b0d-11e8-8e97-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146684920",
    "cica_calltype": "Business",
    "cica_businessaddress": "8049 161st St",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delcie",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWNER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60113",
    "cica_primarycontactlastname": "Bain",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/2/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bain"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NEW HYDE PARK FIRE DEPT",
    "cica_primarycontactfirstname": "Jin",
    "id": "6348d135-9b0d-11e8-8c7e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146684920",
    "cica_calltype": "Business",
    "cica_businessaddress": "17336 103rd Rd",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jin",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "SCO",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60114",
    "cica_primarycontactlastname": "Gryder",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/28/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gryder"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BELMONT",
    "cica_primarycontactfirstname": "Jeffry",
    "id": "6348d9d9-9b0d-11e8-9ba6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148862544",
    "cica_calltype": "Business",
    "cica_businessaddress": "41 Wall St",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jeffry",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "PLUMBER",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60115",
    "cica_primarycontactlastname": "Doner",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/10/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Doner"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BELMONT",
    "cica_primarycontactfirstname": "Kristin",
    "id": "6348e266-9b0d-11e8-89ca-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144728439",
    "cica_calltype": "Business",
    "cica_businessaddress": "14504 Lakewood Ave",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kristin",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CARPENTER",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60116",
    "cica_primarycontactlastname": "Minnix",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/4/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Minnix"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "ELMONT FD ENGINE CO 3",
    "cica_primarycontactfirstname": "Ranae",
    "id": "6348eaf5-9b0d-11e8-af6b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148377995",
    "cica_calltype": "Business",
    "cica_businessaddress": "3447 Steven Rd",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ranae",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "BOOKEEPER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60117",
    "cica_primarycontactlastname": "Whitcher",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/23/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Whitcher"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MARION E SAMUELS",
    "cica_primarycontactfirstname": "Mitchel",
    "id": "6348f397-9b0d-11e8-9f07-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146632466",
    "cica_calltype": "Business",
    "cica_businessaddress": "294 Rushmore Ave",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mitchel",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "PUBL COORD",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60118",
    "cica_primarycontactlastname": "Hamby",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/5/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hamby"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MT SINAI HOSPITAL",
    "cica_primarycontactfirstname": "Zachery",
    "id": "6348fc2e-9b0d-11e8-96ac-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149418976",
    "cica_calltype": "Business",
    "cica_businessaddress": "294 Rushmore Ave",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Zachery",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60119",
    "cica_primarycontactlastname": "Wiersma",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/6/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wiersma"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "USMMA WATERFRONT",
    "cica_primarycontactfirstname": "Genoveva",
    "id": "634904c5-9b0d-11e8-8cf3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149418976",
    "cica_calltype": "Business",
    "cica_businessaddress": "123 Moon Ave",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Genoveva",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CO OWN",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "Spanish",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60120",
    "cica_primarycontactlastname": "Willmore",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/24/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Willmore"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SEERY SYSTEMS GOUP INC",
    "cica_primarycontactfirstname": "Carman",
    "id": "63490d54-9b0d-11e8-b03e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149418976",
    "cica_calltype": "Business",
    "cica_businessaddress": "2343 Muis Rd",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carman",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CO OWNER",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60121",
    "cica_primarycontactlastname": "Cornwall",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/7/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cornwall"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD  114 PCT",
    "cica_primarycontactfirstname": "Michell",
    "id": "634915eb-9b0d-11e8-989c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148794458",
    "cica_calltype": "Business",
    "cica_businessaddress": "344 Rue de Mars",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Michell",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "HAIRDRESSE",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60122",
    "cica_primarycontactlastname": "Usry",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/2/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Usry"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYSD",
    "cica_primarycontactfirstname": "Katy",
    "id": "63491e70-9b0d-11e8-85b4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147396439",
    "cica_calltype": "Business",
    "cica_businessaddress": "53 Dueks Lane",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Katy",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "PO",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60123",
    "cica_primarycontactlastname": "Edelson",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/13/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Edelson"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FDNY",
    "cica_primarycontactfirstname": "Carlotta",
    "id": "634926f3-9b0d-11e8-b0af-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147396439",
    "cica_calltype": "Business",
    "cica_businessaddress": "45 Fdilk Ave",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carlotta",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWN",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163730637",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Mcadam",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/8/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcadam"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "FDNY EMS",
    "cica_primarycontactfirstname": "Conrad",
    "id": "63492f8c-9b0d-11e8-a0d6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145641881",
    "cica_calltype": "Business",
    "cica_businessaddress": "1243334 4th St.",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Conrad",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NURSE AID",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163730637",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Eichman",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/10/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Eichman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SCHAROMS CARES",
    "cica_primarycontactfirstname": "Thersa",
    "id": "63493819-9b0d-11e8-8dc3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147393051",
    "cica_calltype": "Business",
    "cica_businessaddress": "454 Tru Lane",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Thersa",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "ASST PCA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163786693",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Wigton",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/12/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wigton"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "GOLDTEIN PRESS",
    "cica_primarycontactfirstname": "Terresa",
    "id": "634940b0-9b0d-11e8-8e78-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142937493",
    "cica_calltype": "Business",
    "cica_businessaddress": "454 5th Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Terresa",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "CNA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "7163786693",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Honda",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/12/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Honda"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "88 PCT",
    "cica_primarycontactfirstname": "Elvira",
    "id": "6349492b-9b0d-11e8-be15-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142937493",
    "cica_calltype": "Business",
    "cica_businessaddress": "154 Bay 35th St",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elvira",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "PASTOR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859687063",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60088",
    "cica_primarycontactlastname": "Fischer",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/13/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fischer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PSA 2",
    "cica_primarycontactfirstname": "Jonnie",
    "id": "634951b0-9b0d-11e8-8d42-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148973783",
    "cica_calltype": "Business",
    "cica_businessaddress": "105 Swan St",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jonnie",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "SUPVSR",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859687063",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60089",
    "cica_primarycontactlastname": "Marling",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/21/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Marling"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "KINGSBROOK JEWISH MEDICAL",
    "cica_primarycontactfirstname": "Danelle",
    "id": "63495a3d-9b0d-11e8-af7a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143784039",
    "cica_calltype": "Business",
    "cica_businessaddress": "35 Seacoast Ter Apt 3W",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Danelle",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "MECHANIC",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859687063",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60090",
    "cica_primarycontactlastname": "Duby",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/27/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Duby"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Qiana",
    "id": "634962c2-9b0d-11e8-adc4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143784039",
    "cica_calltype": "Business",
    "cica_businessaddress": "14 Metropolitan Oval Apt Tc",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Qiana",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT HW",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60091",
    "cica_primarycontactlastname": "Overcash",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/16/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Overcash"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "OFF SHORE RESTUARANT",
    "cica_primarycontactfirstname": "Mabel",
    "id": "63496b3d-9b0d-11e8-bea2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147477579",
    "cica_calltype": "Business",
    "cica_businessaddress": "2531 38th St Apt 9",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mabel",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "TCHR",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60092",
    "cica_primarycontactlastname": "Crabtree",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/23/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Crabtree"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "DELFINA SALON",
    "cica_primarycontactfirstname": "Eveline",
    "id": "63497507-9b0d-11e8-9d54-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149390023",
    "cica_calltype": "Business",
    "cica_businessaddress": "9138 75th St",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Eveline",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "HSWF",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60093",
    "cica_primarycontactlastname": "Oswald",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/7/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Oswald"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NEW YORK CITY SOCIAL SERVICES",
    "cica_primarycontactfirstname": "Rosina",
    "id": "63497e38-9b0d-11e8-92e1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148158994",
    "cica_calltype": "Business",
    "cica_businessaddress": "17014 130th Ave Apt 7G",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosina",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "OWNER",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859732921",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60094",
    "cica_primarycontactlastname": "Dougherty",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/4/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dougherty"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BROOKDALE",
    "cica_primarycontactfirstname": "Sherie",
    "id": "634986d9-9b0d-11e8-ba8a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9145572247",
    "cica_calltype": "Business",
    "cica_businessaddress": "189 Quincy St Unit 1",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sherie",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OWNER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859683923",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60095",
    "cica_primarycontactlastname": "Hitchings",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/27/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hitchings"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SARAH LIGERIE",
    "cica_primarycontactfirstname": "Zulma",
    "id": "63498f68-9b0d-11e8-bcc2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144818408",
    "cica_calltype": "Business",
    "cica_businessaddress": "15706 86th St",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Zulma",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CUSTODIAN",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5859683923",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60096",
    "cica_primarycontactlastname": "Fassett",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/20/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fassett"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SARAS LINGERIE",
    "cica_primarycontactfirstname": "Anh",
    "id": "63499800-9b0d-11e8-9d12-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148158994",
    "cica_calltype": "Business",
    "cica_businessaddress": "114 Holbrook Rd",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Anh",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "DRIVER",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5855678090",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60097",
    "cica_primarycontactlastname": "Shatley",
    "cica_residentialphone": "NA",
    "cica_fdif": "5/7/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shatley"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD 79 PCT",
    "cica_primarycontactfirstname": "Vi",
    "id": "6349a08f-9b0d-11e8-8850-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147230882",
    "cica_calltype": "Business",
    "cica_businessaddress": "36 Johnsontown Rd",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vi",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "53-3030 03",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5855678090",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60098",
    "cica_primarycontactlastname": "Bombard",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/6/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bombard"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD 79 PCT",
    "cica_primarycontactfirstname": "Edison",
    "id": "6349a91c-9b0d-11e8-9819-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147230882",
    "cica_calltype": "Business",
    "cica_businessaddress": "3801 Hudson Manor Ter Apt 2L",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Edison",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "OWNER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5852980871",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60099",
    "cica_primarycontactlastname": "Royster",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/14/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Royster"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "PS98 SSD",
    "cica_primarycontactfirstname": "Taunya",
    "id": "6349b197-9b0d-11e8-92b9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147238770",
    "cica_calltype": "Business",
    "cica_businessaddress": "39 Amethyst St",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Taunya",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "TEACHERS A",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60100",
    "cica_primarycontactlastname": "Klann",
    "cica_residentialphone": "NA",
    "cica_fdif": "3/15/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Klann"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD QSTF",
    "cica_primarycontactfirstname": "Thad",
    "id": "6349ba0f-9b0d-11e8-ae80-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146033344",
    "cica_calltype": "Business",
    "cica_businessaddress": "15 Fort Pl",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Thad",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OFFC MGR",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60101",
    "cica_primarycontactlastname": "Balzer",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/25/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Balzer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "CHEZ LUI UNISEX",
    "cica_primarycontactfirstname": "Danny",
    "id": "6349c28a-9b0d-11e8-b16f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143820993",
    "cica_calltype": "Business",
    "cica_businessaddress": "15 Fort Pl",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Danny",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "SANITATION",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60102",
    "cica_primarycontactlastname": "Booher",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/18/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Booher"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "B & M AUTO",
    "cica_primarycontactfirstname": "Milford",
    "id": "6349cafa-9b0d-11e8-9375-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "3478437939",
    "cica_calltype": "Business",
    "cica_businessaddress": "69 Birch Rd",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Milford",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60103",
    "cica_primarycontactlastname": "Valenti",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/26/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Valenti"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "COLER HOSPITAL",
    "cica_primarycontactfirstname": "Minnie",
    "id": "6349d37d-9b0d-11e8-8a32-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143320935",
    "cica_calltype": "Business",
    "cica_businessaddress": "85 Marine Way",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Minnie",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWNER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60104",
    "cica_primarycontactlastname": "Brunton",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/21/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Brunton"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD POLICE ACADEMY",
    "cica_primarycontactfirstname": "Glinda",
    "id": "6349dc0c-9b0d-11e8-a798-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9146312030",
    "cica_calltype": "Business",
    "cica_businessaddress": "105 Lamport Blvd",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Glinda",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "STUDENT",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60105",
    "cica_primarycontactlastname": "Laxson",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/6/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Laxson"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MAIMONIDES MEDICAL CENTER",
    "cica_primarycontactfirstname": "Sandra",
    "id": "6349e485-9b0d-11e8-a49b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149976018",
    "cica_calltype": "Business",
    "cica_businessaddress": "37 Barclay Cir",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sandra",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "STUDENT",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60106",
    "cica_primarycontactlastname": "Cabral",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/9/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cabral"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD TD 32",
    "cica_primarycontactfirstname": "Melina",
    "id": "6349ed8c-9b0d-11e8-8a1c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149976018",
    "cica_calltype": "Business",
    "cica_businessaddress": "118 Bay Ter",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Melina",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60107",
    "cica_primarycontactlastname": "Peraza",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/11/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Peraza"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SHINDA MGMT CORP",
    "cica_primarycontactfirstname": "Hermine",
    "id": "6349f6a6-9b0d-11e8-8fea-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144093253",
    "cica_calltype": "Business",
    "cica_businessaddress": "42 E Augusta Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hermine",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "CPA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60108",
    "cica_primarycontactlastname": "Hornback",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/1/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hornback"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "AFFORDABLE HOUSING REALTY",
    "cica_primarycontactfirstname": "Anibal",
    "id": "6349ff35-9b0d-11e8-8c47-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149970316",
    "cica_calltype": "Business",
    "cica_businessaddress": "42 E Augusta Ave",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Anibal",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "EMS",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60109",
    "cica_primarycontactlastname": "Nowakowski",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/24/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nowakowski"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "AFFORDABLE HOUSING",
    "cica_primarycontactfirstname": "Tricia",
    "id": "634a07b8-9b0d-11e8-8800-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142621151",
    "cica_calltype": "Business",
    "cica_businessaddress": "331 Powell St",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tricia",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "BUS OPER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60110",
    "cica_primarycontactlastname": "Quintal",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/8/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Quintal"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BROOKLYN MEDICAL CENTER",
    "cica_primarycontactfirstname": "Bertha",
    "id": "634a1030-9b0d-11e8-93d7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149970316",
    "cica_calltype": "Business",
    "cica_businessaddress": "74 W Castor Pl",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bertha",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "MECHANIC",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60111",
    "cica_primarycontactlastname": "Gales",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/10/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gales"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEHI",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD 67 PCT",
    "cica_primarycontactfirstname": "Kirstin",
    "id": "634a18fa-9b0d-11e8-ba61-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9147616031",
    "cica_calltype": "Business",
    "cica_businessaddress": "74 Beechwood Pl",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kirstin",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "MD7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "SERVER",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60112",
    "cica_primarycontactlastname": "Mcgee",
    "cica_residentialphone": "NA",
    "cica_fdif": "1/2/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcgee"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "37TH PRECINT",
    "cica_primarycontactfirstname": "Faith",
    "id": "634a22e6-9b0d-11e8-bc43-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149494340",
    "cica_calltype": "Business",
    "cica_businessaddress": "PO Box 146",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Faith",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CNA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60113",
    "cica_primarycontactlastname": "Thornhill",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/3/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Thornhill"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "EURO STYLE DESIGNS CORP",
    "cica_primarycontactfirstname": "Keturah",
    "id": "634a3257-9b0d-11e8-b6e7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144237290",
    "cica_calltype": "Business",
    "cica_businessaddress": "39 N 9th Ave",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Keturah",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "MANAGER",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60114",
    "cica_primarycontactlastname": "Giberson",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/2/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Giberson"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "J.",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "SANITATION BK 5",
    "cica_primarycontactfirstname": "Nelia",
    "id": "634a423a-9b0d-11e8-927d-34363bd2a970",
    "cica_primarycontactmiddlename": "J.",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9148374935",
    "cica_calltype": "Business",
    "cica_businessaddress": "39 N 9th Ave",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nelia",
    "cica_businesscity": "Aroundes",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "TRK DRIVER",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60115",
    "cica_primarycontactlastname": "Rau",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/25/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rau"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Rosio",
    "id": "634a4f02-9b0d-11e8-bc3f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144764141",
    "cica_calltype": "Business",
    "cica_businessaddress": "100 Erskine Pl Apt 13A",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosio",
    "cica_businesscity": "Golf",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "OWNR",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60116",
    "cica_primarycontactlastname": "Lykins",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/21/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lykins"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MDC",
    "cica_primarycontactfirstname": "Romelia",
    "id": "634a5d61-9b0d-11e8-8175-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144764141",
    "cica_calltype": "Business",
    "cica_businessaddress": "1783 Undercliff Ave",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Romelia",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "STUDENT",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60117",
    "cica_primarycontactlastname": "Hendrix",
    "cica_residentialphone": "NA",
    "cica_fdif": "4/19/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hendrix"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "A BETTER WORLD REALTY CORP",
    "cica_primarycontactfirstname": "Yadira",
    "id": "634a66f3-9b0d-11e8-b0b7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144764141",
    "cica_calltype": "Business",
    "cica_businessaddress": "586 Beck St Fl 2",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Yadira",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "TELLER",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60118",
    "cica_primarycontactlastname": "Stotts",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/24/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stotts"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD TD 33",
    "cica_primarycontactfirstname": "Corrine",
    "id": "634a7021-9b0d-11e8-97e2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9149439243",
    "cica_calltype": "Business",
    "cica_businessaddress": "222 Bedford Park Blvd Apt 6F",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Corrine",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "60119",
    "cica_primarycontactlastname": "Sallee",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/6/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sallee"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NAZKE TAX SERVICES",
    "cica_primarycontactfirstname": "Sheila",
    "id": "634a7926-9b0d-11e8-98ae-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142610432",
    "cica_calltype": "Business",
    "cica_businessaddress": "1224 Prospect Ave Apt 6H",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sheila",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "MECH",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60120",
    "cica_primarycontactlastname": "Barcelo",
    "cica_residentialphone": "NA",
    "cica_fdif": "10/11/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Barcelo"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "BROOKLYN HOSPITAL",
    "cica_primarycontactfirstname": "Piedad",
    "id": "634a8205-9b0d-11e8-8b16-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143751496",
    "cica_calltype": "Business",
    "cica_businessaddress": "1172 E Tremont Ave Apt 4D",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Piedad",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "CNA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60121",
    "cica_primarycontactlastname": "Dora",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/13/2016",
    "cica_residentialaddress": "NA",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dora"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NY TRANSIT BUS",
    "cica_primarycontactfirstname": "Kerrie",
    "id": "634a8b4a-9b0d-11e8-9e81-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144947063",
    "cica_calltype": "Business",
    "cica_businessaddress": "145 Lexington Ave",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kerrie",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "STU",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60122",
    "cica_primarycontactlastname": "Stamant",
    "cica_residentialphone": "NA",
    "cica_fdif": "2/14/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stamant"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYSD",
    "cica_primarycontactfirstname": "Vanna",
    "id": "634a9570-9b0d-11e8-a90c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144947063",
    "cica_calltype": "Business",
    "cica_businessaddress": "145 Lexington Ave",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vanna",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "STUDENT",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60123",
    "cica_primarycontactlastname": "Kirker",
    "cica_residentialphone": "NA",
    "cica_fdif": "6/22/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kirker"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MTA",
    "cica_primarycontactfirstname": "Emerson",
    "id": "634a9e6b-9b0d-11e8-a45d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143751496",
    "cica_calltype": "Business",
    "cica_businessaddress": "1945 Vyse Ave Apt 6E",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Emerson",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "STUDENT",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Rolland",
    "cica_residentialphone": "NA",
    "cica_fdif": "7/19/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rolland"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "IKEA DEPT STORE",
    "cica_primarycontactfirstname": "Delphia",
    "id": "634aa754-9b0d-11e8-8d47-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9144203211",
    "cica_calltype": "Business",
    "cica_businessaddress": "854 Fairmount Pl",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delphia",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "OWNER",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Skiles",
    "cica_residentialphone": "NA",
    "cica_fdif": "9/24/2018",
    "cica_residentialaddress": "NA",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Skiles"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "NYPD",
    "cica_primarycontactfirstname": "Micah",
    "id": "634ab030-9b0d-11e8-9081-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9143753172",
    "cica_calltype": "Business",
    "cica_businessaddress": "2340 Broadway Apt 2B",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Micah",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "BKKPR",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Prasad",
    "cica_residentialphone": "NA",
    "cica_fdif": "11/9/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Prasad"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BINL",
    "cica_residentialaddresscity": "NA",
    "cica_businessname": "MT SINAI BETH ISRAEL",
    "cica_primarycontactfirstname": "Simon",
    "id": "634ab905-9b0d-11e8-9a83-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "NA",
    "cica_businessphone": "9142611116",
    "cica_calltype": "Business",
    "cica_businessaddress": "1936 E Tremont Ave Apt 1B",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Simon",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "RT SALES",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "NA",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent18",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Coulston",
    "cica_residentialphone": "NA",
    "cica_fdif": "8/19/2017",
    "cica_residentialaddress": "NA",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Coulston"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Leonardo",
    "id": "634ac1ba-9b0d-11e8-9161-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Leonardo",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Milone",
    "cica_residentialphone": "9144475793",
    "cica_fdif": "3/27/2018",
    "cica_residentialaddress": "1936 E Tremont Ave Apt 1B",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Milone"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jenette",
    "id": "634aca7d-9b0d-11e8-ad9c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jenette",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Vanderford",
    "cica_residentialphone": "9143766016",
    "cica_fdif": "6/15/2017",
    "cica_residentialaddress": "3055 Decatur Ave Apt 5H",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vanderford"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gaynell",
    "id": "634ad347-9b0d-11e8-86d1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gaynell",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Saleem",
    "cica_residentialphone": "9143766016",
    "cica_fdif": "10/28/2017",
    "cica_residentialaddress": "3150 Bailey Ave Apt 5B",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Saleem"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Merissa",
    "id": "634adc1c-9b0d-11e8-9184-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Merissa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cranor",
    "cica_residentialphone": "9143766016",
    "cica_fdif": "2/5/2018",
    "cica_residentialaddress": "4425 Mundy Ln Apt 4",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cranor"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Zana",
    "id": "634ae4e3-9b0d-11e8-861e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Zana",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pekar",
    "cica_residentialphone": "9148044167",
    "cica_fdif": "4/27/2017",
    "cica_residentialaddress": "687 E 232nd St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pekar"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Eugenio",
    "id": "634aeda3-9b0d-11e8-8f52-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Eugenio",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Fraizer",
    "cica_residentialphone": "9149652722",
    "cica_fdif": "8/8/2017",
    "cica_residentialaddress": "855 E 233rd St Apt 12H",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fraizer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kristen",
    "id": "634af659-9b0d-11e8-9197-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kristen",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Motto",
    "cica_residentialphone": "9144237928",
    "cica_fdif": "5/5/2018",
    "cica_residentialaddress": "855 E 233rd St Apt 12H",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Motto"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gudrun",
    "id": "634aff23-9b0d-11e8-8b9f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gudrun",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dearman",
    "cica_residentialphone": "9144237928",
    "cica_fdif": "10/4/2016",
    "cica_residentialaddress": "780 Concourse Vlg W Apt 5F",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dearman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lorita",
    "id": "634b07e3-9b0d-11e8-a79c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lorita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Merle",
    "cica_residentialphone": "9149693895",
    "cica_fdif": "3/20/2017",
    "cica_residentialaddress": "1845 Hobart Ave Apt 1C",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Merle"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nakia",
    "id": "634b10c0-9b0d-11e8-b32f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nakia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bomar",
    "cica_residentialphone": "9142027291",
    "cica_fdif": "4/5/2016",
    "cica_residentialaddress": "733 E 216th St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bomar"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Yolanda",
    "id": "634b1994-9b0d-11e8-85cb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Yolanda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bartlett",
    "cica_residentialphone": "9147142565",
    "cica_fdif": "4/17/2016",
    "cica_residentialaddress": "657B Rosewood St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bartlett"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Meri",
    "id": "634b2257-9b0d-11e8-9e2d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Meri",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Littell",
    "cica_residentialphone": "9147142565",
    "cica_fdif": "4/22/2018",
    "cica_residentialaddress": "790 Astor Ave Apt 2A",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Littell"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dorthey",
    "id": "634b2b21-9b0d-11e8-a043-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dorthey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Brinkmann",
    "cica_residentialphone": "9147938804",
    "cica_fdif": "4/26/2016",
    "cica_residentialaddress": "963 E 217th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Brinkmann"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Vincent",
    "id": "634b3411-9b0d-11e8-9e3b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vincent",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lingo",
    "cica_residentialphone": "9147931831",
    "cica_fdif": "10/14/2016",
    "cica_residentialaddress": "1157 E 221st St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lingo"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Majorie",
    "id": "634b3f02-9b0d-11e8-a7bb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Majorie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Maker",
    "cica_residentialphone": "9144240520",
    "cica_fdif": "5/8/2018",
    "cica_residentialaddress": "3312 Edson Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Maker"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Antionette",
    "id": "634b4811-9b0d-11e8-aac0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Antionette",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Obyrne",
    "cica_residentialphone": "9148049743",
    "cica_fdif": "11/9/2016",
    "cica_residentialaddress": "3424 Gunther Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Obyrne"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maple",
    "id": "634b50f0-9b0d-11e8-8bb1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maple",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Klimas",
    "cica_residentialphone": "9149613572",
    "cica_fdif": "4/8/2018",
    "cica_residentialaddress": "3424 Gunther Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Klimas"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Chanel",
    "id": "634b59c5-9b0d-11e8-930c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Chanel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hinchman",
    "cica_residentialphone": "9149611706",
    "cica_fdif": "11/19/2018",
    "cica_residentialaddress": "2919 Kingsland Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hinchman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lashawn",
    "id": "634b628c-9b0d-11e8-b201-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lashawn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tunnell",
    "cica_residentialphone": "9145765456",
    "cica_fdif": "8/15/2017",
    "cica_residentialaddress": "2931 Tenbroeck Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tunnell"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jenee",
    "id": "634b6b57-9b0d-11e8-b14f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jenee",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bucy",
    "cica_residentialphone": "9145924683",
    "cica_fdif": "4/12/2018",
    "cica_residentialaddress": "2393 Morgan Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bucy"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Orville",
    "id": "634b7435-9b0d-11e8-b0fd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Orville",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ewin",
    "cica_residentialphone": "9145924683",
    "cica_fdif": "4/21/2016",
    "cica_residentialaddress": "2563 Kingsland Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ewin"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Salley",
    "id": "634b7d14-9b0d-11e8-925f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Salley",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Harring",
    "cica_residentialphone": "9174037641",
    "cica_fdif": "10/23/2018",
    "cica_residentialaddress": "2563 Kingsland Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Harring"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Laquita",
    "id": "634b8687-9b0d-11e8-a63b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Laquita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pitman",
    "cica_residentialphone": "8453622038",
    "cica_fdif": "10/26/2016",
    "cica_residentialaddress": "2563 Kingsland Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pitman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BIIS",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rosie",
    "id": "634b9311-9b0d-11e8-b614-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC7",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent23",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sugg",
    "cica_residentialphone": "5169034978",
    "cica_fdif": "5/24/2018",
    "cica_residentialaddress": "2424 Kingsland Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sugg"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Vesta",
    "id": "634b9c5e-9b0d-11e8-ae19-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vesta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pentecost",
    "cica_residentialphone": "8459208647",
    "cica_fdif": "2/27/2018",
    "cica_residentialaddress": "3555 Bivona St Apt 15E",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pentecost"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hayden",
    "id": "634ba563-9b0d-11e8-9808-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hayden",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bornstein",
    "cica_residentialphone": "8453684736",
    "cica_fdif": "3/13/2017",
    "cica_residentialaddress": "3410 De Reimer Ave Apt 10A",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bornstein"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Milagros",
    "id": "634bae54-9b0d-11e8-b9fd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Milagros",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Moon",
    "cica_residentialphone": "8453684736",
    "cica_fdif": "4/26/2016",
    "cica_residentialaddress": "53 Trolley Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Moon"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Allie",
    "id": "634bb733-9b0d-11e8-a031-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Allie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Babcock",
    "cica_residentialphone": "8453684736",
    "cica_fdif": "5/18/2018",
    "cica_residentialaddress": "18 Tompkins Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Babcock"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marisol",
    "id": "634bc13d-9b0d-11e8-aac8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marisol",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Veatch",
    "cica_residentialphone": "8453684736",
    "cica_fdif": "7/12/2016",
    "cica_residentialaddress": "176 Tate Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Veatch"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Margrett",
    "id": "634bcaee-9b0d-11e8-99da-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Margrett",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ziolkowski",
    "cica_residentialphone": "8453653280",
    "cica_fdif": "2/23/2016",
    "cica_residentialaddress": "176 Tate Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ziolkowski"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gracie",
    "id": "634bd445-9b0d-11e8-9616-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gracie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Whatley",
    "cica_residentialphone": "8453653280",
    "cica_fdif": "9/27/2017",
    "cica_residentialaddress": "814 Penfield St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Whatley"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Demetra",
    "id": "634bdd8f-9b0d-11e8-8b3f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Demetra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ellsworth",
    "cica_residentialphone": "8453653280",
    "cica_fdif": "5/11/2016",
    "cica_residentialaddress": "146 Grand St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ellsworth"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kristie",
    "id": "634be6e6-9b0d-11e8-857c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kristie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Benningfield",
    "cica_residentialphone": "8453653280",
    "cica_fdif": "6/22/2017",
    "cica_residentialaddress": "22 S Washington Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Benningfield"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Serita",
    "id": "634bf04f-9b0d-11e8-bb7e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Serita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Aumann",
    "cica_residentialphone": "8453534195",
    "cica_fdif": "9/23/2018",
    "cica_residentialaddress": "376 Saw Mill River Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Aumann"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Breanna",
    "id": "634bf92e-9b0d-11e8-bd54-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Breanna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Smelser",
    "cica_residentialphone": "8459420911",
    "cica_fdif": "2/17/2018",
    "cica_residentialaddress": "376 Saw Mill River Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Smelser"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jude",
    "id": "634c02a3-9b0d-11e8-8ea6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jude",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Depaz",
    "cica_residentialphone": "8459420911",
    "cica_fdif": "3/7/2017",
    "cica_residentialaddress": "206 Winthrop Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Depaz"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kieth",
    "id": "634c0c02-9b0d-11e8-a8b4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kieth",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Nephew",
    "cica_residentialphone": "8453523761",
    "cica_fdif": "9/20/2018",
    "cica_residentialaddress": "212 Endicott Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nephew"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Trinidad",
    "id": "634c1559-9b0d-11e8-b166-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Trinidad",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Strackbein",
    "cica_residentialphone": "8453522183",
    "cica_fdif": "1/16/2016",
    "cica_residentialaddress": "325 Knollwood Road Ext",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Strackbein"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Annamaria",
    "id": "634c1f07-9b0d-11e8-b53f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Annamaria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Oman",
    "cica_residentialphone": "8456276249",
    "cica_fdif": "8/14/2017",
    "cica_residentialaddress": "87 Putnam Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Oman"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tabetha",
    "id": "634c2873-9b0d-11e8-b3df-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "222 Bedford Park Blvd Apt 6F",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tabetha",
    "cica_businesscity": "Weekio",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60117",
    "cica_primarycontactlastname": "Hopple",
    "cica_residentialphone": "8452159209",
    "cica_fdif": "8/14/2018",
    "cica_residentialaddress": "88 Webster Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hopple"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Janella",
    "id": "634c31bd-9b0d-11e8-bb9b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "1224 Prospect Ave Apt 6H",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Janella",
    "cica_businesscity": "Kankakee",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60118",
    "cica_primarycontactlastname": "Hott",
    "cica_residentialphone": "8457125191",
    "cica_fdif": "2/20/2017",
    "cica_residentialaddress": "60 Haines Blvd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hott"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Enrique",
    "id": "634c3b11-9b0d-11e8-86e1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "1172 E Tremont Ave Apt 4D",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Enrique",
    "cica_businesscity": "Easy Loft",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60119",
    "cica_primarycontactlastname": "Nave",
    "cica_residentialphone": "8457125191",
    "cica_fdif": "8/1/2017",
    "cica_residentialaddress": "60 Haines Blvd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nave"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Anton",
    "id": "634c4454-9b0d-11e8-9eb8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "145 Lexington Ave",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Anton",
    "cica_businesscity": "Springfield",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60120",
    "cica_primarycontactlastname": "Jaillet",
    "cica_residentialphone": "8455362381",
    "cica_fdif": "3/19/2018",
    "cica_residentialaddress": "69 Hancock Pl",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jaillet"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lupita",
    "id": "634c4d8c-9b0d-11e8-b2ed-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "145 Lexington Ave",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lupita",
    "cica_businesscity": "Easterville",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60121",
    "cica_primarycontactlastname": "Kulesza",
    "cica_residentialphone": "8458211081",
    "cica_fdif": "9/20/2017",
    "cica_residentialaddress": "1505 Halstead Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kulesza"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lorraine",
    "id": "634c56cf-9b0d-11e8-990f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "1945 Vyse Ave Apt 6E",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lorraine",
    "cica_businesscity": "Souttown",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60122",
    "cica_primarycontactlastname": "Arenas",
    "cica_residentialphone": "8458211081",
    "cica_fdif": "3/26/2016",
    "cica_residentialaddress": "1505 Halstead Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Arenas"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Robyn",
    "id": "634c5ffd-9b0d-11e8-83ab-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "854 Fairmount Pl",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Robyn",
    "cica_businesscity": "East Lake",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60123",
    "cica_primarycontactlastname": "Boulware",
    "cica_residentialphone": "6464981312",
    "cica_fdif": "8/18/2018",
    "cica_residentialaddress": "1505 Halstead Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Boulware"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joie",
    "id": "634c6940-9b0d-11e8-8fca-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "2340 Broadway Apt 2B",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joie",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60084",
    "cica_primarycontactlastname": "Beaumont",
    "cica_residentialphone": "6464981312",
    "cica_fdif": "10/4/2017",
    "cica_residentialaddress": "500 Saw Mill River Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Beaumont"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cathleen",
    "id": "634c71f5-9b0d-11e8-8fe0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "1936 E Tremont Ave Apt 1B",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cathleen",
    "cica_businesscity": "Lisle",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "60085",
    "cica_primarycontactlastname": "Devries",
    "cica_residentialphone": "8453710952",
    "cica_fdif": "8/2/2016",
    "cica_residentialaddress": "500 Saw Mill River Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Devries"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Meredith",
    "id": "634c7aab-9b0d-11e8-9e5c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "78 Springville Rd",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Meredith",
    "cica_businesscity": "Wheaton",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60086",
    "cica_primarycontactlastname": "Trahan",
    "cica_residentialphone": "8453525011",
    "cica_fdif": "11/11/2016",
    "cica_residentialaddress": "500 Saw Mill River Rd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Trahan"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elliott",
    "id": "634c8380-9b0d-11e8-a227-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "78 Springville Rd",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elliott",
    "cica_businesscity": "Glenview",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60087",
    "cica_primarycontactlastname": "Grandison",
    "cica_residentialphone": "8453525011",
    "cica_fdif": "6/22/2017",
    "cica_residentialaddress": "220 N Terrace Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Grandison"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rosamond",
    "id": "634c8c35-9b0d-11e8-9569-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "299 Monroe Dr",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosamond",
    "cica_businesscity": "Chicago",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60088",
    "cica_primarycontactlastname": "Ribble",
    "cica_residentialphone": "8453569233",
    "cica_fdif": "6/15/2017",
    "cica_residentialaddress": "62 New Castle Dr",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ribble"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ali",
    "id": "634c9500-9b0d-11e8-9538-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "299 Monroe Dr",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ali",
    "cica_businesscity": "Morton Grove",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60089",
    "cica_primarycontactlastname": "Newborn",
    "cica_residentialphone": "8459475540",
    "cica_fdif": "10/3/2016",
    "cica_residentialaddress": "62 New Castle Dr",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Newborn"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kiyoko",
    "id": "634c9db5-9b0d-11e8-b2f0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "54 Newtown Rd",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kiyoko",
    "cica_businesscity": "Chester",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60090",
    "cica_primarycontactlastname": "Guilbault",
    "cica_residentialphone": "8459475540",
    "cica_fdif": "8/28/2017",
    "cica_residentialaddress": "62 New Castle Dr",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Guilbault"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shanae",
    "id": "634ca717-9b0d-11e8-a205-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "355 Randall Rd",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shanae",
    "cica_businesscity": "Chesterfield",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60091",
    "cica_primarycontactlastname": "Midgett",
    "cica_residentialphone": "8452693355",
    "cica_fdif": "2/2/2018",
    "cica_residentialaddress": "62 New Castle Dr",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Midgett"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Janet",
    "id": "634cb007-9b0d-11e8-b01c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "131 W End Ave",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Janet",
    "cica_businesscity": "East City",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60092",
    "cica_primarycontactlastname": "Costello",
    "cica_residentialphone": "7182798255",
    "cica_fdif": "3/23/2018",
    "cica_residentialaddress": "19 Harrison St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Costello"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "So",
    "id": "634cb95e-9b0d-11e8-8239-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "28 Middle Line Hwy",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "So",
    "cica_businesscity": "Northbrook",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60093",
    "cica_primarycontactlastname": "Forsberg",
    "cica_residentialphone": "7182798255",
    "cica_fdif": "2/12/2018",
    "cica_residentialaddress": "34 Clinton Pl",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Forsberg"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cherry",
    "id": "634cc1cf-9b0d-11e8-b3e3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "534 N Magee St",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cherry",
    "cica_businesscity": "North City",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "IL",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "60094",
    "cica_primarycontactlastname": "Partain",
    "cica_residentialphone": "5162702531",
    "cica_fdif": "9/24/2016",
    "cica_residentialaddress": "1041 E 227th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Partain"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Wilhelmina",
    "id": "634cca3d-9b0d-11e8-96de-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Wilhelmina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Krehbiel",
    "cica_residentialphone": "5167802931",
    "cica_fdif": "9/1/2016",
    "cica_residentialaddress": "29 W Sidney Ave Apt 6N",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Krehbiel"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Melvin",
    "id": "634cd2c2-9b0d-11e8-a35f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Melvin",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pricer",
    "cica_residentialphone": "5164248760",
    "cica_fdif": "4/26/2018",
    "cica_residentialaddress": "154 S 4th Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pricer"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Louetta",
    "id": "634cdb45-9b0d-11e8-aeb3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Louetta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kaufman",
    "cica_residentialphone": "5168590091",
    "cica_fdif": "2/19/2018",
    "cica_residentialaddress": "313 S 6th Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kaufman"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sarita",
    "id": "634ce3ab-9b0d-11e8-a7ec-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sarita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bentz",
    "cica_residentialphone": "5613967176",
    "cica_fdif": "3/6/2016",
    "cica_residentialaddress": "322 S 6th Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bentz"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marvin",
    "id": "634cec2e-9b0d-11e8-933e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marvin",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Crandle",
    "cica_residentialphone": "5167359178",
    "cica_fdif": "11/28/2017",
    "cica_residentialaddress": "468 S 4th Ave Unit 108",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Crandle"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Clifton",
    "id": "634cf4b5-9b0d-11e8-8bff-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Clifton",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bucy",
    "cica_residentialphone": "5165614520",
    "cica_fdif": "9/26/2017",
    "cica_residentialaddress": "3 Irving Pl",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bucy"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Antonette",
    "id": "634cfd42-9b0d-11e8-a571-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Antonette",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cashman",
    "cica_residentialphone": "9173711381",
    "cica_fdif": "10/5/2017",
    "cica_residentialaddress": "3 Irving Pl",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cashman"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ray",
    "id": "634d062b-9b0d-11e8-9251-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ray",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bitter",
    "cica_residentialphone": "5166122396",
    "cica_fdif": "6/21/2018",
    "cica_residentialaddress": "3 Irving Pl",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bitter"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Charisse",
    "id": "634d0ee8-9b0d-11e8-b189-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Charisse",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Eutsey",
    "cica_residentialphone": "5164820379",
    "cica_fdif": "1/2/2018",
    "cica_residentialaddress": "11 Tower Pl",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Eutsey"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Amira",
    "id": "634d1819-9b0d-11e8-b6a8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Amira",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Prickett",
    "cica_residentialphone": "5162481414",
    "cica_fdif": "1/18/2018",
    "cica_residentialaddress": "246 Sheridan Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Prickett"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Giovanni",
    "id": "634d21a8-9b0d-11e8-8f6c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Giovanni",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Borrego",
    "cica_residentialphone": "5162856737",
    "cica_fdif": "3/23/2017",
    "cica_residentialaddress": "250 Lorraine Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Borrego"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Diamond",
    "id": "634d2b78-9b0d-11e8-883c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Diamond",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Filler",
    "cica_residentialphone": "7182765197",
    "cica_fdif": "4/21/2018",
    "cica_residentialaddress": "185 Lorraine Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Filler"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Giuseppina",
    "id": "634d347d-9b0d-11e8-80ce-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Giuseppina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Clayborne",
    "cica_residentialphone": "7184909033",
    "cica_fdif": "3/8/2017",
    "cica_residentialaddress": "15 Oneida Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Clayborne"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Vicky",
    "id": "634d3d51-9b0d-11e8-9f16-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vicky",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Flanagan",
    "cica_residentialphone": "3475433599",
    "cica_fdif": "9/12/2018",
    "cica_residentialaddress": "15 Oneida Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Flanagan"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sharron",
    "id": "634d47e8-9b0d-11e8-855c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sharron",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mckeighan",
    "cica_residentialphone": "6466474441",
    "cica_fdif": "3/2/2016",
    "cica_residentialaddress": "25 Elliot St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mckeighan"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Orville",
    "id": "634d5170-9b0d-11e8-8d30-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Orville",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bruss",
    "cica_residentialphone": "7182270359",
    "cica_fdif": "7/27/2017",
    "cica_residentialaddress": "10802 220th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bruss"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Aldo",
    "id": "634d5ad1-9b0d-11e8-b379-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Aldo",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Frary",
    "cica_residentialphone": "7186191893",
    "cica_fdif": "9/10/2018",
    "cica_residentialaddress": "198 Bell Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Frary"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shea",
    "id": "634d63ca-9b0d-11e8-98dc-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shea",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Oshields",
    "cica_residentialphone": "7183234505",
    "cica_fdif": "11/15/2016",
    "cica_residentialaddress": "429 E 3rd St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Oshields"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cletus",
    "id": "634d6c51-9b0d-11e8-8ae3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cletus",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ridgley",
    "cica_residentialphone": "3475579147",
    "cica_fdif": "8/8/2016",
    "cica_residentialaddress": "429 E 3rd St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ridgley"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Demarcus",
    "id": "634d74d4-9b0d-11e8-8615-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Demarcus",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Goldsborough",
    "cica_residentialphone": "3476147239",
    "cica_fdif": "6/13/2017",
    "cica_residentialaddress": "40 Stonegate Rd",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Goldsborough"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lekisha",
    "id": "634d7d57-9b0d-11e8-94a3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lekisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Delahanty",
    "cica_residentialphone": "7188518982",
    "cica_fdif": "9/6/2016",
    "cica_residentialaddress": "40 Stonegate Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Delahanty"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marguerite",
    "id": "634d85f0-9b0d-11e8-bbe8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marguerite",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Capetillo",
    "cica_residentialphone": "7184524507",
    "cica_fdif": "8/3/2018",
    "cica_residentialaddress": "40 Stonegate Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Capetillo"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Reggie",
    "id": "634d8e68-9b0d-11e8-8871-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Reggie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Maxim",
    "cica_residentialphone": "3473515965",
    "cica_fdif": "2/15/2017",
    "cica_residentialaddress": "49 State St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Maxim"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sylvie",
    "id": "634d96e3-9b0d-11e8-b35b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sylvie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mayhue",
    "cica_residentialphone": "6318852300",
    "cica_fdif": "10/22/2016",
    "cica_residentialaddress": "1597 Crompond Rd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mayhue"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Solange",
    "id": "634d9f51-9b0d-11e8-ba01-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Solange",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Noecker",
    "cica_residentialphone": "3476628529",
    "cica_fdif": "10/3/2016",
    "cica_residentialaddress": "1597 Crompond Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Noecker"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hershel",
    "id": "634da7e1-9b0d-11e8-ac9c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hershel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lerma",
    "cica_residentialphone": "9176793742",
    "cica_fdif": "6/23/2016",
    "cica_residentialaddress": "1652 Boulevard",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lerma"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Clarence",
    "id": "634db066-9b0d-11e8-85cf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Clarence",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Leaf",
    "cica_residentialphone": "6467521395",
    "cica_fdif": "8/3/2018",
    "cica_residentialaddress": "209 Fremont St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Leaf"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kanisha",
    "id": "634db8de-9b0d-11e8-aeb3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kanisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mounsey",
    "cica_residentialphone": "3472400311",
    "cica_fdif": "10/23/2018",
    "cica_residentialaddress": "7 Scott Ln",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mounsey"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Neomi",
    "id": "634dc16e-9b0d-11e8-92da-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Neomi",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lindemann",
    "cica_residentialphone": "7182321353",
    "cica_fdif": "10/25/2016",
    "cica_residentialaddress": "7 Scott Ln",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lindemann"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lakisha",
    "id": "634dc9f0-9b0d-11e8-9ea5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lakisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cornwell",
    "cica_residentialphone": "7186983808",
    "cica_fdif": "3/20/2016",
    "cica_residentialaddress": "542 Westbrook Dr",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cornwell"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ester",
    "id": "634dd275-9b0d-11e8-a33f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ester",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Abarca",
    "cica_residentialphone": "7183143475",
    "cica_fdif": "6/2/2017",
    "cica_residentialaddress": "542 Westbrook Dr",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Abarca"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Alanna",
    "id": "634ddb02-9b0d-11e8-a16f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Alanna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Nobriga",
    "cica_residentialphone": "5162635790",
    "cica_fdif": "1/27/2017",
    "cica_residentialaddress": "625 Cardinal Rd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nobriga"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Yaeko",
    "id": "634de391-9b0d-11e8-80de-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Yaeko",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Guilbert",
    "cica_residentialphone": "7183425299",
    "cica_fdif": "2/3/2016",
    "cica_residentialaddress": "625 Cardinal Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Guilbert"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tuyet",
    "id": "634dec0c-9b0d-11e8-8118-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tuyet",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Madrid",
    "cica_residentialphone": "7182728814",
    "cica_fdif": "7/23/2017",
    "cica_residentialaddress": "133 Woodbrook Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Madrid"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Larissa",
    "id": "634df485-9b0d-11e8-8593-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Larissa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Plemmons",
    "cica_residentialphone": "3478254785",
    "cica_fdif": "5/1/2016",
    "cica_residentialaddress": "133 Woodbrook Rd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Plemmons"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tyson",
    "id": "634dfd00-9b0d-11e8-9f0d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tyson",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Longmire",
    "cica_residentialphone": "9175392854",
    "cica_fdif": "8/26/2017",
    "cica_residentialaddress": "74 Spring St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Longmire"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lacresha",
    "id": "634e0585-9b0d-11e8-8f36-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lacresha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mccown",
    "cica_residentialphone": "9175392854",
    "cica_fdif": "8/11/2017",
    "cica_residentialaddress": "74 Spring St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mccown"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jefferey",
    "id": "634e0df5-9b0d-11e8-988d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jefferey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Force",
    "cica_residentialphone": "7184216631",
    "cica_fdif": "5/13/2017",
    "cica_residentialaddress": "74 Spring St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Force"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lady",
    "id": "634e16ee-9b0d-11e8-bac4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lady",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gregoire",
    "cica_residentialphone": "7184216631",
    "cica_fdif": "4/28/2016",
    "cica_residentialaddress": "74 Spring St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gregoire"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Floria",
    "id": "634e1fb0-9b0d-11e8-873d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Floria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Zeiger",
    "cica_residentialphone": "7184197670",
    "cica_fdif": "6/15/2016",
    "cica_residentialaddress": "85 Brambach Rd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Zeiger"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Raymonde",
    "id": "634e286e-9b0d-11e8-91e1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Raymonde",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lamberti",
    "cica_residentialphone": "7183990950",
    "cica_fdif": "4/7/2018",
    "cica_residentialaddress": "85 Brambach Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lamberti"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Khadijah",
    "id": "634e320a-9b0d-11e8-bae5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Khadijah",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Wymore",
    "cica_residentialphone": "3476932331",
    "cica_fdif": "10/8/2016",
    "cica_residentialaddress": "21 Boulevard",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wymore"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Delois",
    "id": "634e3afd-9b0d-11e8-83c2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delois",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Eby",
    "cica_residentialphone": "5163510193",
    "cica_fdif": "4/26/2016",
    "cica_residentialaddress": "3839 Ettman St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Eby"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kelle",
    "id": "634e43bd-9b0d-11e8-855f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kelle",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Arneson",
    "cica_residentialphone": "7188512506",
    "cica_fdif": "9/12/2018",
    "cica_residentialaddress": "958 E Main St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Arneson"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elke",
    "id": "634e4c87-9b0d-11e8-9a96-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elke",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gelb",
    "cica_residentialphone": "7188512506",
    "cica_fdif": "5/20/2017",
    "cica_residentialaddress": "1108 Stonegate Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gelb"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lesa",
    "id": "634e5547-9b0d-11e8-971f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lesa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Draughn",
    "cica_residentialphone": "7186275384",
    "cica_fdif": "4/3/2016",
    "cica_residentialaddress": "35 Gordon Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Draughn"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Theodore",
    "id": "634e5dfd-9b0d-11e8-ad64-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Theodore",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gastelum",
    "cica_residentialphone": "3474231226",
    "cica_fdif": "11/4/2017",
    "cica_residentialaddress": "35 Gordon Ave # A",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gastelum"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Adelia",
    "id": "634e66b3-9b0d-11e8-9644-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Adelia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Israel",
    "cica_residentialphone": "7186801837",
    "cica_fdif": "2/12/2016",
    "cica_residentialaddress": "71 Storm St Apt 4B",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Israel"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Francesca",
    "id": "634e6f75-9b0d-11e8-937e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Francesca",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lyman",
    "cica_residentialphone": "3472779226",
    "cica_fdif": "6/12/2018",
    "cica_residentialaddress": "225 Jefferson Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lyman"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cassaundra",
    "id": "634e7828-9b0d-11e8-b7ea-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cassaundra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hungerford",
    "cica_residentialphone": "9178642201",
    "cica_fdif": "8/24/2018",
    "cica_residentialaddress": "225 Jefferson Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hungerford"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jazmin",
    "id": "634e80fd-9b0d-11e8-847e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jazmin",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Fife",
    "cica_residentialphone": "3477799832",
    "cica_fdif": "11/22/2018",
    "cica_residentialaddress": "2787 Strang Blvd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fife"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Takako",
    "id": "634e89a8-9b0d-11e8-b0f4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Takako",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pea",
    "cica_residentialphone": "6463608179",
    "cica_fdif": "7/24/2017",
    "cica_residentialaddress": "26 Stratford Rd",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pea"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Mackenzie",
    "id": "634e92a6-9b0d-11e8-8c2d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mackenzie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pero",
    "cica_residentialphone": "7187787662",
    "cica_fdif": "3/14/2016",
    "cica_residentialaddress": "26 Stratford Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pero"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Raul",
    "id": "634e9c11-9b0d-11e8-9b50-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Raul",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Culbreth",
    "cica_residentialphone": "7187787662",
    "cica_fdif": "8/25/2018",
    "cica_residentialaddress": "26 Stratford Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Culbreth"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Evan",
    "id": "634ea4e3-9b0d-11e8-8a3c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Evan",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Vandoren",
    "cica_residentialphone": "7187787662",
    "cica_fdif": "10/24/2018",
    "cica_residentialaddress": "133 Lakeview Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vandoren"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Holley",
    "id": "634ead99-9b0d-11e8-a076-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Holley",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rutz",
    "cica_residentialphone": "6786773078",
    "cica_fdif": "8/22/2017",
    "cica_residentialaddress": "8 Harrison St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rutz"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jacalyn",
    "id": "634eb645-9b0d-11e8-a987-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jacalyn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9147142565",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Aslinger",
    "cica_residentialphone": "3472047215",
    "cica_fdif": "7/14/2016",
    "cica_residentialaddress": "60 Highview Ter",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Aslinger"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jarred",
    "id": "634ebefa-9b0d-11e8-ada1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jarred",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9147142565",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Singletary",
    "cica_residentialphone": "3475819519",
    "cica_fdif": "7/28/2016",
    "cica_residentialaddress": "440 Warburton Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Singletary"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Stacia",
    "id": "634ec7c5-9b0d-11e8-8b61-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Stacia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9147938804",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kessinger",
    "cica_residentialphone": "6318288288",
    "cica_fdif": "10/7/2018",
    "cica_residentialaddress": "3 Howard Pl",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kessinger"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tamatha",
    "id": "634ed126-9b0d-11e8-9552-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tamatha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9147931831",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pavel",
    "cica_residentialphone": "6465088531",
    "cica_fdif": "5/1/2018",
    "cica_residentialaddress": "3 Howard Pl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pavel"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Boyd",
    "id": "634eda17-9b0d-11e8-b81f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Boyd",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9144240520",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Petro",
    "cica_residentialphone": "7187972799",
    "cica_fdif": "7/25/2016",
    "cica_residentialaddress": "3 Howard Pl",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Petro"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Genny",
    "id": "634ee2eb-9b0d-11e8-ae23-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Genny",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9148049743",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bergen",
    "cica_residentialphone": "5162085090",
    "cica_fdif": "2/1/2017",
    "cica_residentialaddress": "65 Shelley Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bergen"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Alecia",
    "id": "634eeba1-9b0d-11e8-9453-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Alecia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9149613572",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Savoy",
    "cica_residentialphone": "5185246427",
    "cica_fdif": "10/21/2017",
    "cica_residentialaddress": "1 Vincent Rd Apt 3P",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Savoy"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Stefanie",
    "id": "634ef475-9b0d-11e8-9ed3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Stefanie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9149611706",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Morriss",
    "cica_residentialphone": "3476934159",
    "cica_fdif": "6/12/2017",
    "cica_residentialaddress": "100 Columbus Ave Apt 6F",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Morriss"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Terrance",
    "id": "634efd35-9b0d-11e8-8ba9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Terrance",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9145765456",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hulett",
    "cica_residentialphone": "3476688067",
    "cica_fdif": "7/12/2017",
    "cica_residentialaddress": "184 Truman Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hulett"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Twanna",
    "id": "634f05d9-9b0d-11e8-bc3c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Twanna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9145924683",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ligon",
    "cica_residentialphone": "3476688067",
    "cica_fdif": "3/18/2017",
    "cica_residentialaddress": "184 Truman Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ligon"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hermine",
    "id": "634f0e97-9b0d-11e8-b920-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hermine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9145924683",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kaina",
    "cica_residentialphone": "7186924713",
    "cica_fdif": "3/6/2017",
    "cica_residentialaddress": "184 Truman Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kaina"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shavon",
    "id": "634f1759-9b0d-11e8-bdf2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shavon",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "9174037641",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mazzola",
    "cica_residentialphone": "7182588131",
    "cica_fdif": "7/24/2018",
    "cica_residentialaddress": "184 Truman Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mazzola"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nannie",
    "id": "634f2023-9b0d-11e8-aac4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nannie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "8453622038",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcgillis",
    "cica_residentialphone": "7183396809",
    "cica_fdif": "8/9/2018",
    "cica_residentialaddress": "6 Cascade Ter Apt 1D",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcgillis"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kenton",
    "id": "634f28e1-9b0d-11e8-adc7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kenton",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "5169034978",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Nussbaum",
    "cica_residentialphone": "3473378815",
    "cica_fdif": "8/14/2018",
    "cica_residentialaddress": "48 Hancock Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nussbaum"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Doria",
    "id": "634f31a3-9b0d-11e8-ac70-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Doria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sabbagh",
    "cica_residentialphone": "3474445020",
    "cica_fdif": "10/10/2016",
    "cica_residentialaddress": "138 Douglas Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sabbagh"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GBEJ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nedra",
    "id": "634f3a6b-9b0d-11e8-b8db-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nedra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "DM8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Roussel",
    "cica_residentialphone": "7189272182",
    "cica_fdif": "11/24/2017",
    "cica_residentialaddress": "341 Park Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Roussel"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gwenda",
    "id": "634f4323-9b0d-11e8-9925-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gwenda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kindell",
    "cica_residentialphone": "3474320351",
    "cica_fdif": "2/4/2016",
    "cica_residentialaddress": "771 Midland Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kindell"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Brigitte",
    "id": "634f4bd7-9b0d-11e8-8c20-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Brigitte",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Xie",
    "cica_residentialphone": "6464314333",
    "cica_fdif": "1/7/2018",
    "cica_residentialaddress": "771 Midland Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Xie"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Fransisca",
    "id": "634f5591-9b0d-11e8-9de7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Fransisca",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ricks",
    "cica_residentialphone": "3472684345",
    "cica_fdif": "7/13/2017",
    "cica_residentialaddress": "771 Midland Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ricks"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shemika",
    "id": "634f5e8c-9b0d-11e8-9dec-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shemika",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Stumpff",
    "cica_residentialphone": "9179152491",
    "cica_fdif": "5/18/2016",
    "cica_residentialaddress": "40 Huber Pl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stumpff"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cherryl",
    "id": "634f676b-9b0d-11e8-8f60-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cherryl",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cheers",
    "cica_residentialphone": "7183844331",
    "cica_fdif": "6/2/2018",
    "cica_residentialaddress": "33 Lindsey St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cheers"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tess",
    "id": "634f7040-9b0d-11e8-9ca3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tess",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Vesely",
    "cica_residentialphone": "6465993872",
    "cica_fdif": "2/12/2018",
    "cica_residentialaddress": "14 Sweetfield Cir Apt Mh",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vesely"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Carlie",
    "id": "634f7963-9b0d-11e8-993b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carlie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Marrero",
    "cica_residentialphone": "7184907091",
    "cica_fdif": "7/20/2017",
    "cica_residentialaddress": "14 Sweetfield Cir Apt Mh",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Marrero"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Laure",
    "id": "634f82eb-9b0d-11e8-93e8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Laure",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Anwar",
    "cica_residentialphone": "7186619848",
    "cica_fdif": "9/20/2018",
    "cica_residentialaddress": "210 Park Hill Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Anwar"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Phoebe",
    "id": "634f8c4c-9b0d-11e8-bb9c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Phoebe",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pastrana",
    "cica_residentialphone": "7186619848",
    "cica_fdif": "9/9/2016",
    "cica_residentialaddress": "204 Alta Vista Dr",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pastrana"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lakisha",
    "id": "634f95ab-9b0d-11e8-b8be-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lakisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dittrich",
    "cica_residentialphone": "5164666683",
    "cica_fdif": "9/6/2017",
    "cica_residentialaddress": "115 Pinecrest Pkwy",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dittrich"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ka",
    "id": "634f9ef5-9b0d-11e8-b742-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ka",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Macky",
    "cica_residentialphone": "9175755576",
    "cica_fdif": "1/1/2016",
    "cica_residentialaddress": "115 Pinecrest Pkwy",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Macky"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Verda",
    "id": "634fa857-9b0d-11e8-ac10-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Verda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hendrie",
    "cica_residentialphone": "7182240099",
    "cica_fdif": "1/9/2017",
    "cica_residentialaddress": "1 Oakridge Pl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hendrie"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dalton",
    "id": "634fb32b-9b0d-11e8-8d5f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dalton",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Chauncey",
    "cica_residentialphone": "3475360307",
    "cica_fdif": "8/24/2016",
    "cica_residentialaddress": "1 Oakridge Pl",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Chauncey"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bettina",
    "id": "634fbe2e-9b0d-11e8-bed6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bettina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Moll",
    "cica_residentialphone": "9146109831",
    "cica_fdif": "7/13/2018",
    "cica_residentialaddress": "53 Kathwood Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Moll"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ahmad",
    "id": "634fc797-9b0d-11e8-ac77-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ahmad",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mirabito",
    "cica_residentialphone": "2127290401",
    "cica_fdif": "4/16/2018",
    "cica_residentialaddress": "9 Danby Pl",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mirabito"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Zona",
    "id": "634fd121-9b0d-11e8-99c4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Zona",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Puentes",
    "cica_residentialphone": "6317906501",
    "cica_fdif": "2/21/2017",
    "cica_residentialaddress": "9 Danby Pl",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Puentes"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Trinidad",
    "id": "634fda9e-9b0d-11e8-b044-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Trinidad",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Loder",
    "cica_residentialphone": "5164209319",
    "cica_fdif": "11/2/2017",
    "cica_residentialaddress": "82 Roundhill Dr",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Loder"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Demetria",
    "id": "634fe373-9b0d-11e8-a9ca-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Demetria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Clore",
    "cica_residentialphone": "7186069367",
    "cica_fdif": "4/22/2018",
    "cica_residentialaddress": "82 Roundhill Dr",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Clore"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ressie",
    "id": "634fed17-9b0d-11e8-b2ac-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ressie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kornegay",
    "cica_residentialphone": "3472550844",
    "cica_fdif": "8/2/2017",
    "cica_residentialaddress": "150 Birchwood Close",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kornegay"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Taneka",
    "id": "634ff740-9b0d-11e8-8d40-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Taneka",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Magallon",
    "cica_residentialphone": "3476844983",
    "cica_fdif": "4/10/2018",
    "cica_residentialaddress": "71 Sedgwick Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Magallon"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Loyce",
    "id": "63500051-9b0d-11e8-a7d1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Loyce",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Barnette",
    "cica_residentialphone": "7187767642",
    "cica_fdif": "9/25/2018",
    "cica_residentialaddress": "1 Stonelea Pl Apt A10",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Barnette"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gail",
    "id": "63500b51-9b0d-11e8-aff6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gail",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Avent",
    "cica_residentialphone": "3475930816",
    "cica_fdif": "11/21/2018",
    "cica_residentialaddress": "7 Robbins Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Avent"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "EPWA",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sabina",
    "id": "63501702-9b0d-11e8-93c2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sabina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent19",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Beckley",
    "cica_residentialphone": "7187405525",
    "cica_fdif": "2/15/2018",
    "cica_residentialaddress": "7 Robbins Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Beckley"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ian",
    "id": "6350209c-9b0d-11e8-9fa6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ian",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Webb",
    "cica_residentialphone": "7187405525",
    "cica_fdif": "7/16/2018",
    "cica_residentialaddress": "40 Davenport Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Webb"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Chrissy",
    "id": "635029a3-9b0d-11e8-b2ee-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Chrissy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pellett",
    "cica_residentialphone": "3478697437",
    "cica_fdif": "5/22/2016",
    "cica_residentialaddress": "40 Davenport Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pellett"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jonell",
    "id": "63503423-9b0d-11e8-b511-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jonell",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sciortino",
    "cica_residentialphone": "7189498950",
    "cica_fdif": "8/27/2016",
    "cica_residentialaddress": "1 Cobblestone Farm Ct",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sciortino"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dario",
    "id": "6350409c-9b0d-11e8-89f3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dario",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bissonnette",
    "cica_residentialphone": "7189771350",
    "cica_fdif": "11/11/2018",
    "cica_residentialaddress": "1 Cobblestone Farm Ct",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bissonnette"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Yoshiko",
    "id": "63504e47-9b0d-11e8-a516-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Yoshiko",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Karls",
    "cica_residentialphone": "5169499674",
    "cica_fdif": "5/12/2016",
    "cica_residentialaddress": "61 Turner Rd",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Karls"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Charlie",
    "id": "63505b99-9b0d-11e8-b1be-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Charlie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hoffman",
    "cica_residentialphone": "7185280483",
    "cica_fdif": "5/10/2016",
    "cica_residentialaddress": "27A S Airmont Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hoffman"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jung",
    "id": "635064dc-9b0d-11e8-95d2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jung",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Munroe",
    "cica_residentialphone": "7185280366",
    "cica_fdif": "6/24/2017",
    "cica_residentialaddress": "27A S Airmont Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Munroe"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Danilo",
    "id": "6350701c-9b0d-11e8-86b3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Danilo",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Laskowski",
    "cica_residentialphone": "7182763299",
    "cica_fdif": "4/24/2016",
    "cica_residentialaddress": "27A S Airmont Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Laskowski"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Taryn",
    "id": "63507a59-9b0d-11e8-a953-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Taryn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mccomas",
    "cica_residentialphone": "7182763299",
    "cica_fdif": "3/9/2018",
    "cica_residentialaddress": "27A S Airmont Rd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mccomas"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shala",
    "id": "6350830f-9b0d-11e8-ac99-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shala",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Harris",
    "cica_residentialphone": "3474885897",
    "cica_fdif": "6/4/2018",
    "cica_residentialaddress": "39 Cobble Pl",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Harris"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tory",
    "id": "63508c82-9b0d-11e8-85ba-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tory",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Louder",
    "cica_residentialphone": "7185022075",
    "cica_fdif": "9/5/2016",
    "cica_residentialaddress": "39 Cobble Pl",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Louder"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elisabeth",
    "id": "63509523-9b0d-11e8-8997-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elisabeth",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Esser",
    "cica_residentialphone": "9176009130",
    "cica_fdif": "7/27/2017",
    "cica_residentialaddress": "39 Cobble Pl",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Esser"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Suzi",
    "id": "63509dbd-9b0d-11e8-8f0c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Suzi",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Stauber",
    "cica_residentialphone": "6464094277",
    "cica_fdif": "4/7/2017",
    "cica_residentialaddress": "39 Cobble Pl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stauber"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shawana",
    "id": "6350a6c2-9b0d-11e8-87ce-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shawana",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Stouffer",
    "cica_residentialphone": "6464094277",
    "cica_fdif": "7/1/2018",
    "cica_residentialaddress": "126 N Route 303 Unit 2",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stouffer"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kati",
    "id": "6350afdc-9b0d-11e8-8b27-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kati",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kittleson",
    "cica_residentialphone": "5166226636",
    "cica_fdif": "2/14/2016",
    "cica_residentialaddress": "78 Capt Shankey Dr",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kittleson"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dorcas",
    "id": "6350b9ab-9b0d-11e8-83fd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dorcas",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mountjoy",
    "cica_residentialphone": "7187124427",
    "cica_fdif": "8/13/2017",
    "cica_residentialaddress": "78 Capt Shankey Dr",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mountjoy"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GXLZ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Katharine",
    "id": "6350c238-9b0d-11e8-8c8b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Katharine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "SC8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hewes",
    "cica_residentialphone": "7183412915",
    "cica_fdif": "7/26/2017",
    "cica_residentialaddress": "11 Lenore Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hewes"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Virgie",
    "id": "6350ccc5-9b0d-11e8-8f4b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Virgie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Soltis",
    "cica_residentialphone": "3478672919",
    "cica_fdif": "4/10/2016",
    "cica_residentialaddress": "11 Lenore Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Soltis"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lionel",
    "id": "6350d7f8-9b0d-11e8-9226-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lionel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gorsuch",
    "cica_residentialphone": "3474557694",
    "cica_fdif": "6/22/2017",
    "cica_residentialaddress": "23 N Edsall Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gorsuch"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Roni",
    "id": "6350e38a-9b0d-11e8-b7a3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Roni",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Finlay",
    "cica_residentialphone": "5166088100",
    "cica_fdif": "11/5/2018",
    "cica_residentialaddress": "24 St Anthony Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Finlay"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Roseanna",
    "id": "6350ed4c-9b0d-11e8-934a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Roseanna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rodger",
    "cica_residentialphone": "7187762838",
    "cica_fdif": "2/20/2018",
    "cica_residentialaddress": "145 Johnsontown Rd",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rodger"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Verena",
    "id": "6350f65e-9b0d-11e8-846e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Verena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mullett",
    "cica_residentialphone": "7185274742",
    "cica_fdif": "7/26/2017",
    "cica_residentialaddress": "145 Johnsontown Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mullett"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Teisha",
    "id": "6350feeb-9b0d-11e8-9473-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Teisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sollars",
    "cica_residentialphone": "7184640309",
    "cica_fdif": "4/5/2016",
    "cica_residentialaddress": "145 Johnsontown Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sollars"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cassey",
    "id": "6351076e-9b0d-11e8-947a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cassey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kilbourne",
    "cica_residentialphone": "7184640309",
    "cica_fdif": "3/24/2018",
    "cica_residentialaddress": "133 Country Club Ln",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kilbourne"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Drucilla",
    "id": "63510ff3-9b0d-11e8-a807-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Drucilla",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Huggard",
    "cica_residentialphone": "7184640309",
    "cica_fdif": "5/13/2017",
    "cica_residentialaddress": "41 Lillian St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Huggard"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Earnestine",
    "id": "6351186e-9b0d-11e8-8ea9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Earnestine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gandhi",
    "cica_residentialphone": "3474890586",
    "cica_fdif": "3/2/2016",
    "cica_residentialaddress": "41 Lillian St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gandhi"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Eleonore",
    "id": "635120de-9b0d-11e8-a279-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Eleonore",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Carnley",
    "cica_residentialphone": "7185222155",
    "cica_fdif": "10/1/2016",
    "cica_residentialaddress": "41 Lillian St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Carnley"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Penney",
    "id": "6351296b-9b0d-11e8-859e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Penney",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hocutt",
    "cica_residentialphone": "3479759317",
    "cica_fdif": "6/16/2016",
    "cica_residentialaddress": "28 Orchard St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hocutt"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nathalie",
    "id": "635131e6-9b0d-11e8-85fa-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nathalie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Picard",
    "cica_residentialphone": "7189491081",
    "cica_fdif": "6/16/2017",
    "cica_residentialaddress": "28 Orchard St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Picard"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kathline",
    "id": "63513a68-9b0d-11e8-8778-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kathline",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Waltz",
    "cica_residentialphone": "7189496766",
    "cica_fdif": "7/7/2017",
    "cica_residentialaddress": "248 N Main St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Waltz"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Trey",
    "id": "63514578-9b0d-11e8-9020-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Trey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pitchford",
    "cica_residentialphone": "7189496766",
    "cica_fdif": "7/20/2016",
    "cica_residentialaddress": "6 Sherman Dr",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pitchford"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ofelia",
    "id": "63514e07-9b0d-11e8-8c99-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ofelia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tinkle",
    "cica_residentialphone": "7189780449",
    "cica_fdif": "6/14/2017",
    "cica_residentialaddress": "6 Sherman Dr",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tinkle"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Macy",
    "id": "63515694-9b0d-11e8-a4e2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Macy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Olenick",
    "cica_residentialphone": "5162945504",
    "cica_fdif": "3/21/2016",
    "cica_residentialaddress": "33 Johnson St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Olenick"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Carletta",
    "id": "63515f23-9b0d-11e8-a737-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carletta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gallo",
    "cica_residentialphone": "6315431688",
    "cica_fdif": "5/7/2017",
    "cica_residentialaddress": "31 Nordica Cir",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gallo"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Miki",
    "id": "6351679c-9b0d-11e8-82ad-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Miki",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Wooden",
    "cica_residentialphone": "3474268616",
    "cica_fdif": "10/26/2016",
    "cica_residentialaddress": "31 Nordica Cir",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wooden"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Mariana",
    "id": "6351701e-9b0d-11e8-a354-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mariana",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Withey",
    "cica_residentialphone": "7188103151",
    "cica_fdif": "10/16/2017",
    "cica_residentialaddress": "91 Washburns Ln",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Withey"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Scott",
    "id": "63517885-9b0d-11e8-b91e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Scott",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Viramontes",
    "cica_residentialphone": "5162230181",
    "cica_fdif": "5/14/2017",
    "cica_residentialaddress": "2355 Bell Blvd Apt 3C",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Viramontes"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Raguel",
    "id": "63518100-9b0d-11e8-b715-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Raguel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mercedes",
    "cica_residentialphone": "5162230181",
    "cica_fdif": "7/13/2017",
    "cica_residentialaddress": "2355 Bell Blvd Apt 3C",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mercedes"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jules",
    "id": "63518978-9b0d-11e8-9469-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jules",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kulikowski",
    "cica_residentialphone": "5163716079",
    "cica_fdif": "9/19/2017",
    "cica_residentialaddress": "25 S 18th St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kulikowski"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maxwell",
    "id": "63519200-9b0d-11e8-a644-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maxwell",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Roesch",
    "cica_residentialphone": "5166653064",
    "cica_fdif": "1/3/2016",
    "cica_residentialaddress": "195 Bellmore St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Roesch"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Mariah",
    "id": "63519a82-9b0d-11e8-9eb6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mariah",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lemanski",
    "cica_residentialphone": "5166653064",
    "cica_fdif": "1/9/2016",
    "cica_residentialaddress": "2150 Hempstead Tpke",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lemanski"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kathy",
    "id": "6351a2fa-9b0d-11e8-a12a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kathy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Weidler",
    "cica_residentialphone": "5167599197",
    "cica_fdif": "4/18/2018",
    "cica_residentialaddress": "2150 Hempstead Tpke",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Weidler"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Leonard",
    "id": "6351ab6b-9b0d-11e8-83e1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Leonard",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Amezquita",
    "cica_residentialphone": "5166768978",
    "cica_fdif": "8/21/2018",
    "cica_residentialaddress": "2150 Hempstead Tpke",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Amezquita"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Randall",
    "id": "6351b7c5-9b0d-11e8-8e73-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Randall",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hypes",
    "cica_residentialphone": "5165793314",
    "cica_fdif": "3/16/2018",
    "cica_residentialaddress": "124 Haven Ln",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hypes"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Emilio",
    "id": "6351c0e8-9b0d-11e8-a6e0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Emilio",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Viers",
    "cica_residentialphone": "5166710185",
    "cica_fdif": "9/23/2018",
    "cica_residentialaddress": "695 Lenore Ln",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Viers"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rebecca",
    "id": "6351ca17-9b0d-11e8-a24b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rebecca",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Culton",
    "cica_residentialphone": "5166377809",
    "cica_fdif": "8/16/2017",
    "cica_residentialaddress": "695 Lenore Ln",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Culton"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Consuelo",
    "id": "6351d2de-9b0d-11e8-942a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Consuelo",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hinckley",
    "cica_residentialphone": "5166768961",
    "cica_fdif": "5/15/2016",
    "cica_residentialaddress": "885 Niagara St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hinckley"
  },
  {
    "cica_market": "13",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "GXFF",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Allyn",
    "id": "6351db97-9b0d-11e8-b46e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Allyn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC8",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "31",
    "cica_writingagentfirstname": "Agent24",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gauldin",
    "cica_residentialphone": "6314274674",
    "cica_fdif": "5/10/2018",
    "cica_residentialaddress": "9 Hayden Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gauldin"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ermelinda",
    "id": "6351e423-9b0d-11e8-8ca8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ermelinda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Meggs",
    "cica_residentialphone": "5164895568",
    "cica_fdif": "2/22/2016",
    "cica_residentialaddress": "91 East St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Meggs"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "James",
    "id": "6351eccf-9b0d-11e8-a0a3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "James",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Brott",
    "cica_residentialphone": "5165388637",
    "cica_fdif": "3/11/2018",
    "cica_residentialaddress": "42 Clovelly Dr",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Brott"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Katherine",
    "id": "6351f58f-9b0d-11e8-9f47-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Katherine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bergey",
    "cica_residentialphone": "5162794117",
    "cica_fdif": "6/24/2016",
    "cica_residentialaddress": "20930 86th Dr Apt 3A",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bergey"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bradley",
    "id": "6351fe6e-9b0d-11e8-bcd6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bradley",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Condrey",
    "cica_residentialphone": "5164830690",
    "cica_fdif": "11/10/2017",
    "cica_residentialaddress": "20930 86th Dr Apt 3A",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Condrey"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rosana",
    "id": "635206f0-9b0d-11e8-8c95-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosana",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Reagan",
    "cica_residentialphone": "5164851992",
    "cica_fdif": "6/2/2018",
    "cica_residentialaddress": "5101 39th Ave Apt C41",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Reagan"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Eulalia",
    "id": "63520f6e-9b0d-11e8-8f9a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Eulalia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Weatherall",
    "cica_residentialphone": "5164851992",
    "cica_fdif": "11/11/2017",
    "cica_residentialaddress": "2119 32nd St Apt 1",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Weatherall"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maddie",
    "id": "635217e6-9b0d-11e8-a5e3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maddie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rothwell",
    "cica_residentialphone": "5169022789",
    "cica_fdif": "1/15/2018",
    "cica_residentialaddress": "761 Correll Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rothwell"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Paola",
    "id": "63522061-9b0d-11e8-b55f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Paola",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mooney",
    "cica_residentialphone": "5164812747",
    "cica_fdif": "5/17/2018",
    "cica_residentialaddress": "35 Middle Loop Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mooney"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jordon",
    "id": "63522ec0-9b0d-11e8-9594-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jordon",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sol",
    "cica_residentialphone": "5164812747",
    "cica_fdif": "2/24/2018",
    "cica_residentialaddress": "321 Jordan St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sol"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jaymie",
    "id": "63523817-9b0d-11e8-9443-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jaymie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bloom",
    "cica_residentialphone": "5162803680",
    "cica_fdif": "1/27/2017",
    "cica_residentialaddress": "795 Lenox Rd # 1",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bloom"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Harry",
    "id": "635240fd-9b0d-11e8-80d1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Harry",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Beamon",
    "cica_residentialphone": "5162803680",
    "cica_fdif": "10/11/2016",
    "cica_residentialaddress": "1114 New York Ave Apt 2D",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Beamon"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Isadora",
    "id": "635249d1-9b0d-11e8-bc7a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Isadora",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Poirrier",
    "cica_residentialphone": "5165264401",
    "cica_fdif": "4/22/2016",
    "cica_residentialaddress": "1114 New York Ave Apt 2D",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Poirrier"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Pearlene",
    "id": "63525287-9b0d-11e8-af87-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Pearlene",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cervantes",
    "cica_residentialphone": "5163843455",
    "cica_fdif": "5/3/2016",
    "cica_residentialaddress": "914 50th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cervantes"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jessika",
    "id": "63525b28-9b0d-11e8-bf16-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jessika",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mccubbin",
    "cica_residentialphone": "5165477421",
    "cica_fdif": "2/26/2017",
    "cica_residentialaddress": "124 Grove St Apt 3",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mccubbin"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Therese",
    "id": "635263e1-9b0d-11e8-b4ad-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Therese",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Seager",
    "cica_residentialphone": "5165873105",
    "cica_fdif": "10/19/2016",
    "cica_residentialaddress": "159 Pulaski St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Seager"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Georgeanna",
    "id": "63526c8c-9b0d-11e8-8fa9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Georgeanna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rendon",
    "cica_residentialphone": "5167705733",
    "cica_fdif": "6/2/2018",
    "cica_residentialaddress": "32 Fallon Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rendon"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Benny",
    "id": "63527538-9b0d-11e8-8027-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Benny",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Nelsen",
    "cica_residentialphone": "6312428554",
    "cica_fdif": "10/12/2017",
    "cica_residentialaddress": "237 New Lots Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nelsen"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nova",
    "id": "63527dd1-9b0d-11e8-806d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nova",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Orsi",
    "cica_residentialphone": "5166405317",
    "cica_fdif": "3/16/2017",
    "cica_residentialaddress": "349 Dewitt Ave Apt 1",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Orsi"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hildegard",
    "id": "63528666-9b0d-11e8-b09e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hildegard",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Giroir",
    "cica_residentialphone": "5164325632",
    "cica_fdif": "6/26/2017",
    "cica_residentialaddress": "661 Jerome St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Giroir"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Harlan",
    "id": "63528f14-9b0d-11e8-b6e7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Harlan",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rothchild",
    "cica_residentialphone": "5166761086",
    "cica_fdif": "1/2/2018",
    "cica_residentialaddress": "1352 Washington Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rothchild"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BDWQ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Miyoko",
    "id": "635297ca-9b0d-11e8-ac89-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Miyoko",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Medlin",
    "cica_residentialphone": "5166761086",
    "cica_fdif": "1/21/2018",
    "cica_residentialaddress": "675 Lincoln Ave Apt 13R",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Medlin"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Abel",
    "id": "6352a04c-9b0d-11e8-85e9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Abel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ruvolo",
    "cica_residentialphone": "5168892233",
    "cica_fdif": "4/24/2018",
    "cica_residentialaddress": "546 79th St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ruvolo"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Candice",
    "id": "6352a8dc-9b0d-11e8-989d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Candice",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Seidl",
    "cica_residentialphone": "7187231231",
    "cica_fdif": "5/6/2016",
    "cica_residentialaddress": "3F Signs Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Seidl"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Deetta",
    "id": "6352b17d-9b0d-11e8-b845-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Deetta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cronin",
    "cica_residentialphone": "5163122100",
    "cica_fdif": "11/1/2018",
    "cica_residentialaddress": "1134 E 43rd St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cronin"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ayako",
    "id": "6352ba0a-9b0d-11e8-a68f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ayako",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Graig",
    "cica_residentialphone": "6315057508",
    "cica_fdif": "3/23/2016",
    "cica_residentialaddress": "1134 E 43rd St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Graig"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Mechelle",
    "id": "6352c3f8-9b0d-11e8-8afc-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mechelle",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Loiacono",
    "cica_residentialphone": "5164818649",
    "cica_fdif": "9/13/2018",
    "cica_residentialaddress": "340 E 92nd St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Loiacono"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Darlena",
    "id": "6352cede-9b0d-11e8-9909-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Darlena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Autry",
    "cica_residentialphone": "5164818649",
    "cica_fdif": "5/1/2018",
    "cica_residentialaddress": "8814 Bedell Ln",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Autry"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Valene",
    "id": "6352d79c-9b0d-11e8-a4b5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Valene",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Fuquay",
    "cica_residentialphone": "5167631151",
    "cica_fdif": "7/2/2017",
    "cica_residentialaddress": "305 Livonia Ave Apt 11B",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fuquay"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Carlotta",
    "id": "6352e047-9b0d-11e8-84c1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carlotta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kerrigan",
    "cica_residentialphone": "5165940138",
    "cica_fdif": "5/28/2016",
    "cica_residentialaddress": "1055 Lincoln Pl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kerrigan"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lanny",
    "id": "6352e8d7-9b0d-11e8-a1af-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lanny",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ferrero",
    "cica_residentialphone": "5162059976",
    "cica_fdif": "8/9/2018",
    "cica_residentialaddress": "1055 Lincoln Pl",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ferrero"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marty",
    "id": "6352f1de-9b0d-11e8-8f49-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marty",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pizana",
    "cica_residentialphone": "5166614930",
    "cica_fdif": "9/20/2017",
    "cica_residentialaddress": "860 E 16th St Apt 1",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pizana"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cyndi",
    "id": "6352fac5-9b0d-11e8-96e8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cyndi",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lamberth",
    "cica_residentialphone": "5165388047",
    "cica_fdif": "9/12/2017",
    "cica_residentialaddress": "860 E 16th St Apt 1",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lamberth"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tiny",
    "id": "635303a3-9b0d-11e8-a21a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tiny",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Galdamez",
    "cica_residentialphone": "5165641852",
    "cica_fdif": "4/15/2016",
    "cica_residentialaddress": "19706 100th Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Galdamez"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hyacinth",
    "id": "63530c97-9b0d-11e8-94fa-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hyacinth",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dubin",
    "cica_residentialphone": "5165641852",
    "cica_fdif": "8/14/2016",
    "cica_residentialaddress": "144 Green Valley Rd # 1",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dubin"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Madison",
    "id": "635316b3-9b0d-11e8-9d9b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Madison",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Peeples",
    "cica_residentialphone": "5165641852",
    "cica_fdif": "4/27/2017",
    "cica_residentialaddress": "30 Halsey St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Peeples"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tonisha",
    "id": "63532026-9b0d-11e8-8c92-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tonisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Criss",
    "cica_residentialphone": "5165388047",
    "cica_fdif": "4/7/2016",
    "cica_residentialaddress": "426 Baltic St Apt 12B",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Criss"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Vita",
    "id": "63532980-9b0d-11e8-9af6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hutcherson",
    "cica_residentialphone": "5165641852",
    "cica_fdif": "11/22/2017",
    "cica_residentialaddress": "296 Lafayette St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hutcherson"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cassidy",
    "id": "635332dc-9b0d-11e8-ab25-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cassidy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Whitby",
    "cica_residentialphone": "5166165859",
    "cica_fdif": "9/10/2017",
    "cica_residentialaddress": "451 E 4th St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Whitby"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Roselia",
    "id": "63533c47-9b0d-11e8-ac05-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Roselia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bartholomew",
    "cica_residentialphone": "9173766699",
    "cica_fdif": "6/13/2016",
    "cica_residentialaddress": "451 E 4th St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bartholomew"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maxwell",
    "id": "635345b3-9b0d-11e8-bc61-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maxwell",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Redrick",
    "cica_residentialphone": "5168123970",
    "cica_fdif": "4/28/2018",
    "cica_residentialaddress": "1745 E 8th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Redrick"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Roxy",
    "id": "63534f26-9b0d-11e8-9363-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Roxy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pigg",
    "cica_residentialphone": "5168123970",
    "cica_fdif": "5/2/2017",
    "cica_residentialaddress": "540 58th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pigg"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Arvilla",
    "id": "63535bd7-9b0d-11e8-9a1c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Arvilla",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sumners",
    "cica_residentialphone": "5165616174",
    "cica_fdif": "2/25/2016",
    "cica_residentialaddress": "6822 4th Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sumners"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Mikki",
    "id": "63536785-9b0d-11e8-a343-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mikki",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Flannery",
    "cica_residentialphone": "5165934091",
    "cica_fdif": "8/25/2016",
    "cica_residentialaddress": "41 Sutton St Apt 3L",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Flannery"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEIO",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Samantha",
    "id": "635371c2-9b0d-11e8-8c14-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Samantha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Devita",
    "cica_residentialphone": "5165934091",
    "cica_fdif": "6/25/2018",
    "cica_residentialaddress": "2928 W 5th St Apt 7L",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Devita"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lily",
    "id": "63537b54-9b0d-11e8-959e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lily",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Acosta",
    "cica_residentialphone": "3863388803",
    "cica_fdif": "7/16/2016",
    "cica_residentialaddress": "159 S 1st St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Acosta"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Anya",
    "id": "6353840a-9b0d-11e8-acd3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Anya",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ruano",
    "cica_residentialphone": "5167473337",
    "cica_fdif": "3/13/2016",
    "cica_residentialaddress": "500 Montgomery St Apt 2A",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ruano"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elfreda",
    "id": "63538cca-9b0d-11e8-becf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elfreda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hennessey",
    "cica_residentialphone": "5163335743",
    "cica_fdif": "9/22/2016",
    "cica_residentialaddress": "1366 Carroll St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hennessey"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Annmarie",
    "id": "6353958a-9b0d-11e8-adcb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Annmarie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Shufelt",
    "cica_residentialphone": "5164141131",
    "cica_fdif": "3/28/2017",
    "cica_residentialaddress": "1366 Carroll St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shufelt"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Natalia",
    "id": "63539e2b-9b0d-11e8-a60a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Natalia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Simons",
    "cica_residentialphone": "5164141131",
    "cica_fdif": "2/14/2017",
    "cica_residentialaddress": "1366 Carroll St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Simons"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sage",
    "id": "6353a6cf-9b0d-11e8-94b4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sage",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcculley",
    "cica_residentialphone": "5168769546",
    "cica_fdif": "3/2/2017",
    "cica_residentialaddress": "350 Sterling St Apt 6K",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcculley"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ginger",
    "id": "6353afb5-9b0d-11e8-bea7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ginger",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tesch",
    "cica_residentialphone": "5163346855",
    "cica_fdif": "2/25/2016",
    "cica_residentialaddress": "522 Ocean Ave Apt 4G",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tesch"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marilyn",
    "id": "6353b86e-9b0d-11e8-944f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marilyn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Morais",
    "cica_residentialphone": "5162146474",
    "cica_fdif": "6/4/2018",
    "cica_residentialaddress": "17750 S Conduit Ave Apt 1D",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Morais"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Effie",
    "id": "6353c0f0-9b0d-11e8-8969-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Effie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Salaam",
    "cica_residentialphone": "5162146474",
    "cica_fdif": "8/20/2016",
    "cica_residentialaddress": "546 49th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Salaam"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Assunta",
    "id": "6353c968-9b0d-11e8-899e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Assunta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Grimshaw",
    "cica_residentialphone": "5162487622",
    "cica_fdif": "4/9/2017",
    "cica_residentialaddress": "2310 Clarendon Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Grimshaw"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Holly",
    "id": "6353d202-9b0d-11e8-993c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Holly",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kahler",
    "cica_residentialphone": "5162487622",
    "cica_fdif": "1/24/2017",
    "cica_residentialaddress": "1701 Quentin Rd Apt B3",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kahler"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Keisha",
    "id": "6353da85-9b0d-11e8-aded-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Keisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dolson",
    "cica_residentialphone": "5162487622",
    "cica_fdif": "7/19/2018",
    "cica_residentialaddress": "656 Marlborough Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dolson"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rusty",
    "id": "6353e300-9b0d-11e8-a0fb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rusty",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Riter",
    "cica_residentialphone": "5162487622",
    "cica_fdif": "10/9/2016",
    "cica_residentialaddress": "164 Dikeman St Apt 3L",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Riter"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joeann",
    "id": "6353eb8f-9b0d-11e8-a01c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joeann",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Weisberg",
    "cica_residentialphone": "6462702095",
    "cica_fdif": "10/23/2018",
    "cica_residentialaddress": "976 Marcel Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Weisberg"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Latisha",
    "id": "6353f407-9b0d-11e8-bbdd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Latisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Staten",
    "cica_residentialphone": "9176677114",
    "cica_fdif": "9/3/2017",
    "cica_residentialaddress": "9225 Fort Hamilton Pkwy Apt A6",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Staten"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lawrence",
    "id": "6353fc8a-9b0d-11e8-b61c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lawrence",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Onan",
    "cica_residentialphone": "3475392222",
    "cica_fdif": "4/14/2018",
    "cica_residentialaddress": "339A Bainbridge St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Onan"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BGOU",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marjory",
    "id": "635404fa-9b0d-11e8-a4bc-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marjory",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent8",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Chartrand",
    "cica_residentialphone": "7188101863",
    "cica_fdif": "6/28/2018",
    "cica_residentialaddress": "18337 Brinkerhoff Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Chartrand"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Greg",
    "id": "63540d80-9b0d-11e8-ad53-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Greg",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ritts",
    "cica_residentialphone": "7184743020",
    "cica_fdif": "2/7/2016",
    "cica_residentialaddress": "197 Chauncey St Apt 1",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ritts"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Olivia",
    "id": "635415f0-9b0d-11e8-9990-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Olivia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bayliss",
    "cica_residentialphone": "6317891273",
    "cica_fdif": "1/24/2017",
    "cica_residentialaddress": "197 Chauncey St Apt 1",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bayliss"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Carmina",
    "id": "63541e68-9b0d-11e8-b48b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carmina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Nickel",
    "cica_residentialphone": "5163186429",
    "cica_fdif": "3/22/2017",
    "cica_residentialaddress": "1399 E 48th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nickel"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shirlee",
    "id": "635426d1-9b0d-11e8-98a3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shirlee",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Belz",
    "cica_residentialphone": "6319915473",
    "cica_fdif": "10/12/2016",
    "cica_residentialaddress": "1475 E 45th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Belz"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Earnestine",
    "id": "63542f4a-9b0d-11e8-b484-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Earnestine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hackley",
    "cica_residentialphone": "6315864075",
    "cica_fdif": "8/20/2016",
    "cica_residentialaddress": "585 E 21st St Apt 1B",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hackley"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ezra",
    "id": "635437c5-9b0d-11e8-b7d4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ezra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Beshears",
    "cica_residentialphone": "6316698720",
    "cica_fdif": "7/3/2017",
    "cica_residentialaddress": "1949 E 36th St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Beshears"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Omar",
    "id": "63544105-9b0d-11e8-8579-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Omar",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Conley",
    "cica_residentialphone": "6316698720",
    "cica_fdif": "4/22/2018",
    "cica_residentialaddress": "10215 Avenue J Ph",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Conley"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ka",
    "id": "63544975-9b0d-11e8-93ad-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ka",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Starling",
    "cica_residentialphone": "6317923369",
    "cica_fdif": "11/8/2017",
    "cica_residentialaddress": "959 E 89th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Starling"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ken",
    "id": "635451f8-9b0d-11e8-a072-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ken",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lafferty",
    "cica_residentialphone": "6316711823",
    "cica_fdif": "11/8/2017",
    "cica_residentialaddress": "1398 E 93rd St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lafferty"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Azzie",
    "id": "63545ad7-9b0d-11e8-a469-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Azzie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ramerez",
    "cica_residentialphone": "6314956862",
    "cica_fdif": "9/3/2017",
    "cica_residentialaddress": "1524 Remsen Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ramerez"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Zita",
    "id": "6354638f-9b0d-11e8-844d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Zita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Manriquez",
    "cica_residentialphone": "6314723676",
    "cica_fdif": "3/3/2017",
    "cica_residentialaddress": "1320 E 84th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Manriquez"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jonie",
    "id": "63546c3a-9b0d-11e8-8a8b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jonie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Borrero",
    "cica_residentialphone": "6318840088",
    "cica_fdif": "7/1/2017",
    "cica_residentialaddress": "1528 E 98th St Apt 104",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Borrero"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Emily",
    "id": "635474ee-9b0d-11e8-b440-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Emily",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Wingard",
    "cica_residentialphone": "6318840088",
    "cica_fdif": "3/20/2018",
    "cica_residentialaddress": "105 Lefferts Pl Apt E45",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wingard"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "ACUA",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Caryn",
    "id": "63547da6-9b0d-11e8-a13a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Caryn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC1",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Shabazz",
    "cica_residentialphone": "6312540129",
    "cica_fdif": "5/11/2016",
    "cica_residentialaddress": "136 Wallabout St Apt 6A",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shabazz"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Josefa",
    "id": "63548685-9b0d-11e8-8ef6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Josefa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hodson",
    "cica_residentialphone": "6316679346",
    "cica_fdif": "9/25/2017",
    "cica_residentialaddress": "75 Wesleyan Rd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hodson"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Roger",
    "id": "63548f07-9b0d-11e8-b14a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Roger",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Aaronson",
    "cica_residentialphone": "6315861933",
    "cica_fdif": "3/7/2017",
    "cica_residentialaddress": "13740 45th Ave Apt 2H",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Aaronson"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Liliana",
    "id": "63549778-9b0d-11e8-9e5e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Liliana",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tisby",
    "cica_residentialphone": "6312424636",
    "cica_fdif": "7/13/2016",
    "cica_residentialaddress": "409 147th St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tisby"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Augustina",
    "id": "6354a47a-9b0d-11e8-878f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Augustina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Helfer",
    "cica_residentialphone": "6312424636",
    "cica_fdif": "2/2/2017",
    "cica_residentialaddress": "2918 160th St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Helfer"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cole",
    "id": "6354adc5-9b0d-11e8-bf18-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cole",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tedford",
    "cica_residentialphone": "6315217299",
    "cica_fdif": "5/28/2018",
    "cica_residentialaddress": "2918 160th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tedford"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dorothea",
    "id": "6354b654-9b0d-11e8-be25-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dorothea",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Nicosia",
    "cica_residentialphone": "6316365548",
    "cica_fdif": "10/16/2016",
    "cica_residentialaddress": "4 Hampton Ct",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nicosia"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Danae",
    "id": "6354bef5-9b0d-11e8-8409-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Danae",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bianco",
    "cica_residentialphone": "6316668446",
    "cica_fdif": "4/9/2016",
    "cica_residentialaddress": "4302 Orient Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bianco"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ami",
    "id": "6354c785-9b0d-11e8-870f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ami",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Luken",
    "cica_residentialphone": "6319400701",
    "cica_fdif": "11/13/2018",
    "cica_residentialaddress": "4302 Orient Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Luken"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kathey",
    "id": "6354d09c-9b0d-11e8-a297-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kathey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Spies",
    "cica_residentialphone": "6319400701",
    "cica_fdif": "8/9/2016",
    "cica_residentialaddress": "5643 Clearview Expy",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Spies"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lisabeth",
    "id": "6354d970-9b0d-11e8-bc20-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lisabeth",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Malsam",
    "cica_residentialphone": "6319400701",
    "cica_fdif": "11/24/2018",
    "cica_residentialaddress": "4818 190th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Malsam"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Natividad",
    "id": "6354e23a-9b0d-11e8-aa7a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Natividad",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Chilcote",
    "cica_residentialphone": "6319684511",
    "cica_fdif": "8/14/2018",
    "cica_residentialaddress": "2321 93rd St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Chilcote"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Yee",
    "id": "6354eafa-9b0d-11e8-a69e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Yee",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Embry",
    "cica_residentialphone": "6319684511",
    "cica_fdif": "3/19/2018",
    "cica_residentialaddress": "2321 93rd St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Embry"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Alexandria",
    "id": "6354f3c5-9b0d-11e8-821b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Alexandria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Holiman",
    "cica_residentialphone": "6315215549",
    "cica_fdif": "3/2/2016",
    "cica_residentialaddress": "2A Elm Dr",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Holiman"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BITJ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Magdalena",
    "id": "6354fc99-9b0d-11e8-912e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Magdalena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Jungers",
    "cica_residentialphone": "5163958186",
    "cica_fdif": "10/9/2018",
    "cica_residentialaddress": "5116 90th St Fl 2",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jungers"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cinderella",
    "id": "6355051c-9b0d-11e8-86ff-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cinderella",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcmullin",
    "cica_residentialphone": "5162238691",
    "cica_fdif": "3/3/2018",
    "cica_residentialaddress": "5415 Junction Blvd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcmullin"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Delpha",
    "id": "63550d8c-9b0d-11e8-9cb7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delpha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Parke",
    "cica_residentialphone": "5169355341",
    "cica_fdif": "5/9/2016",
    "cica_residentialaddress": "11024 64th Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Parke"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gisele",
    "id": "63551611-9b0d-11e8-b7d3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gisele",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcraney",
    "cica_residentialphone": "5169355341",
    "cica_fdif": "8/12/2017",
    "cica_residentialaddress": "4 19th Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcraney"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Debbi",
    "id": "63551e8c-9b0d-11e8-bfb2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Debbi",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Davie",
    "cica_residentialphone": "5166817081",
    "cica_fdif": "3/13/2018",
    "cica_residentialaddress": "4915 Skillman Ave Apt 4F",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Davie"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marnie",
    "id": "63552705-9b0d-11e8-b19e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marnie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lapierre",
    "cica_residentialphone": "5166817081",
    "cica_fdif": "3/7/2018",
    "cica_residentialaddress": "2145 Harmon St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lapierre"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Scottie",
    "id": "63552f75-9b0d-11e8-81c0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Scottie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Manor",
    "cica_residentialphone": "6317371980",
    "cica_fdif": "1/27/2018",
    "cica_residentialaddress": "19214 110th Rd Fl 1",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Manor"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ivana",
    "id": "635537f8-9b0d-11e8-a1e3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ivana",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cardella",
    "cica_residentialphone": "6314472019",
    "cica_fdif": "10/23/2017",
    "cica_residentialaddress": "19420 115th Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cardella"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Donella",
    "id": "63554068-9b0d-11e8-84a9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Donella",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Collazo",
    "cica_residentialphone": "6316264326",
    "cica_fdif": "9/4/2017",
    "cica_residentialaddress": "11418 205th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Collazo"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Deidra",
    "id": "63554d42-9b0d-11e8-a273-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Deidra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hartlage",
    "cica_residentialphone": "6316391028",
    "cica_fdif": "1/5/2018",
    "cica_residentialaddress": "11418 205th St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hartlage"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jona",
    "id": "635556d7-9b0d-11e8-8129-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jona",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Garry",
    "cica_residentialphone": "6314354527",
    "cica_fdif": "7/2/2017",
    "cica_residentialaddress": "11418 205th St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Garry"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Daria",
    "id": "63555fe6-9b0d-11e8-bb2e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Daria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kyker",
    "cica_residentialphone": "6314354527",
    "cica_fdif": "1/20/2018",
    "cica_residentialaddress": "12023 193rd St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kyker"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sharita",
    "id": "635568e3-9b0d-11e8-b67a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sharita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Weiner",
    "cica_residentialphone": "6314351636",
    "cica_fdif": "4/15/2018",
    "cica_residentialaddress": "13420 220th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Weiner"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bella",
    "id": "635571a1-9b0d-11e8-8a33-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bella",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Shane",
    "cica_residentialphone": "6314354527",
    "cica_fdif": "5/27/2017",
    "cica_residentialaddress": "13420 220th St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shane"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "America",
    "id": "63557b2b-9b0d-11e8-8a1d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "America",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pulice",
    "cica_residentialphone": "6314354527",
    "cica_fdif": "2/16/2018",
    "cica_residentialaddress": "13420 220th St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pulice"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kati",
    "id": "635584ba-9b0d-11e8-9ed8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kati",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Couchman",
    "cica_residentialphone": "6314354527",
    "cica_fdif": "7/5/2018",
    "cica_residentialaddress": "13420 220th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Couchman"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dorsey",
    "id": "63558f0c-9b0d-11e8-9fd0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dorsey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Grothe",
    "cica_residentialphone": "6318397336",
    "cica_fdif": "8/1/2017",
    "cica_residentialaddress": "13420 220th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Grothe"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lavera",
    "id": "635597b8-9b0d-11e8-a83f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lavera",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Shuff",
    "cica_residentialphone": "6318397336",
    "cica_fdif": "5/21/2016",
    "cica_residentialaddress": "13918 229th St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shuff"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maisha",
    "id": "6355a059-9b0d-11e8-913e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Zygmont",
    "cica_residentialphone": "6318397336",
    "cica_fdif": "1/6/2017",
    "cica_residentialaddress": "13918 229th St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Zygmont"
  },
  {
    "cica_market": "15",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AGUO",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bonny",
    "id": "6355a8e6-9b0d-11e8-b668-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bonny",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC1",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent9",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Silverman",
    "cica_residentialphone": "6318344700",
    "cica_fdif": "6/5/2018",
    "cica_residentialaddress": "14609 227th St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Silverman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Judson",
    "id": "6355b18a-9b0d-11e8-80d2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Judson",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hamil",
    "cica_residentialphone": "6315811721",
    "cica_fdif": "10/9/2016",
    "cica_residentialaddress": "14609 227th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hamil"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Julienne",
    "id": "6355ba21-9b0d-11e8-b139-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Julienne",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Myrick",
    "cica_residentialphone": "6314670545",
    "cica_fdif": "10/22/2016",
    "cica_residentialaddress": "8439 153rd Ave Apt 4",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Myrick"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nicholas",
    "id": "6355c2cc-9b0d-11e8-a88c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nicholas",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Coffer",
    "cica_residentialphone": "6314670545",
    "cica_fdif": "1/24/2018",
    "cica_residentialaddress": "9801 165th Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Coffer"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Charlotte",
    "id": "6355cb5c-9b0d-11e8-a46e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Charlotte",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pears",
    "cica_residentialphone": "6314042835",
    "cica_fdif": "9/8/2017",
    "cica_residentialaddress": "9801 165th Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pears"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Eli",
    "id": "6355d3f3-9b0d-11e8-9092-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Eli",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Harbert",
    "cica_residentialphone": "9179715009",
    "cica_fdif": "8/17/2018",
    "cica_residentialaddress": "46 Stewart Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Harbert"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maria",
    "id": "6355dc82-9b0d-11e8-ab0e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Coughlan",
    "cica_residentialphone": "6314826144",
    "cica_fdif": "5/22/2017",
    "cica_residentialaddress": "10111 113th St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Coughlan"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Krystin",
    "id": "6355e77a-9b0d-11e8-b3fd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Krystin",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Vanfleet",
    "cica_residentialphone": "6318398610",
    "cica_fdif": "4/4/2018",
    "cica_residentialaddress": "13505 233rd St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vanfleet"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Palma",
    "id": "6355f000-9b0d-11e8-8319-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Palma",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Wimbush",
    "cica_residentialphone": "6317475204",
    "cica_fdif": "9/7/2016",
    "cica_residentialaddress": "13505 233rd St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wimbush"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Laureen",
    "id": "6355f8a3-9b0d-11e8-8a19-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Laureen",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Donnelly",
    "cica_residentialphone": "6316136108",
    "cica_fdif": "5/8/2018",
    "cica_residentialaddress": "24302 135th Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Donnelly"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Robbyn",
    "id": "6356012e-9b0d-11e8-b543-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Robbyn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Schlottmann",
    "cica_residentialphone": "6316136108",
    "cica_fdif": "9/15/2018",
    "cica_residentialaddress": "25748 149th Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schlottmann"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maribel",
    "id": "635609bd-9b0d-11e8-acb5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maribel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Minjares",
    "cica_residentialphone": "6314993459",
    "cica_fdif": "2/16/2017",
    "cica_residentialaddress": "10042 204th St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Minjares"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marlon",
    "id": "63561268-9b0d-11e8-b8ac-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marlon",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Poplin",
    "cica_residentialphone": "6314998661",
    "cica_fdif": "2/24/2017",
    "cica_residentialaddress": "1859 Elizabeth Ct",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Poplin"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Aracely",
    "id": "63561aee-9b0d-11e8-b481-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Aracely",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Beam",
    "cica_residentialphone": "6314998661",
    "cica_fdif": "6/28/2017",
    "cica_residentialaddress": "21516 104th Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Beam"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joey",
    "id": "63562385-9b0d-11e8-9673-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bozeman",
    "cica_residentialphone": "6312233583",
    "cica_fdif": "9/3/2018",
    "cica_residentialaddress": "10328 219th St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bozeman"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bethann",
    "id": "63562c63-9b0d-11e8-92d4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bethann",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rodkey",
    "cica_residentialphone": "6319244054",
    "cica_fdif": "8/3/2016",
    "cica_residentialaddress": "22022 106th Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rodkey"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Glinda",
    "id": "635634fa-9b0d-11e8-84db-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Glinda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rupert",
    "cica_residentialphone": "6316615084",
    "cica_fdif": "4/2/2016",
    "cica_residentialaddress": "11410 197th St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rupert"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Evie",
    "id": "63563d94-9b0d-11e8-9236-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Evie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gingrich",
    "cica_residentialphone": "6319285626",
    "cica_fdif": "5/8/2016",
    "cica_residentialaddress": "11410 197th St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gingrich"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jackie",
    "id": "635647ee-9b0d-11e8-ae6a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jackie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Novy",
    "cica_residentialphone": "6319285626",
    "cica_fdif": "4/14/2016",
    "cica_residentialaddress": "11410 197th St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Novy"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marcie",
    "id": "63565066-9b0d-11e8-83b2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marcie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lafayette",
    "cica_residentialphone": "6319285626",
    "cica_fdif": "5/8/2017",
    "cica_residentialaddress": "156 Cedar St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lafayette"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elouise",
    "id": "63565900-9b0d-11e8-8783-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elouise",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pak",
    "cica_residentialphone": "6318335951",
    "cica_fdif": "3/1/2017",
    "cica_residentialaddress": "11032 157th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pak"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BEXU",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hilma",
    "id": "63566199-9b0d-11e8-9a9f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hilma",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "DM2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Weatherspoon",
    "cica_residentialphone": "6313871987",
    "cica_fdif": "4/24/2016",
    "cica_residentialaddress": "11032 157th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Weatherspoon"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Easter",
    "id": "63566a23-9b0d-11e8-a1cf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Easter",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Virden",
    "cica_residentialphone": "6319407252",
    "cica_fdif": "6/25/2018",
    "cica_residentialaddress": "525 Henry St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Virden"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Santos",
    "id": "635672b3-9b0d-11e8-8bd3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Santos",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Levalley",
    "cica_residentialphone": "6313553594",
    "cica_fdif": "1/10/2018",
    "cica_residentialaddress": "17216 Victoria Dr",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Levalley"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elva",
    "id": "63567b38-9b0d-11e8-aca6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elva",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Andrada",
    "cica_residentialphone": "6317541225",
    "cica_fdif": "10/5/2016",
    "cica_residentialaddress": "16026 130th Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Andrada"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Willy",
    "id": "635683c5-9b0d-11e8-a322-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Willy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mershon",
    "cica_residentialphone": "6313684461",
    "cica_fdif": "5/19/2016",
    "cica_residentialaddress": "13445 166th Pl Apt 10B",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mershon"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Odette",
    "id": "63568c68-9b0d-11e8-99f5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Odette",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ruggieri",
    "cica_residentialphone": "6313684461",
    "cica_fdif": "11/15/2016",
    "cica_residentialaddress": "13445 166th Pl Apt 10B",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ruggieri"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Katherina",
    "id": "635694f5-9b0d-11e8-9967-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Katherina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lazaro",
    "cica_residentialphone": "6313684461",
    "cica_fdif": "11/28/2016",
    "cica_residentialaddress": "15515 N Conduit Ave Apt 50",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lazaro"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Antonia",
    "id": "63569d85-9b0d-11e8-a028-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Antonia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pembleton",
    "cica_residentialphone": "6313684461",
    "cica_fdif": "4/12/2017",
    "cica_residentialaddress": "17105 143rd Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pembleton"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joaquin",
    "id": "6356a61c-9b0d-11e8-831b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joaquin",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Norberg",
    "cica_residentialphone": "6318276445",
    "cica_fdif": "11/1/2017",
    "cica_residentialaddress": "187 Jerome Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Norberg"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ludie",
    "id": "6356aeb3-9b0d-11e8-bf04-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ludie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lahr",
    "cica_residentialphone": "9143752645",
    "cica_fdif": "1/15/2016",
    "cica_residentialaddress": "9 Fernwood Dr",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lahr"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Julieta",
    "id": "6356b738-9b0d-11e8-bd50-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Julieta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Felps",
    "cica_residentialphone": "6317517682",
    "cica_fdif": "2/11/2017",
    "cica_residentialaddress": "1055 Alhambra Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Felps"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joelle",
    "id": "6356bfc5-9b0d-11e8-a69f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joelle",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Jerabek",
    "cica_residentialphone": "6318281337",
    "cica_fdif": "10/4/2018",
    "cica_residentialaddress": "717 Stanton Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Jerabek"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BIUE",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maryellen",
    "id": "6356c84a-9b0d-11e8-8efb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maryellen",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Broadhead",
    "cica_residentialphone": "5162493125",
    "cica_fdif": "4/12/2016",
    "cica_residentialaddress": "2333 Central Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Broadhead"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "HFJJ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Janessa",
    "id": "6356d0c5-9b0d-11e8-b220-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Janessa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcgarry",
    "cica_residentialphone": "5162493125",
    "cica_fdif": "9/23/2018",
    "cica_residentialaddress": "2333 Central Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcgarry"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "HFJJ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lasandra",
    "id": "6356d933-9b0d-11e8-8f39-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lasandra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ogg",
    "cica_residentialphone": "5162493125",
    "cica_fdif": "4/7/2017",
    "cica_residentialaddress": "9 Thompson Dr",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ogg"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "HFJJ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nguyet",
    "id": "6356e1c0-9b0d-11e8-b287-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nguyet",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Baudoin",
    "cica_residentialphone": "6317532643",
    "cica_fdif": "10/26/2016",
    "cica_residentialaddress": "146 Woodside Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Baudoin"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "HFJJ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sherri",
    "id": "6356ea47-9b0d-11e8-a90b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sherri",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mckinnie",
    "cica_residentialphone": "6318469184",
    "cica_fdif": "4/26/2016",
    "cica_residentialaddress": "146 Woodside Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mckinnie"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "HFJJ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jamee",
    "id": "6356f2b5-9b0d-11e8-8406-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jamee",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lobel",
    "cica_residentialphone": "6318469185",
    "cica_fdif": "1/9/2016",
    "cica_residentialaddress": "4 Inwood Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lobel"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "HFJJ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jacquelyne",
    "id": "6356fb3a-9b0d-11e8-9db5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jacquelyne",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "SC2",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pilarski",
    "cica_residentialphone": "6315853483",
    "cica_fdif": "11/17/2017",
    "cica_residentialaddress": "38 Mill Hill Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pilarski"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BKQL",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tatyana",
    "id": "635703c7-9b0d-11e8-97a3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tatyana",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tullier",
    "cica_residentialphone": "6315853483",
    "cica_fdif": "8/19/2017",
    "cica_residentialaddress": "257 Red Maple Dr S",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tullier"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BKQL",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cristal",
    "id": "63570c54-9b0d-11e8-babd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cristal",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Timmins",
    "cica_residentialphone": "6319814264",
    "cica_fdif": "10/6/2018",
    "cica_residentialaddress": "16 Conway Ct",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Timmins"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BKQL",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shawnna",
    "id": "635714dc-9b0d-11e8-a0ec-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shawnna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Murray",
    "cica_residentialphone": "6319814264",
    "cica_fdif": "5/28/2017",
    "cica_residentialaddress": "16 Conway Ct",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Murray"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BKQL",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elvina",
    "id": "63571d5e-9b0d-11e8-ade6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elvina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Wang",
    "cica_residentialphone": "6317570431",
    "cica_fdif": "2/18/2016",
    "cica_residentialaddress": "2 Foxboro Ln",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wang"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BKQL",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hollie",
    "id": "635725eb-9b0d-11e8-9e7a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hollie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sunde",
    "cica_residentialphone": "6314239066",
    "cica_fdif": "5/13/2016",
    "cica_residentialaddress": "19 Melrose Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sunde"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BKQL",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Quyen",
    "id": "63572e51-9b0d-11e8-90c0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Quyen",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tao",
    "cica_residentialphone": "6314273815",
    "cica_fdif": "11/9/2018",
    "cica_residentialaddress": "19 Melrose Rd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tao"
  },
  {
    "cica_market": "1",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BKQL",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Everett",
    "id": "635736d7-9b0d-11e8-886a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Everett",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC2",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "36",
    "cica_writingagentfirstname": "Agent4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Aguinaldo",
    "cica_residentialphone": "6314273815",
    "cica_fdif": "5/28/2017",
    "cica_residentialaddress": "125 Hempstead Gardens Dr Apt K",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Aguinaldo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gearldine",
    "id": "63573f47-9b0d-11e8-bf48-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gearldine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Shute",
    "cica_residentialphone": "6314273815",
    "cica_fdif": "4/9/2016",
    "cica_residentialaddress": "125 Hempstead Gardens Dr",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Shute"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lu",
    "id": "635747f3-9b0d-11e8-b945-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lu",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Crumpton",
    "cica_residentialphone": "6314279759",
    "cica_fdif": "5/8/2017",
    "cica_residentialaddress": "65 Harriet Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Crumpton"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Layne",
    "id": "635753a1-9b0d-11e8-9810-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Layne",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcglown",
    "cica_residentialphone": "6318962319",
    "cica_fdif": "10/17/2017",
    "cica_residentialaddress": "40 Meadowbrook Rd",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcglown"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Fonda",
    "id": "63575c23-9b0d-11e8-845a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Fonda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ellinger",
    "cica_residentialphone": "5219228172",
    "cica_fdif": "1/23/2017",
    "cica_residentialaddress": "761 Front St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ellinger"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Annika",
    "id": "63576494-9b0d-11e8-903a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Annika",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Thurlow",
    "cica_residentialphone": "6315815648",
    "cica_fdif": "3/8/2017",
    "cica_residentialaddress": "68 Courtenay Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Thurlow"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Claudia",
    "id": "63576d17-9b0d-11e8-bad3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Claudia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Galan",
    "cica_residentialphone": "6315815648",
    "cica_fdif": "1/8/2017",
    "cica_residentialaddress": "50 Albermarle",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Galan"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joel",
    "id": "63577587-9b0d-11e8-86a0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ihle",
    "cica_residentialphone": "6312778674",
    "cica_fdif": "9/5/2017",
    "cica_residentialaddress": "28 Sunnyside Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ihle"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rosenda",
    "id": "63577e17-9b0d-11e8-bd84-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosenda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tweedy",
    "cica_residentialphone": "6316633947",
    "cica_fdif": "4/22/2016",
    "cica_residentialaddress": "135 Carolina Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tweedy"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Francis",
    "id": "635786a6-9b0d-11e8-a6a6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Francis",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Suiter",
    "cica_residentialphone": "5169388092",
    "cica_fdif": "1/25/2017",
    "cica_residentialaddress": "135 Carolina Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Suiter"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Carry",
    "id": "63578f28-9b0d-11e8-88f9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carry",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Feng",
    "cica_residentialphone": "5169388092",
    "cica_fdif": "10/6/2016",
    "cica_residentialaddress": "200 Hilton Ave Unit 45",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Feng"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bridgett",
    "id": "635797ab-9b0d-11e8-9c34-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bridgett",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Schlegel",
    "cica_residentialphone": "5167311873",
    "cica_fdif": "3/9/2018",
    "cica_residentialaddress": "95 Powell Pl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schlegel"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Glennis",
    "id": "6357a030-9b0d-11e8-a5c1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Glennis",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Marbury",
    "cica_residentialphone": "5165205580",
    "cica_fdif": "9/11/2017",
    "cica_residentialaddress": "95 Powell Pl",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Marbury"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Isiah",
    "id": "6357a8ab-9b0d-11e8-a583-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Isiah",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Doria",
    "cica_residentialphone": "5163123521",
    "cica_fdif": "7/7/2016",
    "cica_residentialaddress": "246 Locust St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Doria"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Mina",
    "id": "6357b191-9b0d-11e8-bff1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sagucio",
    "cica_residentialphone": "5163123521",
    "cica_fdif": "7/4/2018",
    "cica_residentialaddress": "246 Locust St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sagucio"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tanesha",
    "id": "6357ba21-9b0d-11e8-9a33-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tanesha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Langham",
    "cica_residentialphone": "5163123521",
    "cica_fdif": "8/4/2017",
    "cica_residentialaddress": "60 Manor Pkwy",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Langham"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Meri",
    "id": "6357c2a3-9b0d-11e8-b24d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Meri",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Montagna",
    "cica_residentialphone": "5167351159",
    "cica_fdif": "2/21/2016",
    "cica_residentialaddress": "60 Manor Pkwy",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Montagna"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "ALKI",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Oren",
    "id": "6357cb33-9b0d-11e8-b769-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Oren",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kammerer",
    "cica_residentialphone": "9179817507",
    "cica_fdif": "1/25/2018",
    "cica_residentialaddress": "274 Arcadia Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kammerer"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sandy",
    "id": "6357d54f-9b0d-11e8-8fae-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sandy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Papas",
    "cica_residentialphone": "6313219100",
    "cica_fdif": "5/18/2017",
    "cica_residentialaddress": "296 Arcadia Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Papas"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Korey",
    "id": "6357dde8-9b0d-11e8-8f17-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Korey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tavera",
    "cica_residentialphone": "5163219100",
    "cica_fdif": "11/10/2018",
    "cica_residentialaddress": "480 Cedar St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tavera"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kayce",
    "id": "6357e675-9b0d-11e8-81d7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kayce",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Alejo",
    "cica_residentialphone": "5166421736",
    "cica_fdif": "2/7/2016",
    "cica_residentialaddress": "535 Decatur St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Alejo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Homer",
    "id": "6357ef05-9b0d-11e8-bb23-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Homer",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Palmer",
    "cica_residentialphone": "6319918152",
    "cica_fdif": "2/1/2018",
    "cica_residentialaddress": "26 Washington Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Palmer"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Teena",
    "id": "6357f79c-9b0d-11e8-96bd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Teena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Park",
    "cica_residentialphone": "6319918152",
    "cica_fdif": "6/16/2017",
    "cica_residentialaddress": "603 Bira St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Park"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Carlos",
    "id": "63580138-9b0d-11e8-8578-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Carlos",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Selvage",
    "cica_residentialphone": "6317960508",
    "cica_fdif": "8/26/2017",
    "cica_residentialaddress": "117 Warner Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Selvage"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Chu",
    "id": "63580a82-9b0d-11e8-8f75-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Chu",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Verdun",
    "cica_residentialphone": "5164546557",
    "cica_fdif": "7/27/2017",
    "cica_residentialaddress": "187 Nassau Ln",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Verdun"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cristina",
    "id": "635813e3-9b0d-11e8-b8d7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cristina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kinsella",
    "cica_residentialphone": "5164092156",
    "cica_fdif": "5/25/2016",
    "cica_residentialaddress": "6 Cherrywood Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kinsella"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Otelia",
    "id": "63581d2e-9b0d-11e8-a4df-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Otelia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Moorhouse",
    "cica_residentialphone": "5164092156",
    "cica_fdif": "2/6/2018",
    "cica_residentialaddress": "6 Cherrywood Rd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Moorhouse"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Brittney",
    "id": "6358268f-9b0d-11e8-909b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Brittney",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ota",
    "cica_residentialphone": "5167953022",
    "cica_fdif": "4/22/2016",
    "cica_residentialaddress": "285 W Broadway",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ota"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BBUM",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Leann",
    "id": "63582ffa-9b0d-11e8-9cc2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Leann",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent5",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lamy",
    "cica_residentialphone": "5165121630",
    "cica_fdif": "5/10/2017",
    "cica_residentialaddress": "24322 144th Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lamy"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Denita",
    "id": "6358393d-9b0d-11e8-a209-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Denita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Carnahan",
    "cica_residentialphone": "6313217063",
    "cica_fdif": "5/11/2017",
    "cica_residentialaddress": "92 Motley St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Carnahan"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cammie",
    "id": "635842a6-9b0d-11e8-b5b4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cammie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Chitwood",
    "cica_residentialphone": "5167286078",
    "cica_fdif": "8/17/2017",
    "cica_residentialaddress": "1289 Jerusalem Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Chitwood"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Loise",
    "id": "63584bfa-9b0d-11e8-9c60-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Loise",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pai",
    "cica_residentialphone": "5169938146",
    "cica_fdif": "7/13/2017",
    "cica_residentialaddress": "1289 Jerusalem Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pai"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Harmony",
    "id": "635854c5-9b0d-11e8-9040-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Harmony",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Feuerstein",
    "cica_residentialphone": "5166955499",
    "cica_fdif": "11/2/2017",
    "cica_residentialaddress": "1289 Jerusalem Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Feuerstein"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kaleigh",
    "id": "63585d21-9b0d-11e8-aaa8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kaleigh",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sontag",
    "cica_residentialphone": "5163084951",
    "cica_fdif": "7/6/2016",
    "cica_residentialaddress": "1289 Jerusalem Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sontag"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Vincenza",
    "id": "6358656b-9b0d-11e8-80f6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vincenza",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gillan",
    "cica_residentialphone": "5167997644",
    "cica_fdif": "6/1/2016",
    "cica_residentialaddress": "10 Calais Ct",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gillan"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Corey",
    "id": "63586dc5-9b0d-11e8-8f86-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Corey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Doss",
    "cica_residentialphone": "5167997644",
    "cica_fdif": "9/22/2016",
    "cica_residentialaddress": "225 Mott St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Doss"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bobette",
    "id": "63587619-9b0d-11e8-b45e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bobette",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Amar",
    "cica_residentialphone": "5167999437",
    "cica_fdif": "8/19/2016",
    "cica_residentialaddress": "36 Delisle Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Amar"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kennith",
    "id": "63587e57-9b0d-11e8-bad5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kennith",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Olivas",
    "cica_residentialphone": "5164047362",
    "cica_fdif": "4/9/2017",
    "cica_residentialaddress": "298 School St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Olivas"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Caitlyn",
    "id": "635886b0-9b0d-11e8-bbf1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Caitlyn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Duck",
    "cica_residentialphone": "5166801123",
    "cica_fdif": "7/5/2018",
    "cica_residentialaddress": "298 School St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Duck"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Titus",
    "id": "63588ef0-9b0d-11e8-80a5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Titus",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hobdy",
    "cica_residentialphone": "5167986891",
    "cica_fdif": "3/4/2018",
    "cica_residentialaddress": "298 School St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hobdy"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Saran",
    "id": "63589757-9b0d-11e8-abf6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Saran",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bleau",
    "cica_residentialphone": "6317361553",
    "cica_fdif": "6/7/2018",
    "cica_residentialaddress": "298 School St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bleau"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lynetta",
    "id": "63589f9e-9b0d-11e8-88a1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lynetta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Walke",
    "cica_residentialphone": "6316542649",
    "cica_fdif": "9/18/2018",
    "cica_residentialaddress": "298 School St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Walke"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Angelena",
    "id": "6358a7f0-9b0d-11e8-91f3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Angelena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Schoening",
    "cica_residentialphone": "6316542649",
    "cica_fdif": "7/11/2016",
    "cica_residentialaddress": "298 School St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schoening"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Merri",
    "id": "6358b042-9b0d-11e8-8333-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Merri",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Groom",
    "cica_residentialphone": "6317302946",
    "cica_fdif": "9/1/2016",
    "cica_residentialaddress": "298 School St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Groom"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shanae",
    "id": "6358b8a8-9b0d-11e8-84dc-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shanae",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Finnen",
    "cica_residentialphone": "6319056332",
    "cica_fdif": "1/22/2018",
    "cica_residentialaddress": "109 Wellington Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Finnen"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Brendan",
    "id": "6358c0fa-9b0d-11e8-bb43-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Brendan",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mahabir",
    "cica_residentialphone": "6315042173",
    "cica_fdif": "7/5/2016",
    "cica_residentialaddress": "20 Adler Pl",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mahabir"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Earle",
    "id": "6358c94a-9b0d-11e8-b19f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Earle",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Olinger",
    "cica_residentialphone": "6316566808",
    "cica_fdif": "10/19/2018",
    "cica_residentialaddress": "20 Adler Pl",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Olinger"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Matilda",
    "id": "6358d187-9b0d-11e8-a088-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Matilda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Harvard",
    "cica_residentialphone": "9175201106",
    "cica_fdif": "9/16/2017",
    "cica_residentialaddress": "88 E Valley Stream Blvd Apt 4",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Harvard"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sidney",
    "id": "6358d9d1-9b0d-11e8-8dce-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sidney",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Snipes",
    "cica_residentialphone": "6312182982",
    "cica_fdif": "7/17/2017",
    "cica_residentialaddress": "88 E Valley Stream Blvd Apt 4",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Snipes"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Alethia",
    "id": "6358e223-9b0d-11e8-9f1c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Alethia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Fencl",
    "cica_residentialphone": "6316544331",
    "cica_fdif": "6/20/2017",
    "cica_residentialaddress": "17 Haig Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fencl"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "47X",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tracey",
    "id": "6358ea75-9b0d-11e8-9d33-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tracey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent10",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gelb",
    "cica_residentialphone": "6314478715",
    "cica_fdif": "8/7/2017",
    "cica_residentialaddress": "235 Stuart Rd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gelb"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Markus",
    "id": "6358f399-9b0d-11e8-83df-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Markus",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Vasques",
    "cica_residentialphone": "6314478715",
    "cica_fdif": "4/16/2017",
    "cica_residentialaddress": "235 Stuart Rd",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Vasques"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Nilsa",
    "id": "6358fe30-9b0d-11e8-adc7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Nilsa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Grothe",
    "cica_residentialphone": "6312897448",
    "cica_fdif": "3/12/2016",
    "cica_residentialaddress": "85 Horton Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Grothe"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Laurel",
    "id": "635907a3-9b0d-11e8-8c11-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Laurel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gade",
    "cica_residentialphone": "6312890539",
    "cica_fdif": "4/24/2017",
    "cica_residentialaddress": "237 Asbury Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gade"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lola",
    "id": "63590feb-9b0d-11e8-8e1b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lola",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Labelle",
    "cica_residentialphone": "6317583045",
    "cica_fdif": "4/14/2017",
    "cica_residentialaddress": "226 Hopper St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Labelle"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jeffie",
    "id": "63591833-9b0d-11e8-860a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jeffie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mckinstry",
    "cica_residentialphone": "6312890673",
    "cica_fdif": "6/26/2018",
    "cica_residentialaddress": "223 Sylvester St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mckinstry"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Delena",
    "id": "63592091-9b0d-11e8-9314-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Delena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hosch",
    "cica_residentialphone": "6314753862",
    "cica_fdif": "7/24/2018",
    "cica_residentialaddress": "223 Sylvester St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hosch"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Corrine",
    "id": "635928cf-9b0d-11e8-ae39-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Corrine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Eder",
    "cica_residentialphone": "6318726079",
    "cica_fdif": "3/25/2017",
    "cica_residentialaddress": "38 Emerson Ct",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Eder"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jerica",
    "id": "63593117-9b0d-11e8-b377-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jerica",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Piscopo",
    "cica_residentialphone": "6312866816",
    "cica_fdif": "7/12/2017",
    "cica_residentialaddress": "2337 Volante Pl",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Piscopo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Izetta",
    "id": "635939de-9b0d-11e8-b386-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Izetta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Adcock",
    "cica_residentialphone": "6312892751",
    "cica_fdif": "6/16/2018",
    "cica_residentialaddress": "934 Washington Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Adcock"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Clay",
    "id": "63594245-9b0d-11e8-bb8d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Clay",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Yoshimoto",
    "cica_residentialphone": "6312892751",
    "cica_fdif": "3/8/2016",
    "cica_residentialaddress": "934 Washington Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Yoshimoto"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ettie",
    "id": "63594a8c-9b0d-11e8-973a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ettie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Doris",
    "cica_residentialphone": "6314742884",
    "cica_fdif": "4/1/2018",
    "cica_residentialaddress": "181 Campbell Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Doris"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Janiece",
    "id": "635952e8-9b0d-11e8-bf6a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Janiece",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Grizzell",
    "cica_residentialphone": "6318211166",
    "cica_fdif": "8/11/2017",
    "cica_residentialaddress": "626 Foch Blvd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Grizzell"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Miguel",
    "id": "63595b30-9b0d-11e8-93bf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Miguel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Brimage",
    "cica_residentialphone": "6318211166",
    "cica_fdif": "7/2/2016",
    "cica_residentialaddress": "626 Foch Blvd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Brimage"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Linda",
    "id": "63596378-9b0d-11e8-9512-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Linda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Saulnier",
    "cica_residentialphone": "6318211166",
    "cica_fdif": "1/1/2017",
    "cica_residentialaddress": "626 Foch Blvd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Saulnier"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tyisha",
    "id": "63596bcc-9b0d-11e8-bcbd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tyisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Terranova",
    "cica_residentialphone": "6318213119",
    "cica_fdif": "4/19/2017",
    "cica_residentialaddress": "626 Foch Blvd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Terranova"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Renay",
    "id": "63597414-9b0d-11e8-8ecd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Renay",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Deaner",
    "cica_residentialphone": "6314677734",
    "cica_fdif": "3/23/2016",
    "cica_residentialaddress": "1038 Bay 32nd St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Deaner"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Twyla",
    "id": "63597c5c-9b0d-11e8-bc1a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Twyla",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Worsley",
    "cica_residentialphone": "6314677734",
    "cica_fdif": "6/21/2016",
    "cica_residentialaddress": "1024 Bay 32nd St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Worsley"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Amelia",
    "id": "635984ae-9b0d-11e8-bf88-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Amelia",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Murdock",
    "cica_residentialphone": "6317368824",
    "cica_fdif": "2/4/2018",
    "cica_residentialaddress": "1024 Bay 32nd St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Murdock"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Stephany",
    "id": "63598d00-9b0d-11e8-ba8d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Stephany",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hahne",
    "cica_residentialphone": "5162162126",
    "cica_fdif": "2/16/2016",
    "cica_residentialaddress": "2021 Seagirt Blvd # A3E",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hahne"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cordell",
    "id": "63599551-9b0d-11e8-a9b0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cordell",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Court",
    "cica_residentialphone": "6318621130",
    "cica_fdif": "5/25/2018",
    "cica_residentialaddress": "2057 Seagirt Blvd Apt 2D",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Court"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kittie",
    "id": "63599da3-9b0d-11e8-92dd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kittie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lowder",
    "cica_residentialphone": "6318621130",
    "cica_fdif": "5/8/2017",
    "cica_residentialaddress": "540 Beach 136th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lowder"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Luanna",
    "id": "6359a5f5-9b0d-11e8-b539-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Luanna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hoge",
    "cica_residentialphone": "6317481579",
    "cica_fdif": "8/16/2017",
    "cica_residentialaddress": "19 Lindy Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hoge"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Minnie",
    "id": "6359ae28-9b0d-11e8-b659-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Minnie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Saldivar",
    "cica_residentialphone": "6315638428",
    "cica_fdif": "1/15/2016",
    "cica_residentialaddress": "19 Lindy Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Saldivar"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tegan",
    "id": "6359b67a-9b0d-11e8-9105-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tegan",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Wilkin",
    "cica_residentialphone": "6315638428",
    "cica_fdif": "1/28/2018",
    "cica_residentialaddress": "868 County Line Rd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Wilkin"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Corie",
    "id": "6359c0e1-9b0d-11e8-8ef4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Corie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Eells",
    "cica_residentialphone": "6313637425",
    "cica_fdif": "7/24/2018",
    "cica_residentialaddress": "PO Box 606",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Eells"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "HRMZ",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Karey",
    "id": "6359ca7d-9b0d-11e8-9105-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Karey",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC3",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hess",
    "cica_residentialphone": "8133121318",
    "cica_fdif": "1/5/2017",
    "cica_residentialaddress": "PO Box 606",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hess"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Krystal",
    "id": "6359d2cc-9b0d-11e8-b6ed-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Krystal",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ryba",
    "cica_residentialphone": "6316986268",
    "cica_fdif": "11/24/2017",
    "cica_residentialaddress": "130 Wright St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ryba"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Reynaldo",
    "id": "6359db97-9b0d-11e8-9ed9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Reynaldo",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Scola",
    "cica_residentialphone": "6316968122",
    "cica_fdif": "4/12/2016",
    "cica_residentialaddress": "701 Windmill Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Scola"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Jenae",
    "id": "6359e566-9b0d-11e8-9dba-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Jenae",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hock",
    "cica_residentialphone": "6313312206",
    "cica_fdif": "1/15/2016",
    "cica_residentialaddress": "1347 August Rd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hock"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rosaura",
    "id": "6359edae-9b0d-11e8-885d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rosaura",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Copper",
    "cica_residentialphone": "6313312206",
    "cica_fdif": "6/23/2017",
    "cica_residentialaddress": "345 Old Farmingdale Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Copper"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Deonna",
    "id": "6359f600-9b0d-11e8-a9dd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Deonna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Erbe",
    "cica_residentialphone": "6316967958",
    "cica_fdif": "8/11/2016",
    "cica_residentialaddress": "345 Old Farmingdale Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Erbe"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Garth",
    "id": "6359fe51-9b0d-11e8-8a4f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Garth",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Relyea",
    "cica_residentialphone": "6313771485",
    "cica_fdif": "5/22/2017",
    "cica_residentialaddress": "717 Frankford Rd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Relyea"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Laree",
    "id": "635a074c-9b0d-11e8-a3f8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Laree",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Casson",
    "cica_residentialphone": "5168106345",
    "cica_fdif": "4/25/2017",
    "cica_residentialaddress": "45 Auburn St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Casson"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Aida",
    "id": "635a1017-9b0d-11e8-a593-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Aida",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gillam",
    "cica_residentialphone": "6319810323",
    "cica_fdif": "8/10/2017",
    "cica_residentialaddress": "71 Meadow Ln",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gillam"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bethann",
    "id": "635a18cc-9b0d-11e8-b5f5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bethann",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Glatt",
    "cica_residentialphone": "6317759037",
    "cica_fdif": "10/21/2018",
    "cica_residentialaddress": "71 Meadow Ln",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Glatt"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elaina",
    "id": "635a2185-9b0d-11e8-a09e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elaina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Manthe",
    "cica_residentialphone": "6318212867",
    "cica_fdif": "2/11/2017",
    "cica_residentialaddress": "1139 5th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Manthe"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Birdie",
    "id": "635a2a94-9b0d-11e8-9d39-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Birdie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Nowacki",
    "cica_residentialphone": "6315845473",
    "cica_fdif": "10/18/2018",
    "cica_residentialaddress": "1139 5th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Nowacki"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rolando",
    "id": "635a32dc-9b0d-11e8-801e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rolando",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hieb",
    "cica_residentialphone": "6315913235",
    "cica_fdif": "11/17/2018",
    "cica_residentialaddress": "1148 Nugent Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hieb"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joetta",
    "id": "635a3b2e-9b0d-11e8-878a-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joetta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Clayborne",
    "cica_residentialphone": "6318861158",
    "cica_fdif": "9/8/2017",
    "cica_residentialaddress": "1148 Nugent Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Clayborne"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Annette",
    "id": "635a4380-9b0d-11e8-9b63-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Annette",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dudgeon",
    "cica_residentialphone": "6315228557",
    "cica_fdif": "8/13/2016",
    "cica_residentialaddress": "122 Queen St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dudgeon"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marketta",
    "id": "635a4bc7-9b0d-11e8-b4bd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marketta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Winland",
    "cica_residentialphone": "6319205378",
    "cica_fdif": "4/15/2016",
    "cica_residentialaddress": "122 Queen St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Winland"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tamela",
    "id": "635a5419-9b0d-11e8-b1af-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tamela",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Billingsley",
    "cica_residentialphone": "5168224827",
    "cica_fdif": "10/2/2016",
    "cica_residentialaddress": "1007 Merriam Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Billingsley"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Virgil",
    "id": "635a5c61-9b0d-11e8-8e29-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Virgil",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gaeth",
    "cica_residentialphone": "5169351480",
    "cica_fdif": "5/3/2017",
    "cica_residentialaddress": "1007 Merriam Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gaeth"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Luann",
    "id": "635a64ab-9b0d-11e8-beef-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Luann",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mead",
    "cica_residentialphone": "5164331462",
    "cica_fdif": "11/19/2017",
    "cica_residentialaddress": "1640 E 3rd Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mead"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Della",
    "id": "635a6cf3-9b0d-11e8-9abc-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Della",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ned",
    "cica_residentialphone": "6314357848",
    "cica_fdif": "6/6/2017",
    "cica_residentialaddress": "141 Cocoanut St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ned"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Missy",
    "id": "635a753a-9b0d-11e8-bb87-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Missy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bacchus",
    "cica_residentialphone": "6317275266",
    "cica_fdif": "7/23/2017",
    "cica_residentialaddress": "934 Gardiner Dr",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bacchus"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Manie",
    "id": "635a7d78-9b0d-11e8-92ed-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Manie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Estell",
    "cica_residentialphone": "6316965240",
    "cica_fdif": "8/21/2017",
    "cica_residentialaddress": "1120 Nugent Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Estell"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ellie",
    "id": "635a85d4-9b0d-11e8-afc1-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ellie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rouleau",
    "cica_residentialphone": "6314771197",
    "cica_fdif": "2/24/2016",
    "cica_residentialaddress": "1120 Nugent Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rouleau"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Alaine",
    "id": "635a9591-9b0d-11e8-b30c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Alaine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Stirling",
    "cica_residentialphone": "6314771197",
    "cica_fdif": "6/10/2016",
    "cica_residentialaddress": "1120 Nugent Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stirling"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Otha",
    "id": "635aa545-9b0d-11e8-b5f0-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Otha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bussard",
    "cica_residentialphone": "6314771197",
    "cica_fdif": "4/6/2017",
    "cica_residentialaddress": "784 Orinoco Dr",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bussard"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lenora",
    "id": "635ab180-9b0d-11e8-9e63-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lenora",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Schiller",
    "cica_residentialphone": "6314771197",
    "cica_fdif": "7/19/2018",
    "cica_residentialaddress": "784 Orinoco Dr",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Schiller"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Harold",
    "id": "635abc66-9b0d-11e8-a8bd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Harold",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tuch",
    "cica_residentialphone": "6214771197",
    "cica_fdif": "8/15/2017",
    "cica_residentialaddress": "15 Penataquit Ave Apt 2C",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tuch"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marianela",
    "id": "635ac7a6-9b0d-11e8-a532-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marianela",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cassette",
    "cica_residentialphone": "6314771197",
    "cica_fdif": "1/17/2018",
    "cica_residentialaddress": "2441 New Pl",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cassette"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lashandra",
    "id": "635ad051-9b0d-11e8-8a11-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lashandra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rodriques",
    "cica_residentialphone": "6313699563",
    "cica_fdif": "7/12/2017",
    "cica_residentialaddress": "2036 Whalen Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rodriques"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Miranda",
    "id": "635adaca-9b0d-11e8-b793-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Miranda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Topham",
    "cica_residentialphone": "6318781679",
    "cica_fdif": "4/7/2016",
    "cica_residentialaddress": "407 Central Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Topham"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kam",
    "id": "635ae39e-9b0d-11e8-a0bf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kam",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Piasecki",
    "cica_residentialphone": "6316558611",
    "cica_fdif": "8/14/2018",
    "cica_residentialaddress": "407 Central Ave Apt A",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Piasecki"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Margorie",
    "id": "635aed6b-9b0d-11e8-8c53-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Margorie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Colangelo",
    "cica_residentialphone": "6315765699",
    "cica_fdif": "1/23/2016",
    "cica_residentialaddress": "6 Farmedge Rd",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Colangelo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "XVW5",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Chanel",
    "id": "635af5ca-9b0d-11e8-a243-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Chanel",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent6",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcnish",
    "cica_residentialphone": "6313293310",
    "cica_fdif": "11/23/2017",
    "cica_residentialaddress": "6 Farmedge Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcnish"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Brandon",
    "id": "635afe23-9b0d-11e8-9b7d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Brandon",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcelroy",
    "cica_residentialphone": "6313290983",
    "cica_fdif": "3/8/2017",
    "cica_residentialaddress": "370 Stewart Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcelroy"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Natividad",
    "id": "635b0694-9b0d-11e8-9a14-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Natividad",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Blackwell",
    "cica_residentialphone": "6314338972",
    "cica_fdif": "11/17/2016",
    "cica_residentialaddress": "1374 Hummel Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Blackwell"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bobby",
    "id": "635b0efa-9b0d-11e8-9e6e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bobby",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ardis",
    "cica_residentialphone": "6316536312",
    "cica_fdif": "2/5/2017",
    "cica_residentialaddress": "74 W 9th St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ardis"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Deb",
    "id": "635b1761-9b0d-11e8-a171-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Deb",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Stroh",
    "cica_residentialphone": "6316536312",
    "cica_fdif": "9/28/2018",
    "cica_residentialaddress": "37 Wilson St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stroh"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Anja",
    "id": "635b1fba-9b0d-11e8-bdf9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Anja",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Costanza",
    "cica_residentialphone": "6316534778",
    "cica_fdif": "11/21/2018",
    "cica_residentialaddress": "37 Wilson St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Costanza"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rita",
    "id": "635b282b-9b0d-11e8-8b1b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rita",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sunseri",
    "cica_residentialphone": "6314772843",
    "cica_fdif": "11/28/2018",
    "cica_residentialaddress": "132 Floyd St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sunseri"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Danuta",
    "id": "635b3073-9b0d-11e8-a388-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Danuta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dahl",
    "cica_residentialphone": "6315942036",
    "cica_fdif": "2/1/2017",
    "cica_residentialaddress": "132 Floyd St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dahl"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rikki",
    "id": "635b38cf-9b0d-11e8-9e35-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rikki",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ahl",
    "cica_residentialphone": "6315942036",
    "cica_fdif": "10/15/2016",
    "cica_residentialaddress": "132 Floyd St",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ahl"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Terese",
    "id": "635b412e-9b0d-11e8-bfc9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Terese",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Delmont",
    "cica_residentialphone": "6317282589",
    "cica_fdif": "4/23/2016",
    "cica_residentialaddress": "132 Floyd St",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Delmont"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Geraldine",
    "id": "635b497d-9b0d-11e8-bfd9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Geraldine",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Igo",
    "cica_residentialphone": "6317282589",
    "cica_fdif": "5/23/2017",
    "cica_residentialaddress": "132 Floyd St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Igo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Wilbert",
    "id": "635b51cf-9b0d-11e8-8d02-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Wilbert",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tumlinson",
    "cica_residentialphone": "5318312442",
    "cica_fdif": "5/10/2017",
    "cica_residentialaddress": "132 Floyd St",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tumlinson"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Caterina",
    "id": "635b5a19-9b0d-11e8-8d48-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Caterina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mallet",
    "cica_residentialphone": "6313693827",
    "cica_fdif": "7/17/2016",
    "cica_residentialaddress": "124 Louisiana Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mallet"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marissa",
    "id": "635b6287-9b0d-11e8-8a78-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marissa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Morningstar",
    "cica_residentialphone": "6317727866",
    "cica_fdif": "10/18/2017",
    "cica_residentialaddress": "124 Louisiana Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Morningstar"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elbert",
    "id": "635b700c-9b0d-11e8-8747-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elbert",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mclees",
    "cica_residentialphone": "6312811731",
    "cica_fdif": "9/9/2016",
    "cica_residentialaddress": "124 Louisiana Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mclees"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Mari",
    "id": "635b78eb-9b0d-11e8-8420-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Mari",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Sidoti",
    "cica_residentialphone": "6312811731",
    "cica_fdif": "10/4/2018",
    "cica_residentialaddress": "147 Stumpel St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Sidoti"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Barrett",
    "id": "635b8433-9b0d-11e8-bb90-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Barrett",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mcquillan",
    "cica_residentialphone": "3478695877",
    "cica_fdif": "2/12/2017",
    "cica_residentialaddress": "2747 Montauk Hwy",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mcquillan"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rashida",
    "id": "635b8e1e-9b0d-11e8-bfdd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rashida",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bachmann",
    "cica_residentialphone": "6317655698",
    "cica_fdif": "8/16/2017",
    "cica_residentialaddress": "194 Wood Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bachmann"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Yulanda",
    "id": "635b9685-9b0d-11e8-9d17-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Yulanda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Leatherwood",
    "cica_residentialphone": "6317284062",
    "cica_fdif": "9/17/2018",
    "cica_residentialaddress": "194 Wood Rd",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Leatherwood"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Isaura",
    "id": "635b9ee3-9b0d-11e8-958e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Isaura",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Furlong",
    "cica_residentialphone": "6317284062",
    "cica_fdif": "3/21/2018",
    "cica_residentialaddress": "20 Woodland Blvd",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Furlong"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Everett",
    "id": "635ba747-9b0d-11e8-a620-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Everett",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lacayo",
    "cica_residentialphone": "6318215735",
    "cica_fdif": "8/12/2017",
    "cica_residentialaddress": "90 Blydenburgh Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lacayo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Vernie",
    "id": "635bafa3-9b0d-11e8-98ee-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Vernie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Orvis",
    "cica_residentialphone": "6319962829",
    "cica_fdif": "2/21/2016",
    "cica_residentialaddress": "103 Calebs Path",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Orvis"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "MWV5",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lue",
    "id": "635bb814-9b0d-11e8-bb05-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lue",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC3",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent11",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kaplan",
    "cica_residentialphone": "6313995991",
    "cica_fdif": "8/7/2017",
    "cica_residentialaddress": "99 Vanderbilt Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kaplan"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Cassidy",
    "id": "635bc119-9b0d-11e8-92f3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Cassidy",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Perkin",
    "cica_residentialphone": "6312837806",
    "cica_fdif": "5/5/2018",
    "cica_residentialaddress": "99 Vanderbilt Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Perkin"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Emery",
    "id": "635bc99c-9b0d-11e8-8912-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Emery",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bisbee",
    "cica_residentialphone": "6312837806",
    "cica_fdif": "1/6/2016",
    "cica_residentialaddress": "101 Mattituck Ct",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bisbee"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rolando",
    "id": "635bd287-9b0d-11e8-99bd-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rolando",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ybarbo",
    "cica_residentialphone": "6312837806",
    "cica_fdif": "7/10/2017",
    "cica_residentialaddress": "101 Mattituck Ct",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ybarbo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Margo",
    "id": "635bdaf8-9b0d-11e8-9434-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Margo",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hering",
    "cica_residentialphone": "6312837806",
    "cica_fdif": "6/3/2018",
    "cica_residentialaddress": "20 Hayrick Ln",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hering"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ricki",
    "id": "635be351-9b0d-11e8-b916-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ricki",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Plummer",
    "cica_residentialphone": "6312832414",
    "cica_fdif": "10/8/2017",
    "cica_residentialaddress": "21 Terry Ln",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Plummer"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Hector",
    "id": "635bec45-9b0d-11e8-aafb-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Hector",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mauck",
    "cica_residentialphone": "6312832139",
    "cica_fdif": "6/11/2017",
    "cica_residentialaddress": "21 Terry Ln",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mauck"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Sherise",
    "id": "635bf523-9b0d-11e8-9dff-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Sherise",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Farr",
    "cica_residentialphone": "6312832139",
    "cica_fdif": "8/2/2018",
    "cica_residentialaddress": "138 Galvani St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Farr"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Terrence",
    "id": "635bfd91-9b0d-11e8-86bf-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Terrence",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Lozada",
    "cica_residentialphone": "6315748204",
    "cica_fdif": "11/12/2018",
    "cica_residentialaddress": "610 Hollywood Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Lozada"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Scarlet",
    "id": "635c0670-9b0d-11e8-9732-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Scarlet",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Tineo",
    "cica_residentialphone": "6312783496",
    "cica_fdif": "11/4/2017",
    "cica_residentialaddress": "10 Wagstaff Ln",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Tineo"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ela",
    "id": "635c0f61-9b0d-11e8-925d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ela",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Joaquin",
    "cica_residentialphone": "6317658459",
    "cica_fdif": "11/28/2016",
    "cica_residentialaddress": "15 Potomac Ct",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Joaquin"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dania",
    "id": "635c1899-9b0d-11e8-b3c4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dania",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Been",
    "cica_residentialphone": "6317658459",
    "cica_fdif": "1/2/2016",
    "cica_residentialaddress": "15 Potomac Ct",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Been"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lorene",
    "id": "635c2100-9b0d-11e8-8c4f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lorene",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Das",
    "cica_residentialphone": "6312943713",
    "cica_fdif": "7/15/2018",
    "cica_residentialaddress": "15 Potomac Ct",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Das"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Zelda",
    "id": "635c29e6-9b0d-11e8-a545-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Zelda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Reineke",
    "cica_residentialphone": "6312813835",
    "cica_fdif": "7/28/2017",
    "cica_residentialaddress": "2905 Townehouse Dr",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Reineke"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Zetta",
    "id": "635c32cf-9b0d-11e8-9cc5-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Zetta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Troupe",
    "cica_residentialphone": "6319983181",
    "cica_fdif": "7/4/2018",
    "cica_residentialaddress": "1022 Avalon Pines Dr",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Troupe"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Oscar",
    "id": "635c3bb8-9b0d-11e8-813e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Oscar",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Poythress",
    "cica_residentialphone": "7184681314",
    "cica_fdif": "8/3/2016",
    "cica_residentialaddress": "19 Priscilla Ave",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Poythress"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Yan",
    "id": "635c4428-9b0d-11e8-80b8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Yan",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Treat",
    "cica_residentialphone": "9146632466",
    "cica_fdif": "5/28/2018",
    "cica_residentialaddress": "17 Fairlawn Dr",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Treat"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ciera",
    "id": "635c4cf0-9b0d-11e8-8659-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ciera",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bullard",
    "cica_residentialphone": "9146180784",
    "cica_fdif": "10/10/2017",
    "cica_residentialaddress": "14 Cordell Pl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bullard"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rory",
    "id": "635c55ee-9b0d-11e8-b408-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rory",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dewolf",
    "cica_residentialphone": "9149231739",
    "cica_fdif": "8/9/2017",
    "cica_residentialaddress": "3 Rocco Dr",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dewolf"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marlys",
    "id": "635c5ee1-9b0d-11e8-8f3d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marlys",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ebeling",
    "cica_residentialphone": "9147392377",
    "cica_fdif": "5/7/2018",
    "cica_residentialaddress": "3 Rocco Dr",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ebeling"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Dionne",
    "id": "635c6b57-9b0d-11e8-bbc2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Dionne",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Yarnall",
    "cica_residentialphone": "9147392377",
    "cica_fdif": "8/9/2017",
    "cica_residentialaddress": "3 Rocco Dr",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Yarnall"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "4N8",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ben",
    "id": "635c74ab-9b0d-11e8-9519-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ben",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "DM4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Fisher",
    "cica_residentialphone": "9147363799",
    "cica_fdif": "10/11/2017",
    "cica_residentialaddress": "3 Rocco Dr",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Fisher"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lorinda",
    "id": "635c7d91-9b0d-11e8-977c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lorinda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Toohey",
    "cica_residentialphone": "9147367399",
    "cica_fdif": "3/3/2018",
    "cica_residentialaddress": "1224 Prospect Ave Apt 6H",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Toohey"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Darwin",
    "id": "635c867d-9b0d-11e8-b67c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Darwin",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gangemi",
    "cica_residentialphone": "9149330232",
    "cica_fdif": "10/18/2017",
    "cica_residentialaddress": "1172 E Tremont Ave Apt 4D",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gangemi"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Corrina",
    "id": "635c8ef5-9b0d-11e8-b501-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Corrina",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Heckart",
    "cica_residentialphone": "9149330232",
    "cica_fdif": "11/8/2017",
    "cica_residentialaddress": "145 Lexington Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Heckart"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Xochitl",
    "id": "635c97ca-9b0d-11e8-8ab3-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Xochitl",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mitton",
    "cica_residentialphone": "9143370687",
    "cica_fdif": "10/5/2016",
    "cica_residentialaddress": "145 Lexington Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mitton"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Agnes",
    "id": "635ca0ba-9b0d-11e8-b80c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Agnes",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Guntrum",
    "cica_residentialphone": "2032236542",
    "cica_fdif": "8/18/2017",
    "cica_residentialaddress": "1945 Vyse Ave Apt 6E",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Guntrum"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Joelle",
    "id": "635ca9ae-9b0d-11e8-a0e2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Joelle",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ridinger",
    "cica_residentialphone": "9147695212",
    "cica_fdif": "4/24/2016",
    "cica_residentialaddress": "854 Fairmount Pl",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ridinger"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Maggie",
    "id": "635cb21e-9b0d-11e8-9a53-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Maggie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kirsh",
    "cica_residentialphone": "9147695212",
    "cica_fdif": "11/22/2016",
    "cica_residentialaddress": "2340 Broadway Apt 2B",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kirsh"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Imelda",
    "id": "635cbaf3-9b0d-11e8-a98c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Imelda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Corney",
    "cica_residentialphone": "9142996478",
    "cica_fdif": "9/19/2018",
    "cica_residentialaddress": "1936 E Tremont Ave Apt 1B",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Corney"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rogelio",
    "id": "635cc3cf-9b0d-11e8-bb00-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rogelio",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Blumberg",
    "cica_residentialphone": "9146312779",
    "cica_fdif": "1/22/2017",
    "cica_residentialaddress": "78 Springville Rd",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Blumberg"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kareen",
    "id": "635cccb8-9b0d-11e8-9af7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kareen",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Goodin",
    "cica_residentialphone": "9146312779",
    "cica_fdif": "6/19/2018",
    "cica_residentialaddress": "78 Springville Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Goodin"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Madeline",
    "id": "635cd528-9b0d-11e8-a476-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Madeline",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Bible",
    "cica_residentialphone": "9146495455",
    "cica_fdif": "4/25/2016",
    "cica_residentialaddress": "299 Monroe Dr",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Bible"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Evelynn",
    "id": "635cddf3-9b0d-11e8-a538-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Evelynn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Legaspi",
    "cica_residentialphone": "9142455878",
    "cica_fdif": "1/26/2016",
    "cica_residentialaddress": "299 Monroe Dr",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Legaspi"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Talitha",
    "id": "635ce6cf-9b0d-11e8-997d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Talitha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Donlan",
    "cica_residentialphone": "9142455878",
    "cica_fdif": "6/18/2016",
    "cica_residentialaddress": "54 Newtown Rd",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Donlan"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kenyetta",
    "id": "635cefb8-9b0d-11e8-8e9f-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kenyetta",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60114",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Rivenburg",
    "cica_residentialphone": "9144240601",
    "cica_fdif": "6/6/2016",
    "cica_residentialaddress": "355 Randall Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Rivenburg"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Elda",
    "id": "635cf828-9b0d-11e8-b8ca-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Elda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60115",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dear",
    "cica_residentialphone": "9149484286",
    "cica_fdif": "10/12/2018",
    "cica_residentialaddress": "131 W End Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dear"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Brandon",
    "id": "635d0297-9b0d-11e8-98c6-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Brandon",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60116",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Carlucci",
    "cica_residentialphone": "9149484286",
    "cica_fdif": "1/20/2018",
    "cica_residentialaddress": "28 Middle Line Hwy",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Carlucci"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Shala",
    "id": "635d0c28-9b0d-11e8-9d7d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Shala",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60117",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dingus",
    "cica_residentialphone": "9149484286",
    "cica_fdif": "11/3/2017",
    "cica_residentialaddress": "534 N Magee St",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dingus"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Edie",
    "id": "635d1591-9b0d-11e8-9bff-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Edie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60118",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hartranft",
    "cica_residentialphone": "9143644451",
    "cica_fdif": "10/12/2016",
    "cica_residentialaddress": "534 N Magee St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hartranft"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Angelyn",
    "id": "635d20f0-9b0d-11e8-8328-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Angelyn",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60119",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Coulston",
    "cica_residentialphone": "9143281866",
    "cica_fdif": "3/7/2018",
    "cica_residentialaddress": "24 Fairway Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Coulston"
  },
  {
    "cica_market": "2",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "AWOP",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Garth",
    "id": "635d2b02-9b0d-11e8-9db9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Garth",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "DM4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60120",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent7",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Ferranti",
    "cica_residentialphone": "9145928142",
    "cica_fdif": "2/8/2017",
    "cica_residentialaddress": "PO Box 1941",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Ferranti"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Lashawna",
    "id": "635d3607-9b0d-11e8-9d63-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Lashawna",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60121",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Farrell",
    "cica_residentialphone": "9144286546",
    "cica_fdif": "5/4/2018",
    "cica_residentialaddress": "PO Box 1941",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Farrell"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gregg",
    "id": "635d4163-9b0d-11e8-a7b9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gregg",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60122",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Kulick",
    "cica_residentialphone": "9144286546",
    "cica_fdif": "11/15/2017",
    "cica_residentialaddress": "32 Coxs Curve Rd",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Kulick"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Laquanda",
    "id": "635d4aee-9b0d-11e8-bcd2-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Laquanda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60123",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pillow",
    "cica_residentialphone": "9144287512",
    "cica_fdif": "8/21/2018",
    "cica_residentialaddress": "10802 220th St",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pillow"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Spring",
    "id": "635d5668-9b0d-11e8-a16c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Spring",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60084",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Stair",
    "cica_residentialphone": "9144287512",
    "cica_fdif": "5/27/2017",
    "cica_residentialaddress": "33 Narragansett Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stair"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Taisha",
    "id": "635d6217-9b0d-11e8-a902-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Taisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60085",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Gong",
    "cica_residentialphone": "9143285713",
    "cica_fdif": "4/24/2017",
    "cica_residentialaddress": "123 State St Fl 2",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Gong"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Leandro",
    "id": "635d6cf3-9b0d-11e8-812c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Leandro",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60086",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cahn",
    "cica_residentialphone": "9143285713",
    "cica_fdif": "11/27/2017",
    "cica_residentialaddress": "3735 Old Crompond Rd",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cahn"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Marielle",
    "id": "635d765e-9b0d-11e8-baf8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Marielle",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60087",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Cravens",
    "cica_residentialphone": "6466375883",
    "cica_fdif": "10/11/2018",
    "cica_residentialaddress": "85 S Regent St",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Cravens"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Margorie",
    "id": "635d7f45-9b0d-11e8-bd84-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Margorie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60088",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hoffmeister",
    "cica_residentialphone": "9149688131",
    "cica_fdif": "3/24/2016",
    "cica_residentialaddress": "85 S Regent St",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hoffmeister"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Edmundo",
    "id": "635d8838-9b0d-11e8-a235-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Edmundo",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60089",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Mattocks",
    "cica_residentialphone": "9149688131",
    "cica_fdif": "6/1/2016",
    "cica_residentialaddress": "342 Marietta Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Mattocks"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Gwyneth",
    "id": "635d90ba-9b0d-11e8-a972-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Gwyneth",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60090",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dougal",
    "cica_residentialphone": "9143611027",
    "cica_fdif": "9/14/2017",
    "cica_residentialaddress": "342 Marietta Ave",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dougal"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Asa",
    "id": "635d99e1-9b0d-11e8-bf3e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Asa",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60091",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Faucett",
    "cica_residentialphone": "9144762347",
    "cica_fdif": "4/4/2017",
    "cica_residentialaddress": "2183 Mohansic Ave",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Faucett"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Emery",
    "id": "635da35e-9b0d-11e8-a19c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Emery",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "11 Days",
    "cica_residentialaddresszip": "60092",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Turlington",
    "cica_residentialphone": "9144762347",
    "cica_fdif": "5/5/2017",
    "cica_residentialaddress": "2183 Mohansic Ave",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Turlington"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ellena",
    "id": "635dac63-9b0d-11e8-9ca8-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ellena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60093",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Emert",
    "cica_residentialphone": "9142585517",
    "cica_fdif": "5/19/2016",
    "cica_residentialaddress": "30 Fieldstone Dr Apt 26A",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Emert"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Wheaton",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Kandra",
    "id": "635db4d4-9b0d-11e8-853e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Kandra",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60094",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "03/09/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Darden",
    "cica_residentialphone": "9142581019",
    "cica_fdif": "4/5/2017",
    "cica_residentialaddress": "30 Fieldstone Dr Apt 26A",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Darden"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Glenview",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Moira",
    "id": "635dbdc5-9b0d-11e8-b5e7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "35",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Moira",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60095",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/12/82",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Well",
    "cica_residentialphone": "9149640121",
    "cica_fdif": "4/2/2018",
    "cica_residentialaddress": "9 Winnetou Rd",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Well"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rona",
    "id": "635dc6a3-9b0d-11e8-91d9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "43",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rona",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60096",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "02/10/74",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Heier",
    "cica_residentialphone": "9149640121",
    "cica_fdif": "6/15/2016",
    "cica_residentialaddress": "19 Manitou Trl",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Heier"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Morton Grove",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Conrad",
    "id": "635dcf97-9b0d-11e8-a42e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Conrad",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60097",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$27,000-$35,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dubois",
    "cica_residentialphone": "9149640121",
    "cica_fdif": "9/22/2016",
    "cica_residentialaddress": "19 Manitou Trl",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dubois"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Chester",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Milda",
    "id": "635dd7fa-9b0d-11e8-b9b7-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "46",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Milda",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "12 Days",
    "cica_residentialaddresszip": "60098",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "11/10/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Hammaker",
    "cica_residentialphone": "9142070423",
    "cica_fdif": "5/19/2016",
    "cica_residentialaddress": "7 Gedney Ter",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Hammaker"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Chesterfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bonnie",
    "id": "635de0dc-9b0d-11e8-a306-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "54",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bonnie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "ASP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60099",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/11/63",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Loney",
    "cica_residentialphone": "9142070423",
    "cica_fdif": "7/24/2016",
    "cica_residentialaddress": "7 Gedney Ter",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Loney"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "East City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Noemi",
    "id": "635de94a-9b0d-11e8-8fdc-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "45",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Noemi",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "3 Days",
    "cica_residentialaddresszip": "60100",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/09/72",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Southard",
    "cica_residentialphone": "2036214573",
    "cica_fdif": "6/21/2016",
    "cica_residentialaddress": "21 Tomahawk Dr",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Southard"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Northbrook",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tennille",
    "id": "635df1a6-9b0d-11e8-8fa4-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "47",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tennille",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60101",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/10/70",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Stahr",
    "cica_residentialphone": "9144862741",
    "cica_fdif": "2/24/2018",
    "cica_residentialaddress": "21 Tomahawk Dr",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Stahr"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "North City",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Bert",
    "id": "635df9f8-9b0d-11e8-8990-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "48",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Bert",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60102",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/12/69",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Guth",
    "cica_residentialphone": "9144575697",
    "cica_fdif": "7/24/2018",
    "cica_residentialaddress": "31 Centre St",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Guth"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "29th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Aroundes",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Queen",
    "id": "635e025c-9b0d-11e8-bd6e-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Queen",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "CAN ",
    "cica_writingagentmiddlename": "NA",
    "expires": "7 Days",
    "cica_residentialaddresszip": "60103",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Barrientos",
    "cica_residentialphone": "9144761792",
    "cica_fdif": "2/7/2016",
    "cica_residentialaddress": "132 Page Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Barrientos"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "25th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Golf",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "King",
    "id": "635e0aa3-9b0d-11e8-83d9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "32",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "King",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "GAP",
    "cica_writingagentmiddlename": "NA",
    "expires": "9 Days",
    "cica_residentialaddresszip": "60104",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "30/06/85",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "18.01",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Press",
    "cica_residentialphone": "9144575697",
    "cica_fdif": "10/23/2018",
    "cica_residentialaddress": "132 Page Ave",
    "cica_apv": "216.12",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Press"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "5th",
    "cica_writingagentcode": "JYEU",
    "cica_residentialaddresscity": "Weekio",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Florida",
    "id": "635e1302-9b0d-11e8-bc43-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "22",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Florida",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "MD4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "5 Days",
    "cica_residentialaddresszip": "60105",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "SC4",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/95",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "15.12",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Dever",
    "cica_residentialphone": "9147511579",
    "cica_fdif": "5/16/2018",
    "cica_residentialaddress": "132 Page Ave",
    "cica_apv": "181.44",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Dever"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "14th",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "Kankakee",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Tamisha",
    "id": "635e1b70-9b0d-11e8-ad61-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "25",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Tamisha",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "SPJ",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60106",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/08/92",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "27.13",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Aguilera",
    "cica_residentialphone": "9149693895",
    "cica_fdif": "6/14/2016",
    "cica_residentialaddress": "40 Huber Pl",
    "cica_apv": "325.56",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Aguilera"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "15th",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "Easy Loft",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Victoria",
    "id": "635e23b8-9b0d-11e8-a75d-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "27",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Victoria",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "IP",
    "cica_writingagentmiddlename": "NA",
    "expires": "6 Days",
    "cica_residentialaddresszip": "60107",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "29/06/90",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "65.16",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$18,000-$26,000",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pillai",
    "cica_residentialphone": "9293127266",
    "cica_fdif": "4/15/2017",
    "cica_residentialaddress": "40 Huber Pl",
    "cica_apv": "781.92",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pillai"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "19th",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "Springfield",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Rowena",
    "id": "635e2c00-9b0d-11e8-8380-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "53",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Rowena",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "SPP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60108",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "12/07/64",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "12.99",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "$15,000-$17,999",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Pompei",
    "cica_residentialphone": "9146237374",
    "cica_fdif": "11/3/2017",
    "cica_residentialaddress": "40 Huber Pl",
    "cica_apv": "155.88",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Pompei"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "21st",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "Easterville",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Ressie",
    "id": "635e344a-9b0d-11e8-b44c-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "52",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Ressie",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "Over 75,000",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "10 Days",
    "cica_residentialaddresszip": "60109",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "22/10/65",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "13.45",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Swinford",
    "cica_residentialphone": "9147793701",
    "cica_fdif": "7/5/2018",
    "cica_residentialaddress": "527 Riverdale Ave",
    "cica_apv": "161.4",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Swinford"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "1st",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "Souttown",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Pandora",
    "id": "635e3c91-9b0d-11e8-b5d9-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "61",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Pandora",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60110",
    "cica_languagepreference": "English",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "04/09/57",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Garret",
    "cica_residentialphone": "9147793701",
    "cica_fdif": "6/8/2018",
    "cica_residentialaddress": "16 Terrace Pl",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Garret"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "3rd",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "East Lake",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Brande",
    "id": "635e44d9-9b0d-11e8-8e29-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "34",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Brande",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "18,000-29,999",
    "cica_occupation": "NA",
    "product": "AP",
    "cica_writingagentmiddlename": "NA",
    "expires": "4 Days",
    "cica_residentialaddresszip": "60111",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/83",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Grahn",
    "cica_residentialphone": "9147793701",
    "cica_fdif": "5/16/2016",
    "cica_residentialaddress": "16 Terrace Pl",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Grahn"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "7th",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "Chicago",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Holley",
    "id": "635e4d21-9b0d-11e8-b299-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "28",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Holley",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "30,000-49,999",
    "cica_occupation": "NA",
    "product": "FLP",
    "cica_writingagentmiddlename": "NA",
    "expires": "8 Days",
    "cica_residentialaddresszip": "60112",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "28/12/89",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "11.84",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Risko",
    "cica_residentialphone": "3475918842",
    "cica_fdif": "10/9/2016",
    "cica_residentialaddress": "16 Terrace Pl",
    "cica_apv": "142.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Risko"
  },
  {
    "cica_market": "4",
    "cica_customermiddlename": "NA",
    "cica_premiumbillingdate": "17th",
    "cica_writingagentcode": "BBJG",
    "cica_residentialaddresscity": "Lisle",
    "cica_businessname": "NA",
    "cica_primarycontactfirstname": "Molly",
    "id": "635e5557-9b0d-11e8-957b-34363bd2a970",
    "cica_primarycontactmiddlename": "NA",
    "cica_residentialaddressstate": "IL",
    "cica_businessphone": "NA",
    "cica_calltype": "Residence",
    "cica_businessaddress": "NA",
    "cica_age": "31",
    "cica_recurringpaymenttype": "Checking",
    "cica_customerfirstname": "Molly",
    "cica_businesscity": "NA",
    "cica_writingagentsmanagerfirstname": "SC4",
    "cica_writingagentsmanagermiddlename": "NA",
    "cica_grossannualhouseholdincome": "50,000-74,999",
    "cica_occupation": "NA",
    "product": "OPM",
    "cica_writingagentmiddlename": "NA",
    "expires": "2 Days",
    "cica_residentialaddresszip": "60113",
    "cica_languagepreference": "Spanish",
    "cica_division": "61",
    "cica_writingagentfirstname": "Agent12",
    "cica_initialpaymenttype": "Checking",
    "cica_insuredsdob": "24/08/86",
    "cica_premiummode": "Monthly",
    "cica_alternatephone": "NA",
    "cica_writingagentsmanagerlastname": "DEV1",
    "cica_monthlypremiuim": "22.34",
    "cica_appdate": "18/07/18",
    "cica_businessaddressstate": "NA",
    "cica_grossannualindividualincome": "NA",
    "cica_businessaddresszip": "NA",
    "cica_primarycontactlastname": "Corry",
    "cica_residentialphone": "9148130662",
    "cica_fdif": "8/28/2017",
    "cica_residentialaddress": "30 Westwood Ave",
    "cica_apv": "268.08",
    "cica_writingagentlastname": "DEV1",
    "cica_customerlastname": "Corry"
  }
];

export default insDataStub;



// WEBPACK FOOTER //
// ./src/lib/inspectionsData.js